(function (factory) {
  typeof define === 'function' && define.amd ? define('index', factory) :
  factory();
}((function () { 'use strict';

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }

  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }

  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };

    return _setPrototypeOf(o, p);
  }

  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  function _construct(Parent, args, Class) {
    if (_isNativeReflectConstruct()) {
      _construct = Reflect.construct;
    } else {
      _construct = function _construct(Parent, args, Class) {
        var a = [null];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) _setPrototypeOf(instance, Class.prototype);
        return instance;
      };
    }

    return _construct.apply(null, arguments);
  }

  function _isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
  }

  function _wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;

    _wrapNativeSuper = function _wrapNativeSuper(Class) {
      if (Class === null || !_isNativeFunction(Class)) return Class;

      if (typeof Class !== "function") {
        throw new TypeError("Super expression must either be null or a function");
      }

      if (typeof _cache !== "undefined") {
        if (_cache.has(Class)) return _cache.get(Class);

        _cache.set(Class, Wrapper);
      }

      function Wrapper() {
        return _construct(Class, arguments, _getPrototypeOf(this).constructor);
      }

      Wrapper.prototype = Object.create(Class.prototype, {
        constructor: {
          value: Wrapper,
          enumerable: false,
          writable: true,
          configurable: true
        }
      });
      return _setPrototypeOf(Wrapper, Class);
    };

    return _wrapNativeSuper(Class);
  }

  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return self;
  }

  function _possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) {
      return call;
    }

    return _assertThisInitialized(self);
  }

  function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();

    return function _createSuperInternal() {
      var Super = _getPrototypeOf(Derived),
          result;

      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf(this).constructor;

        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }

      return _possibleConstructorReturn(this, result);
    };
  }

  var Responsive = /*#__PURE__*/function () {
    function Responsive() {
      var _this = this;

      _classCallCheck(this, Responsive);

      this.currentBreakpoint = Responsive.getCurrentBreakpoint();
      window.addEventListener('resize', function () {
        var newBreakpoint = Responsive.getCurrentBreakpoint();

        if (_this.currentBreakpoint === newBreakpoint) {
          return;
        }

        document.dispatchEvent(new CustomEvent('breakpoint:changed', {
          detail: {
            previousBreakpoint: _this.currentBreakpoint,
            currentBreakpoint: newBreakpoint
          }
        }));
        _this.currentBreakpoint = newBreakpoint;
      });
    }

    _createClass(Responsive, null, [{
      key: "matchesBreakpoint",
      value: function matchesBreakpoint(breakpoint) {
        switch (breakpoint) {
          case 'phone':
            return window.matchMedia('screen and (max-width: 640px)').matches;

          case 'tablet':
            return window.matchMedia('screen and (min-width: 641px) and (max-width: 1007px)').matches;

          case 'tablet-and-up':
            return window.matchMedia('screen and (min-width: 641px)').matches;

          case 'pocket':
            return window.matchMedia('screen and (max-width: 1007px)').matches;

          case 'lap':
            return window.matchMedia('screen and (min-width: 1008px) and (max-width: 1279px)').matches;

          case 'lap-and-up':
            return window.matchMedia('screen and (min-width: 1008px)').matches;

          case 'desk':
            return window.matchMedia('screen and (min-width: 1280px)').matches;

          case 'widescreen':
            return window.matchMedia('screen and (min-width: 1600px)').matches;

          case 'supports-hover':
            return window.matchMedia('(hover: hover) and (pointer: fine)').matches;
        }
      }
    }, {
      key: "getCurrentBreakpoint",
      value: function getCurrentBreakpoint() {
        if (window.matchMedia('screen and (max-width: 640px)').matches) {
          return 'phone';
        }

        if (window.matchMedia('screen and (min-width: 641px) and (max-width: 1007px)').matches) {
          return 'tablet';
        }

        if (window.matchMedia('screen and (min-width: 1008px) and (max-width: 1279px)').matches) {
          return 'lap';
        }

        if (window.matchMedia('screen and (min-width: 1280px)').matches) {
          return 'desk';
        }
      }
    }]);

    return Responsive;
  }();

  var Carousel = /*#__PURE__*/function () {
    function Carousel(element) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var overrideSettings = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      _classCallCheck(this, Carousel);

      this.element = element;
      this.initialConfig = Object.assign(JSON.parse(element.getAttribute('data-flickity-config')), overrideSettings);
      this.options = options;

      this._attachListeners();

      this._build();
    }

    _createClass(Carousel, [{
      key: "destroy",
      value: function destroy() {
        this.flickityInstance.destroy();

        if (this.initialConfig['breakpoints'] !== undefined) {
          document.removeEventListener('breakpoint:changed', this._onBreakpointChangedListener);
        }
      }
    }, {
      key: "getFlickityInstance",
      value: function getFlickityInstance() {
        return this.flickityInstance;
      }
    }, {
      key: "selectCell",
      value: function selectCell(index) {
        var shouldPause = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var shouldAnimate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

        if (shouldPause) {
          this.flickityInstance.pausePlayer();
        }

        this.flickityInstance.select(index, false, !shouldAnimate);
      }
    }, {
      key: "next",
      value: function next() {
        this.flickityInstance.next();
      }
    }, {
      key: "previous",
      value: function previous() {
        this.flickityInstance.previous();
      }
    }, {
      key: "pausePlayer",
      value: function pausePlayer() {
        this.flickityInstance.pausePlayer();
      }
    }, {
      key: "unpausePlayer",
      value: function unpausePlayer() {
        this.flickityInstance.unpausePlayer();
      }
    }, {
      key: "resize",
      value: function resize() {
        this.flickityInstance.resize();
      }
    }, {
      key: "getSelectedIndex",
      value: function getSelectedIndex() {
        return this.flickityInstance.selectedIndex;
      }
    }, {
      key: "getSelectedCell",
      value: function getSelectedCell() {
        return this.flickityInstance.selectedCell.element;
      }
    }, {
      key: "_attachListeners",
      value: function _attachListeners() {
        if (this.initialConfig['breakpoints'] !== undefined) {
          this._onBreakpointChangedListener = this._onBreakpointChanged.bind(this);
          document.addEventListener('breakpoint:changed', this._onBreakpointChangedListener);
        }
      }
      /**
       * Create the carousel instance
       */

    }, {
      key: "_build",
      value: function _build() {
        var _this = this;

        var config = this._processConfig();

        this.flickityInstance = new Flickity(this.element, config);

        this._validateDraggable();

        this.selectedIndex = this.flickityInstance.selectedIndex;
        this.flickityInstance.on('resize', this._validateDraggable.bind(this));

        if (this.options['onSelect']) {
          this.flickityInstance.on('select', function () {
            // Flickity will send the "select" event whenever the window resize (even on mobile...), as a consequence we need to check
            // first if the slide index have changed or not (cf: https://github.com/metafizzy/flickity/issues/529)
            if (_this.selectedIndex !== _this.flickityInstance.selectedIndex) {
              _this.options['onSelect'](_this.flickityInstance.selectedIndex, _this.flickityInstance.selectedCell.element);

              _this.selectedIndex = _this.flickityInstance.selectedIndex;
            }
          });
        }

        if (this.options['onSettle']) {
          this.flickityInstance.on('settle', function (index) {
            _this.options['onSettle'](index, _this.flickityInstance.selectedCell.element);
          });
        }

        if (this.options['onClick']) {
          this.flickityInstance.on('staticClick', function (event, pointer, cell, index) {
            _this.options['onClick'](cell, index);
          });
        }
      }
      /**
       * By default, Flickity does not disable draggable automatically if there is nothing to slide. We therefore manually do the check here by checking
       * if the displayed elements equals to the amount of elements
       */

    }, {
      key: "_validateDraggable",
      value: function _validateDraggable() {
        var isActive = this.flickityInstance.isActive || false;

        if (!isActive || !this.flickityInstance.options['draggable']) {
          return; // Not draggable, so nothing to do
        }

        if (undefined === this.flickityInstance.selectedElements || this.flickityInstance.selectedElements.length === this.flickityInstance.cells.length) {
          this.flickityInstance.unbindDrag();
        } else {
          this.flickityInstance.bindDrag();
        }
      }
      /**
       * Flickity is a CSS driven library and hence it is hard to setup some stuff in pure JS
       */

    }, {
      key: "_processConfig",
      value: function _processConfig() {
        var config = Object.assign({}, this.initialConfig);
        delete config['breakpoints'];

        if (this.initialConfig['breakpoints'] === undefined) {
          return config; // No change, we simply return the config as it is
        }

        var breakpoints = this.initialConfig['breakpoints'];
        breakpoints.forEach(function (breakpoint) {
          if (Responsive.matchesBreakpoint(breakpoint['matches'])) {
            config = Object.assign(config, breakpoint['settings']);
          }
        });
        return config;
      }
      /**
       * Verify if the breakpoint has changed, and optionally update the carousel
       */

    }, {
      key: "_onBreakpointChanged",
      value: function _onBreakpointChanged() {
        // The breakpoint may have changed, so we delete the carousel and rebuild it
        this.flickityInstance.destroy();

        this._build();
      }
    }]);

    return Carousel;
  }();

  var Animation = /*#__PURE__*/function () {
    function Animation() {
      _classCallCheck(this, Animation);
    }

    _createClass(Animation, null, [{
      key: "slideUp",
      value:
      /**
       * Slide up aims to close an element. To do that, we take the height of the element, and set it to 0 to
       * force an animation
       */
      function slideUp(element) {
        element.style.height = "".concat(element.scrollHeight, "px"); // Force previous height to allow CSS transition

        element.offsetHeight; // Force redraw

        element.style.height = 0;
      }
      /**
       * Slide down aims to open an element. To do that, you must make sure that the element you are trying to open
       * is set with height: 0; overflow: hidden in the CSS, and does not contain any padding nor margin.
       */

    }, {
      key: "slideDown",
      value: function slideDown(element) {
        if (element.style.height === 'auto') {
          return;
        } // To do the animation we temporarily hide it, check the height, and transition to it


        element.style.height = "".concat(element.firstElementChild.scrollHeight, "px");

        var transitionEnded = function transitionEnded(event) {
          if (event.propertyName === 'height') {
            element.style.height = 'auto'; // Allows the content to grow normally

            element.removeEventListener('transitionend', transitionEnded);
          }
        };

        element.addEventListener('transitionend', transitionEnded);
      }
    }]);

    return Animation;
  }();

  /**
   * Various DOM helper
   */
  var Dom = /*#__PURE__*/function () {
    function Dom() {
      _classCallCheck(this, Dom);
    }

    _createClass(Dom, null, [{
      key: "getSiblings",
      value:
      /**
       * Get all the previous and next siblings, optionally filtered by a selector
       */
      function getSiblings(element, filter) {
        var includeSelf = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        var siblings = [];
        var currentElement = element; // Do the previous first

        while (currentElement = currentElement.previousElementSibling) {
          if (!filter || currentElement.matches(filter)) {
            siblings.push(currentElement);
          }
        }

        if (includeSelf) {
          siblings.push(element);
        } // Then the next side


        currentElement = element;

        while (currentElement = currentElement.nextElementSibling) {
          if (!filter || currentElement.matches(filter)) {
            siblings.push(currentElement);
          }
        }

        return siblings;
      }
      /**
       * By default, NodeList object are only iterable with forEach on newest browsers. To support it cross-browser,
       * we need to normalize it
       */

    }, {
      key: "nodeListToArray",
      value: function nodeListToArray(nodeList, filter) {
        var items = [];

        for (var i = 0; i !== nodeList.length; ++i) {
          if (!filter || nodeList[i].matches(filter)) {
            items.push(nodeList[i]);
          }
        }

        return items;
      }
      /**
       * Calculate an element width with its margin
       */

    }, {
      key: "outerWidthWithMargin",
      value: function outerWidthWithMargin(element) {
        var width = element.offsetWidth,
            style = getComputedStyle(element);
        width += parseInt(style.marginLeft) + parseInt(style.marginRight);
        return width;
      }
      /**
       * Calculate an element height with its margin
       */

    }, {
      key: "outerHeightWithMargin",
      value: function outerHeightWithMargin(element) {
        var height = element.offsetHeight,
            style = getComputedStyle(element);
        height += parseInt(style.marginTop) + parseInt(style.marginBottom);
        return height;
      }
    }]);

    return Dom;
  }();

  var Collapsible = /*#__PURE__*/function () {
    function Collapsible() {
      _classCallCheck(this, Collapsible);

      this.domDelegate = new domDelegate.Delegate(document.body);

      this._attachListeners();
    }

    _createClass(Collapsible, [{
      key: "_attachListeners",
      value: function _attachListeners() {
        this.domDelegate.on('click', '[data-action="toggle-collapsible"]', this._toggleCollapsible.bind(this));
      }
      /**
       * Toggle a given collapsible
       */

    }, {
      key: "_toggleCollapsible",
      value: function _toggleCollapsible(event, target) {
        var _this = this;

        // If this is an auto-expand and that it reaches the needed breakpoint, we do nothing
        var parentCollapsible = target.closest('.Collapsible');

        if (parentCollapsible.classList.contains('Collapsible--autoExpand') && Responsive.matchesBreakpoint('tablet-and-up')) {
          return;
        }

        var isOpen = target.getAttribute('aria-expanded') === 'true';

        if (isOpen) {
          this._close(parentCollapsible, target);
        } else {
          this._open(parentCollapsible, target);
        } // We make sure to close any siblings collapsible as well


        Dom.getSiblings(parentCollapsible).forEach(function (collapsibleToClose) {
          return _this._close(collapsibleToClose);
        });
        event.preventDefault();
      }
      /**
       * Open a given collapsible
       */

    }, {
      key: "_open",
      value: function _open(collapsible) {
        var toggleButton = collapsible.querySelector('.Collapsible__Button'),
            collapsibleInner = collapsible.querySelector('.Collapsible__Inner');

        if (!collapsibleInner || toggleButton.getAttribute('aria-expanded') === 'true') {
          return; // It's already open
        }

        toggleButton.setAttribute('aria-expanded', 'true');
        collapsibleInner.style.overflow = 'visible';
        Animation.slideDown(collapsibleInner);
        setTimeout(function () {
          collapsible.style.overflow = 'visible';
        }, 350);
      }
      /**
       * Close a given collapsible
       */

    }, {
      key: "_close",
      value: function _close(collapsible) {
        var toggleButton = collapsible.querySelector('.Collapsible__Button'),
            collapsibleInner = collapsible.querySelector('.Collapsible__Inner');

        if (!collapsibleInner || toggleButton.getAttribute('aria-expanded') === 'false') {
          return; // It's already closed
        }

        toggleButton.setAttribute('aria-expanded', 'false');
        collapsibleInner.style.overflow = 'hidden';
        collapsible.style.overflow = 'hidden';
        Animation.slideUp(collapsibleInner);
      }
    }]);

    return Collapsible;
  }();

  // // tabs
  // var TabsX = /*#__PURE__*/function () {
  //   function Tabs() {
  //     _classCallCheck(this, Tabs);

  //     console.log('DEBUG: tabs!!!');

  //     this.domDelegate = new domDelegate.Delegate(document.body);

  //     // this._attachListeners();
  //     var elements = document.querySelectorAll('.cd-tabs');
  //     Array.prototype.forEach.call(elements, function(el, i){
  //       console.log('DEBUG: cd tabs', el);

  //       var contentActiveClass = 'cd-tabs__content--active';

  //       var $allContents = el.querySelectorAll('.cd-tabs__content');

  //       // .removeClass(contentActiveClass);

  //       Array.from($allContents).forEach(function(tc){
  //         tc.classList.remove(contentActiveClass);
  //         // tc.classList.add('testclass');

  //         var links = tc.querySelectorAll('.cd-tabs__content-title > a')

  //         Array.from(links).forEach(function(link) {
  //           link.addEventListener('click',function(ev) {
  //             console.log('DEBUG: clicked');
              
  //           var $parentTab = tc;
  //           var $content = $parentTab.querySelector('.cd-tabs__content-content');
            
  //           if ($parentTab.classList.contains(contentActiveClass)) {
  //             // $allContents.removeClass(contentActiveClass);
  //             // $content.slideUp(300);
  //             $parentTab.classList.remove(contentActiveClass);
  //           } else {
  //             // $allContents.filter('.'+contentActiveClass)
  //             //   .removeClass(contentActiveClass)
  //             //   .find('.cd-tabs__content-content').slideUp(300);


  //             $parentTab.classList.add(contentActiveClass);
              
      
  //             // setTimeout(function(){
  //             //   $parentTab.addClass(contentActiveClass);
  //             // },36); // add a bit delay to allow css transition (because the same element are given display block which not support transition)
  //             // $content.slideDown(300);

  //             // Animation.slideDown($content);
  //             // setTimeout(function () {
  //             //   $content.style.overflow = 'visible';
  //             //   $parentTab.classList.add(contentActiveClass);
  //             // }, 350);      

  //           }
  //           return false;
  //         }, false);
  //         });

            
      

  //       });


    
  //     });
  //   }

  //   _createClass(Tabs, [{
  //     key: "_attachListeners",
  //     value: function _attachListeners() {
        
  //     }
  //     /**
  //      * Toggle a given collapsible
  //      */

  //   }, {
  //     key: "_toggleCollapsible",
  //     value: function _toggleCollapsible(event, target) {
  //       var _this = this;
  //       event.preventDefault();
  //     }
  //   }, {
  //     key: "_open",
  //     value: function _open(collapsible) {
  //       // Animation.slideDown(collapsibleInner);
  //     }
  //   }, {
  //     key: "_close",
  //     value: function _close(collapsible) {
  //     }
  //   }]);

  //   return Tabs;
  // }();


  /**
 * @fileOverview
 * @author Zoltan Toth
 * @version 1.0.0
 */

/**
 * @description
 * Vanilla Javascript Tabs
 *
 * @class
 * @param {string} options.elem - HTML id of the tabs container
 * @param {number} [options.open = 0] - Render the tabs with this item open
 */
var Tabs = function (options) {
	var elem = document.getElementById(options.elem),
		open = options.open || 0,
		titleClass = 'js-tabs__title',
		activeClass = 'js-tabs__title-active',
		contentClass = 'js-tabs__content',
		tabsNum = elem.querySelectorAll('.' + titleClass).length;

	render();

	/**
	 * Initial rendering of the tabs.
	 */
	function render(n) {
		elem.addEventListener('click', onClick);

		var init = (n == null) ? checkTab(open) : checkTab(n);

		for (var i = 0; i < tabsNum; i++) {
			elem.querySelectorAll('.' + titleClass)[i].setAttribute('data-index', i);
			if (i === init) openTab(i);
		}
	}

	/**
	 * Handle clicks on the tabs.
	 * 
	 * @param {object} e - Element the click occured on.
	 */
	function onClick(e) {
		if (e.target.className.indexOf(titleClass) === -1) return;
		e.preventDefault();
		openTab(e.target.getAttribute('data-index'));
	}

	/**
	 * Hide all tabs and re-set tab titles.
	 */
	function reset() {
      [].forEach.call(elem.querySelectorAll('.' + contentClass), function (item) {
			// item.style.display = 'none';
			item.classList.remove('active');
		});

      [].forEach.call(elem.querySelectorAll('.' + titleClass), function (item) {
			item.className = removeClass(item.className, activeClass);
		});
	}

	/**
	 * Utility function to remove the open class from tab titles.
	 *
	 * @param {string} str - Current class.
	 * @param {string} cls - The class to remove.
	 */
	function removeClass(str, cls) {
		var reg = new RegExp('(\ )' + cls + '(\)', 'g');
		return str.replace(reg, '');
	}

	/**
	 * Utility function to remove the open class from tab titles.
	 *
	 * @param n - Tab to open.
	 */
	function checkTab(n) {
		return (n < 0 || isNaN(n) || n > tabsNum) ? 0 : n;
	}

	/**
	 * Opens a tab by index.
	 * 
	 * @param {number} n - Index of tab to open. Starts at 0.
	 * 
	 * @public
	 */
	function openTab(n) {
		reset();

		var i = checkTab(n);

		elem.querySelectorAll('.' + titleClass)[i].className += ' ' + activeClass;
		// elem.querySelectorAll('.' + contentClass)[i].style.display = '';
		elem.querySelectorAll('.' + contentClass)[i].classList.add('active');

    // ClueEdit
    // resize window. why? because there's tabs that contains flickity (you may also like tabs) that lazy rendered in non-active tab, resize window will fix its height calculation
    window.dispatchEvent(new Event('resize'));
    

	}

	/**
	 * Updates the tabs.
	 * 
	 * @param {number} n - Index of tab to open. Starts at 0.
	 * 
	 * @public
	 */
	function update(n) {
		destroy();
		reset();
		render(n);
	}

	/**
	 * Removes the listeners from the tabs.
	 * 
	 * @public
	 */
	function destroy() {
		elem.removeEventListener('click', onClick);
	}

	return {
		open: openTab,
		update: update,
		destroy: destroy
	};
};


function getHandleFromUrl(url) {
  var str = url.split('/products/');
  if (str.length > 1) {
    return str[1];
  }
  return '';
}



  var Accessibility = /*#__PURE__*/function () {
    function Accessibility() {
      _classCallCheck(this, Accessibility);
    }

    _createClass(Accessibility, null, [{
      key: "trapFocus",
      value:
      /**
       * Traps the focus in a particular container
       */
      function trapFocus(container, namespace) {
        this.listeners = this.listeners || {}; // We check if there is an element with the attribute "autofocus"

        var elementToFocus = container.querySelector('[autofocus]') || container;
        container.setAttribute('tabindex', '-1');
        elementToFocus.focus();

        this.listeners[namespace] = function (event) {
          if (container !== event.target && !container.contains(event.target)) {
            container.focus();
          }
        };

        document.addEventListener('focusin', this.listeners[namespace]);
      }
      /**
       * Removes the trap of focus in a particular container
       */

    }, {
      key: "removeTrapFocus",
      value: function removeTrapFocus(container, namespace) {
        if (container) {
          container.removeAttribute('tabindex');
        }

        if (this.listeners && this.listeners[namespace]) {
          document.removeEventListener('focusin', this.listeners[namespace]);
        }
      }
      /**
       * Reset any previous trap focus
       */

    }, {
      key: "clearTrapFocus",
      value: function clearTrapFocus() {
        for (var key in this.listeners) {
          if (this.listeners.hasOwnProperty(key)) {
            document.removeEventListener('focusin', this.listeners[key]);
          }
        }

        this.listeners = {};
      }
    }]);

    return Accessibility;
  }();

  var Drawer = /*#__PURE__*/function () {
    function Drawer(element) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      _classCallCheck(this, Drawer);

      this.element = element;
      this.delegateElement = new domDelegate.Delegate(this.element);
      this.delegateBody = new domDelegate.Delegate(document.body);

      this.onOpen = options['onOpen'] || function () {};

      this.onClose = options['onClose'] || function () {};

      this.isOpen = false;
      this.direction = this.element.classList.contains('Drawer--fromLeft') ? 'fromLeft' : 'fromRight';
      this.pageOverlayElement = document.querySelector('.PageOverlay');

      this._attachListeners();
    }

    _createClass(Drawer, [{
      key: "destroy",
      value: function destroy() {
        this.delegateBody.off('click', "[data-action=\"open-drawer\"][data-drawer-id=\"".concat(this.element.id, "\"]"));
        this.delegateBody.off('click', "[data-action=\"close-drawer\"][data-drawer-id=\"".concat(this.element.id, "\"]"));
        window.removeEventListener('resize', this._calculateMaxHeightListener);
      }
    }, {
      key: "toggle",
      value: function toggle() {
        this.isOpen ? this.close() : this.open();
      }
    }, {
      key: "open",
      value: function open(event) {
        if (this.isOpen) {
          return;
        } // Make sure that the search is closed whenever a drawer is opened


        this.element.dispatchEvent(new CustomEvent('search:close', {
          bubbles: true
        }));

        if (event) {
          event.preventDefault();
        }

        this.element.setAttribute('aria-hidden', 'false');

        this._calculateMaxHeight();

        document.documentElement.classList.add('no-scroll'); // This prevent the body to scroll on iOS. This is honestly a bit hacky, but until the platform supports "touch-action: none" like
        // other browsers, this is the only way to achieve that
        //disableBodyScroll(true, '[data-scrollable]');

        Accessibility.trapFocus(this.element, 'drawer');
        document.querySelector('#shopify-section-header').style.zIndex = ''; // Ugly hack
        // We attach an event to the page overlay to close it

        this.pageOverlayElement.classList.add('is-visible');
        this.pageOverlayElement.addEventListener('click', this._closeListener);
        this.isOpen = true;
        this.onOpen(); // Call the callback to allow other code to hook their logic

        return false;
      }
    }, {
      key: "close",
      value: function close(event) {
        if (!this.isOpen) {
          return;
        }

        if (event) {
          event.preventDefault();
        }

        this.element.setAttribute('aria-hidden', 'true');
        document.documentElement.classList.remove('no-scroll'); //disableBodyScroll(false, '[data-scrollable]');

        Accessibility.removeTrapFocus(this.element, 'drawer');
        this.pageOverlayElement.classList.remove('is-visible');
        this.pageOverlayElement.removeEventListener('click', this._closeListener);
        this.isOpen = false;
        this.onClose(); // Call the callback to allow other code to hook their logic
      }
    }, {
      key: "_attachListeners",
      value: function _attachListeners() {
        this._openListener = this.open.bind(this);
        this._closeListener = this.close.bind(this);
        this._calculateMaxHeightListener = this._calculateMaxHeight.bind(this);
        this.delegateBody.on('click', "[data-action=\"open-drawer\"][data-drawer-id=\"".concat(this.element.id, "\"]"), this._openListener);
        this.delegateBody.on('click', "[data-action=\"close-drawer\"][data-drawer-id=\"".concat(this.element.id, "\"]"), this._closeListener);
        this.element.addEventListener('keyup', this._handleKeyboard.bind(this));
        window.addEventListener('resize', this._calculateMaxHeightListener);
      }
      /**
       * Make sure that we force a max-height so that the drawer always stays on screen
       */

    }, {
      key: "_calculateMaxHeight",
      value: function _calculateMaxHeight() {
        this.element.style.maxHeight = window.innerHeight + 'px';
      }
    }, {
      key: "_handleKeyboard",
      value:
      /**
       * Handle a11y events
       */
      function _handleKeyboard(event) {
        if (this.isOpen && event.keyCode === 27) {
          this.close();
        }
      }
    }]);

    return Drawer;
  }();

  /**
   * Simple plugin that handles the loading bar actions
   *
   * This plugin uses delegate events so it's independent of the sections.
   */
  var LoadingBar = /*#__PURE__*/function () {
    function LoadingBar() {
      _classCallCheck(this, LoadingBar);

      this.element = document.querySelector('.LoadingBar');
      document.addEventListener('theme:loading:start', this._onLoadingStart.bind(this));
      document.addEventListener('theme:loading:end', this._onLoadingEnd.bind(this));
      this.element.addEventListener('transitionend', this._onTransitionEnd.bind(this));
    }

    _createClass(LoadingBar, [{
      key: "_onLoadingStart",
      value: function _onLoadingStart() {
        this.element.classList.add('is-visible');
        this.element.style.width = '40%';
      }
    }, {
      key: "_onLoadingEnd",
      value: function _onLoadingEnd() {
        this.element.style.width = '100%';
        this.element.classList.add('is-finished');
      }
    }, {
      key: "_onTransitionEnd",
      value: function _onTransitionEnd(event) {
        if (event.propertyName === 'width' && this.element.classList.contains('is-finished')) {
          this.element.classList.remove('is-visible');
          this.element.classList.remove('is-finished');
          this.element.style.width = '0';
        }
      }
    }]);

    return LoadingBar;
  }();

  var Modal = /*#__PURE__*/function () {
    function Modal() {
      _classCallCheck(this, Modal);

      this.domDelegate = new domDelegate.Delegate(document.body);
      this.activeModal = null; // Keep track of the active modal

      this.wasLocked = false;
      this.pageOverlayElement = document.querySelector('.PageOverlay');

      this._attachListeners();

      this._checkOpenByHash();
    }

    _createClass(Modal, [{
      key: "_attachListeners",
      value: function _attachListeners() {
        this._closeListener = this._closeModal.bind(this);
        this._handleKeyboardListener = this._handleKeyboard.bind(this);
        this.domDelegate.on('click', '[data-action="open-modal"]', this._openModalEvent.bind(this));
        this.domDelegate.on('click', '[data-action="close-modal"]', this._closeModal.bind(this));
      }
    }, {
      key: "_openModalEvent",
      value: function _openModalEvent(event, target) {
        this._openModal(document.getElementById(target.getAttribute('aria-controls')));

        event.preventDefault();
        event.stopPropagation();
      }
    }, {
      key: "_openModal",
      value: function _openModal(modal) {
        var _this = this;

        if (this.activeModal || !modal) {
          return; // If there is already an open modal, we return as we only allows one modal at a time
        }

        this.activeModal = modal;
        this.domDelegate.on('keyup', this._handleKeyboardListener);

        if (document.documentElement.classList.contains('no-scroll')) {
          this.wasLocked = true;
        }

        fastdom.mutate(function () {
          Accessibility.clearTrapFocus(); // Needed as the modal can be open on top of a popover

          _this._onTransitionEndedListener = _this._onTransitionEnded.bind(_this);

          _this.activeModal.addEventListener('transitionend', _this._onTransitionEndedListener);

          _this.activeModal.setAttribute('aria-hidden', 'false');

          document.documentElement.classList.add('no-scroll'); // If the modal is not a fullscreen modal, then we also display the overlay

          if (!_this.activeModal.classList.contains('Modal--fullScreen')) {
            _this.pageOverlayElement.classList.add('is-visible');

            _this.pageOverlayElement.addEventListener('click', _this._closeListener);
          }
        });
      }
    }, {
      key: "_closeModal",
      value: function _closeModal() {
        var _this2 = this;

        if (!this.activeModal) {
          return; // If no modal are open, we return immediately
        }

        this.activeModal.removeEventListener('keyup', this._handleKeyboardListener);
        this.domDelegate.off('keyup');
        fastdom.mutate(function () {
          // If the modal is of video type, we need to remove the iframe to stop the video
          if (_this2.activeModal.classList.contains('Modal--videoContent')) {
            _this2._resetVideoListener = _this2._resetVideo.bind(_this2);

            _this2.activeModal.addEventListener('transitionend', _this2._resetVideoListener);
          }

          Accessibility.removeTrapFocus(_this2.activeModal, 'modal');

          if (!_this2.activeModal.classList.contains('Modal--fullScreen')) {
            _this2.pageOverlayElement.classList.remove('is-visible');

            _this2.pageOverlayElement.removeEventListener('click', _this2._closeListener);
          }

          _this2.activeModal.setAttribute('aria-hidden', 'true');

          _this2.activeModal = null;

          if (!_this2.wasLocked) {
            document.documentElement.classList.remove('no-scroll');
          }
        });
      }
    }, {
      key: "_onTransitionEnded",
      value: function _onTransitionEnded(event) {
        if (event.propertyName !== 'visibility') {
          return;
        }

        Accessibility.trapFocus(this.activeModal, 'modal'); // Trap the focus first (as this trigger reflows)

        this.activeModal.removeEventListener('transitionend', this._onTransitionEndedListener);
      }
    }, {
      key: "_resetVideo",
      value: function _resetVideo(event) {
        if (event.propertyName !== 'visibility') {
          return; // We check the visibility property as it's the one LazySizes uses for triggering lazyloading
        }

        var iframe = event.target.querySelector('iframe');
        iframe.parentNode.innerHTML = "<iframe class=\"Image--lazyLoad\" data-src=".concat(iframe.getAttribute('data-src'), " frameborder=\"0\" allowfullscreen>");
        event.target.removeEventListener('transitionend', this._resetVideoListener);
      }
      /**
       * Some forms needs to be open inside a modal, and on page reload we must make sure to properly open the modal again
       */

    }, {
      key: "_checkOpenByHash",
      value: function _checkOpenByHash() {
        var hash = window.location.hash,
            modal = document.getElementById(hash.replace('#', ''));

        if (modal && modal.classList.contains('Modal')) {
          this._openModal(modal);
        }
      }
      /**
       * Handle a11y events
       */

    }, {
      key: "_handleKeyboard",
      value: function _handleKeyboard(event) {
        if (null !== this.activeModal && event.keyCode === 27) {
          this._closeModal();
        }
      }
    }]);

    return Modal;
  }();

  var Popover = /*#__PURE__*/function () {
    function Popover(element, options) {
      _classCallCheck(this, Popover);

      this.element = element;
      this.delegateElement = new domDelegate.Delegate(this.element);
      this.activator = options['activator'] || document.querySelector("[aria-controls=\"".concat(element.getAttribute('id'), "\"]"));
      this.preferredPosition = options['preferredPosition'] || 'bottom';
      this.preferredAlignment = options['preferredAlignment'] || undefined;
      this.threshold = options['threshold'] || 20;
      this.isOpen = false;

      this.onValueChanged = options['onValueChanged'] || function () {};

      this.onOpen = options['onOpen'] || function () {};

      this.onClose = options['onClose'] || function () {};

      this.showOverlay = options['showOverlay'] === undefined ? true : options['showOverlay'];
      this.pageOverlayElement = document.querySelector('.PageOverlay');

      this._attachListeners();
    }

    _createClass(Popover, [{
      key: "destroy",
      value: function destroy() {
        this.element.removeEventListener('keyup', this._handleKeyboardListener);
        this.delegateElement.off('click');
        this.activator.removeEventListener('click', this._toggleListener);
      }
    }, {
      key: "toggle",
      value: function toggle() {
        this.isOpen ? this.close() : this.open();
      }
    }, {
      key: "open",
      value: function open() {
        var _this = this;

        // Note: the additional check on the aria-controls is used here so that a given activator can be used on different
        //       popovers and be modified dynamically in JavaScript
        if (this.isOpen || this.activator.getAttribute('aria-controls') !== this.element.id) {
          return;
        }

        this.element.setAttribute('aria-hidden', 'false');
        this.activator.setAttribute('aria-expanded', 'true');
        disableBodyScroll(true, '[data-scrollable]');
        document.documentElement.classList.add('no-scroll'); // Prevent scrolling when popover is open

        if (Responsive.matchesBreakpoint('lap-and-up')) {
          document.body.addEventListener('click', this._clickOutsideListener);

          this._position();

          this.element.setAttribute('tabindex', '-1');
          this.element.addEventListener('transitionend', function () {
            _this.element.focus();
          }, {
            once: true
          });
        } else {
          this.element.removeAttribute('style');

          if (this.showOverlay) {
            this.pageOverlayElement.classList.add('is-visible');
            this.pageOverlayElement.addEventListener('click', this._closeListener);
          }
        }

        this.onOpen(this); // Call the callback to allow other code to hook their logic

        this.isOpen = true;
      }
    }, {
      key: "close",
      value: function close() {
        if (!this.isOpen) {
          return;
        }

        this.element.setAttribute('aria-hidden', 'true');
        this.activator.setAttribute('aria-expanded', 'false');
        disableBodyScroll(false, '[data-scrollable]');
        document.documentElement.classList.remove('no-scroll');

        if (Responsive.matchesBreakpoint('lap-and-up')) {
          document.body.removeEventListener('click', this._clickOutsideListener);
        } else if (this.showOverlay) {
          this.pageOverlayElement.classList.remove('is-visible');
          this.pageOverlayElement.removeEventListener('click', this._closeListener);
        }

        this.element.removeAttribute('tabindex');
        this.activator.focus();
        this.onClose(this); // Call the callback to allow other code to hook their logic

        this.isOpen = false;
      }
    }, {
      key: "_attachListeners",
      value: function _attachListeners() {
        this._handleKeyboardListener = this._handleKeyboard.bind(this);
        this._clickOutsideListener = this._clickOutside.bind(this);
        this._closeListener = this.close.bind(this);
        this._toggleListener = this.toggle.bind(this);
        this.element.addEventListener('keyup', this._handleKeyboardListener);
        this.activator.addEventListener('click', this._toggleListener);
        this.delegateElement.on('click', '[data-action="close-popover"]', this.close.bind(this));
        this.delegateElement.on('click', '[data-action="select-value"]', this._valueChanged.bind(this));

        if (this.element.hasAttribute('id')) {
          this.delegateElement.on('focusout', "#".concat(this.element.getAttribute('id')), this._onFocusOut.bind(this));
        }
      }
      /**
       * Whenever a value is selected, it can notify a callback so that the calling code can do its own logic in response
       * of the value change
       */

    }, {
      key: "_valueChanged",
      value: function _valueChanged(event) {
        Dom.getSiblings(event.target, '.is-selected').forEach(function (item) {
          return item.classList.remove('is-selected');
        });
        event.target.classList.add('is-selected'); // If there is a callback in option we call it with the value

        this.onValueChanged(event.target.getAttribute('data-value'), event.target, this.activator);
        this.close();
      }
    }, {
      key: "_onFocusOut",
      value: function _onFocusOut(event) {
        if (!this.element.contains(event.relatedTarget)) {
          this.close();
        }
      }
      /**
       * Callback that is called to decide if we should close the popover when a click is captured outside
       */

    }, {
      key: "_clickOutside",
      value: function _clickOutside(event) {
        if (!event.target.closest('.Popover') && !event.target.closest('.Modal') && event.target !== this.activator && !this.activator.contains(event.target)) {
          this.close();
        }
      }
      /**
       * On desktop, we reposition the popover in JavaScript by doing some smart logic to detect the most appropriate area
       */

    }, {
      key: "_position",
      value: function _position() {
        var _this2 = this;

        var topPosition = 0,
            rightPosition = 0,
            position = '',
            alignment = '',
            threshold = this.threshold;
        fastdom.measure(function () {
          var windowHeight = window.innerHeight,
              activatorBoundingRect = _this2.activator.getBoundingClientRect(),
              halfHeight = windowHeight / 2;

          if (_this2.preferredPosition === 'bottom') {
            alignment = 'right';

            if (_this2.element.clientHeight <= windowHeight - (activatorBoundingRect.bottom + threshold) || windowHeight - activatorBoundingRect.bottom >= halfHeight) {
              position = 'bottom';
            } else {
              position = 'top';
            }
          } else if (_this2.preferredPosition === 'top') {
            alignment = 'right';

            if (_this2.element.clientHeight <= activatorBoundingRect.top - threshold || activatorBoundingRect.top >= halfHeight) {
              position = 'top';
            } else {
              position = 'bottom';
            }
          } else {
            position = 'left'; // Is there enough space to use the center alignment (which is preferred)?

            var halfElementHeight = _this2.element.clientHeight / 2;

            if (activatorBoundingRect.top >= halfElementHeight && windowHeight - activatorBoundingRect.bottom >= halfElementHeight) {
              alignment = 'center';
            } else if (windowHeight - activatorBoundingRect.bottom >= halfElementHeight) {
              alignment = 'bottom';
            } else {
              alignment = 'top';
            }
          }

          if (_this2.preferredAlignment) {
            alignment = _this2.preferredAlignment;
          }

          if (position === 'top') {
            topPosition = activatorBoundingRect.top - _this2.element.clientHeight - threshold;

            if (alignment === 'center') {
              rightPosition = window.innerWidth - activatorBoundingRect.right - _this2.element.clientWidth / 2 + 3;
            } else {
              rightPosition = window.innerWidth - activatorBoundingRect.right;
            }
          } else if (position === 'bottom') {
            topPosition = activatorBoundingRect.bottom + threshold;

            if (alignment === 'center') {
              rightPosition = window.innerWidth - activatorBoundingRect.right - _this2.element.clientWidth / 2 + 3;
            } else {
              rightPosition = window.innerWidth - activatorBoundingRect.right;
            }
          } else {
            rightPosition = window.innerWidth - activatorBoundingRect.left + threshold;

            if (alignment === 'center') {
              topPosition = activatorBoundingRect.top - _this2.element.clientHeight / 2 + _this2.activator.clientHeight / 2;
            } else if (alignment === 'top') {
              topPosition = activatorBoundingRect.bottom - _this2.element.clientHeight;
            } else {
              topPosition = activatorBoundingRect.top;
            }
          }
        });
        fastdom.mutate(function () {
          ['Popover--positionBottom', 'Popover--positionTop', 'Popover--positionCenter', 'Popover--alignTop', 'Popover--alignCenter', 'Popover--alignBottom'].map(function (item) {
            return _this2.element.classList.remove(item);
          });

          _this2.element.classList.add("Popover--position".concat(position.charAt(0).toUpperCase() + position.slice(1)));

          _this2.element.classList.add("Popover--align".concat(alignment.charAt(0).toUpperCase() + alignment.slice(1)));

          _this2.element.setAttribute('style', "top: ".concat(parseInt(topPosition), "px; right: ").concat(parseInt(rightPosition), "px;"));
        });
      }
      /**
       * Handle a11y events
       */

    }, {
      key: "_handleKeyboard",
      value: function _handleKeyboard(event) {
        if (this.isOpen && event.keyCode === 27) {
          this.close();
        }
      }
    }]);

    return Popover;
  }();

  /**
   * This class will coordinate all the transitions from the website
   */
  var PageTransition = /*#__PURE__*/function () {
    function PageTransition() {
      _classCallCheck(this, PageTransition);

      this.domDelegate = new domDelegate.Delegate(document.body);
      this.pageTransition = document.querySelector('.PageTransition');

      this._attachListeners();
    }

    _createClass(PageTransition, [{
      key: "_attachListeners",
      value: function _attachListeners() {
        this.domDelegate.on('click', 'a[href]:not([href^="#"]):not([href^="javascript:"]):not([href^="mailto:"]):not([href^="tel:"]):not([target="_blank"])', this._onPageUnload.bind(this));
      }
      /**
       * This callback captures click and transition from one page to another by doing a transition
       */

    }, {
      key: "_onPageUnload",
      value: function _onPageUnload(event, target) {
        var _this = this;

        if (event.defaultPrevented || event.ctrlKey || event.metaKey || !window.theme.showPageTransition || !this.pageTransition) {
          return;
        }

        event.preventDefault(); // Prevent the click to happen

        if (window.theme.showPageTransition && this.pageTransition) {
          var doTransition = function doTransition(event) {
            // Animation is finished, we can transition
            if (event.propertyName === 'opacity') {
              _this.pageTransition.removeEventListener('transitionend', doTransition);

              window.location.href = target.href;
            }
          };

          this.pageTransition.addEventListener('transitionend', doTransition);
          this.pageTransition.style.visibility = 'visible';
          this.pageTransition.style.opacity = '1';
        }
      }
    }], [{
      key: "getInstance",
      value: function getInstance() {
        if (!this.instance) {
          this.instance = new PageTransition();
        }

        return this.instance;
      }
    }]);

    return PageTransition;
  }();

  /**
   * Note: this was a feature that was added at the very end and couldn't do something much cleaner without rewriting large parts of the theme...
   */
  var ProductItemColorSwatch = /*#__PURE__*/function () {
    function ProductItemColorSwatch(element) {
      _classCallCheck(this, ProductItemColorSwatch);

      this.element = element;
      this.delegateElement = new domDelegate.Delegate(this.element);
      this.delegateElement.on('change', '.ColorSwatch__Radio', this._colorChanged.bind(this));
    }

    _createClass(ProductItemColorSwatch, [{
      key: "_colorChanged",
      value: function _colorChanged(event, target) {
        // We need to change the URL of the various links
        var productItem = target.closest('.ProductItem'),
            variantUrl = target.getAttribute('data-variant-url');
        productItem.querySelector('.ProductItem__ImageWrapper').setAttribute('href', variantUrl);
        productItem.querySelector('.ProductItem__Title > a').setAttribute('href', variantUrl); // If we have a custom image for the variant, we change it

        var originalImageElement = productItem.querySelector('.ProductItem__Image:not(.ProductItem__Image--alternate)');

        if (target.hasAttribute('data-image-url') && target.getAttribute('data-image-id') !== originalImageElement.getAttribute('data-image-id')) {
          var newImageElement = document.createElement('img');
          newImageElement.className = 'ProductItem__Image Image--fadeIn Image--lazyLoad';
          newImageElement.setAttribute('data-image-id', target.getAttribute('data-image-id'));
          newImageElement.setAttribute('data-src', target.getAttribute('data-image-url'));
          newImageElement.setAttribute('data-widths', target.getAttribute('data-image-widths'));
          newImageElement.setAttribute('data-sizes', 'auto'); // Replace the original node

          if (window.theme.productImageSize === 'natural') {
            originalImageElement.parentNode.style.paddingBottom = "".concat(100.0 / target.getAttribute('data-image-aspect-ratio'), "%");
          }

          originalImageElement.parentNode.style.setProperty('--aspect-ratio', target.getAttribute('data-image-aspect-ratio'));
          originalImageElement.parentNode.replaceChild(newImageElement, originalImageElement);
        }
      }
    }]);

    return ProductItemColorSwatch;
  }();

  var Image = /*#__PURE__*/function () {
    function Image() {
      _classCallCheck(this, Image);
    }

    _createClass(Image, null, [{
      key: "getSizedImageUrl",
      value:
      /**
       * Create a CDN URL (similar to the img_url filter in Liquid)
       */
      function getSizedImageUrl(src, size) {
        if (size === null) {
          return src;
        }

        if (size === 'master') {
          return src.replace(/http(s)?:/, '');
        }

        var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

        if (match) {
          var prefix = src.split(match[0]);
          var suffix = match[0];
          return (prefix[0] + '_' + size + suffix).replace(/http(s)?:/, '');
        } else {
          return null;
        }
      }
      /**
       * From a given set of desired sizes and a given image, filter out any unwanted sizes
       */

    }, {
      key: "getSupportedSizes",
      value: function getSupportedSizes(image, desiredSizes) {
        var supportedSizes = [],
            imageWidth = image['width'];
        desiredSizes.forEach(function (width) {
          if (imageWidth >= width) {
            supportedSizes.push(width);
          }
        });
        return supportedSizes;
      }
    }]);

    return Image;
  }();

  var ProductImageZoom = /*#__PURE__*/function () {
    function ProductImageZoom(element, slideshow) {
      _classCallCheck(this, ProductImageZoom);

      this.element = element;
      this.delegateElement = new domDelegate.Delegate(this.element);
      this.delegateRoot = new domDelegate.Delegate(document.body);
      this.slideshow = slideshow;

      this._attachListeners();
    }

    _createClass(ProductImageZoom, [{
      key: "destroy",
      value: function destroy() {
        this.delegateElement.off('click');
      }
    }, {
      key: "_attachListeners",
      value: function _attachListeners() {
        this.delegateElement.on('click', '[data-action="open-product-zoom"]', this._initPhotoSwipe.bind(this));
        this.delegateElement.on('click', '.Product__SlideItem--image', this._initPhotoSwipeFromImageClick.bind(this));
      }
      /**
       * To save performance, we only initialize PhotoSwipe when it's requested. All high resolution images
       * are also loaded only on demand. Also, please note that PhotoSwipe is always completely destroyed
       * whenever it is closed, so it stays super snappy
       */

    }, {
      key: "_initPhotoSwipe",
      value: function _initPhotoSwipe() {
        var images = [];
        this.slideshow.flickityInstance.cells.forEach(function (item) {
          if (item.element.classList.contains('Product__SlideItem--image')) {
            images.push(item.element.querySelector('img'));
          }
        });

        this._createPhotoSwipeInstance(this._createPhotoSwipeItemsFromImages(images), parseInt(this.slideshow.flickityInstance.selectedElement.getAttribute('data-image-media-position')));
      }
      /**
       * On desktop we do not have the dedicated small icon, instead the zoom is triggered when clicking directly on the image
       */

    }, {
      key: "_initPhotoSwipeFromImageClick",
      value: function _initPhotoSwipeFromImageClick(event, target) {
        // Opening this way is only available on desktop
        if (Responsive.matchesBreakpoint('pocket')) {
          return;
        }

        var images = Dom.nodeListToArray(this.element.querySelectorAll('.Product__SlideItem--image img'));

        this._createPhotoSwipeInstance(this._createPhotoSwipeItemsFromImages(images), parseInt(target.getAttribute('data-image-media-position')));
      }
      /**
       * Take a list of images and create a PhotoSwipe array. This is called whenever the gallery is initialized.
       */

    }, {
      key: "_createPhotoSwipeItemsFromImages",
      value: function _createPhotoSwipeItemsFromImages(images) {
        return images.map(function (image) {
          var maxWidth = parseInt(image.getAttribute('data-max-width')),
              maxHeight = parseInt(image.getAttribute('data-max-height')),
              maxDimension = Responsive.matchesBreakpoint('phone') ? 1200 : 1800,
              // 1200 is max size for mobile and 1800 for larger devices
          reduceFactor = 1.0;

          if (maxWidth >= maxHeight) {
            reduceFactor = Math.max(maxWidth / maxDimension, 1.0);
          } else {
            reduceFactor = Math.max(maxHeight / maxDimension, 1.0);
          }

          var requestedWidth = Math.floor(maxWidth / reduceFactor);
          var requestedHeight = Math.floor(maxHeight / reduceFactor);
          return {
            msrc: image.currentSrc || image.src,
            // For browser that supports srcset, currentSrc is the currently used image
            w: requestedWidth,
            h: requestedHeight,
            initialZoomLevel: 0.65,
            src: Image.getSizedImageUrl(image.getAttribute('data-original-src'), requestedWidth + 'x' + requestedHeight)
          };
        });
      }
      /**
       * Take a list of nodes containing all images and create a PhotoSwipe array. This is called
       * whenever the gallery is initialized.
       */

    }, {
      key: "_createPhotoSwipeInstance",
      value: function _createPhotoSwipeInstance(items, selectedImageIndex) {
        var _this = this;

        var photoswipeContainer = document.querySelector('.pswp');
        this.photoSwipeInstance = new PhotoSwipe(photoswipeContainer, false, items, {
          index: selectedImageIndex,
          showHideOpacity: true,
          showAnimationDuration: 500,
          loop: false,
          history: false,
          closeOnVerticalDrag: false,
          allowPanToNext: false,
          pinchToClose: false,
          errorMsg: '<p class="pswp__error-msg">' + window.languages.productImageLoadingError + '</p>',
          scaleMode: 'zoom',
          getDoubleTapZoom: function getDoubleTapZoom(isMouseClick, item) {
            if (isMouseClick) {
              return 1.6;
            } else {
              return item.initialZoomLevel < 0.7 ? 1 : 1.33;
            }
          },
          getThumbBoundsFn: function getThumbBoundsFn(index) {
            var thumbnail = _this.element.querySelector(".Product__Slideshow .Carousel__Cell[data-image-media-position=\"".concat(parseInt(index), "\"] img")),
                pageYScroll = window.pageYOffset || document.documentElement.scrollTop,
                rect = thumbnail.getBoundingClientRect();

            return {
              x: rect.left,
              y: rect.top + pageYScroll,
              w: rect.width
            };
          }
        });
        this.photoSwipeInstance.listen('beforeChange', this._onSlideChanged.bind(this));
        this.photoSwipeInstance.listen('destroy', this._destroyPhotoSwipe.bind(this));
        this.photoSwipeInstance.listen('doubleTap', this._onDoubleTap.bind(this));
        this.photoSwipeInstance.listen('initialZoomIn', this._onInitialZoomIn.bind(this));
        this.photoSwipeInstance.listen('initialZoomOut', this._onInitialZoomOut.bind(this));
        this.delegateRoot.on('pswpTap', '.pswp__scroll-wrap', this._onSingleTap.bind(this));
        this.delegateRoot.on('pswpTap', '.pswp__button--close', this.photoSwipeInstance.close);
        this.delegateRoot.on('pswpTap', '.pswp__button--prev', this.photoSwipeInstance.prev);
        this.delegateRoot.on('pswpTap', '.pswp__button--next', this.photoSwipeInstance.next);
        this.photoSwipeInstance.init();
      }
      /**
       * Update the nav
       */

    }, {
      key: "_onSlideChanged",
      value: function _onSlideChanged() {
        if (this.photoSwipeInstance.getCurrentIndex() === 0) {
          this.photoSwipeInstance.scrollWrap.querySelector('.pswp__button--prev').setAttribute('disabled', 'disabled');
        } else {
          this.photoSwipeInstance.scrollWrap.querySelector('.pswp__button--prev').removeAttribute('disabled');
        }

        if (this.photoSwipeInstance.getCurrentIndex() + 1 === this.photoSwipeInstance.options.getNumItemsFn()) {
          this.photoSwipeInstance.scrollWrap.querySelector('.pswp__button--next').setAttribute('disabled', 'disabled');
        } else {
          this.photoSwipeInstance.scrollWrap.querySelector('.pswp__button--next').removeAttribute('disabled');
        }
      }
      /**
       * This event is a bit different and is triggered when the user click somewhere. We use it do allow to zoom in and
       * zoom out in the image on desktop and use for the UI
       */

    }, {
      key: "_onSingleTap",
      value: function _onSingleTap(event) {
        if (!event.detail || event.detail.pointerType === 'mouse') {
          if (event.target.classList.contains('pswp__img')) {
            this.photoSwipeInstance.toggleDesktopZoom(event.detail.releasePoint);
          }
        } else {
          if (event.target.classList.contains('pswp__button')) {
            return;
          }

          event.target.closest('.pswp').querySelector('.pswp__ui').classList.toggle('pswp__ui--hidden');
        }
      }
    }, {
      key: "_onDoubleTap",
      value: function _onDoubleTap(point) {
        var initialZoomLevel = this.photoSwipeInstance.currItem.initialZoomLevel;

        if (this.photoSwipeInstance.getZoomLevel() !== initialZoomLevel) {
          this.photoSwipeInstance.zoomTo(initialZoomLevel, point, 333);
        } else {
          this.photoSwipeInstance.zoomTo(initialZoomLevel < 0.7 ? 1 : 1.33, point, 333);
        }
      }
    }, {
      key: "_onInitialZoomIn",
      value: function _onInitialZoomIn() {
        document.querySelector('.pswp__ui').classList.remove('pswp__ui--hidden');
      }
    }, {
      key: "_onInitialZoomOut",
      value: function _onInitialZoomOut() {
        document.querySelector('.pswp__ui').classList.add('pswp__ui--hidden');
      }
      /**
       * PhotoSwipe instance is automatically destroyed for us when it's closed. What we need to do is simply re-set
       * our in-memory instance to null and our own events
       */

    }, {
      key: "_destroyPhotoSwipe",
      value: function _destroyPhotoSwipe() {
        this.delegateRoot.off('pswpTap');
        this.photoSwipeInstance = null;
      }
    }]);

    return ProductImageZoom;
  }();

  var ProductModel = /*#__PURE__*/function () {
    function ProductModel(element, stackProductImages) {
      _classCallCheck(this, ProductModel);

      this.element = element;
      this.delegateElement = new domDelegate.Delegate(this.element);
      this.delegateRoot = new domDelegate.Delegate(document.documentElement);
      this.stackProductImages = stackProductImages;

      this._attachListeners();

      var stylesheet = document.createElement('link');
      stylesheet.rel = 'stylesheet';
      stylesheet.href = 'https://cdn.shopify.com/shopifycloud/model-viewer-ui/assets/v1.0/model-viewer-ui.css';
      document.head.appendChild(stylesheet);
      window.Shopify.loadFeatures([{
        name: 'model-viewer-ui',
        version: '1.0',
        onLoad: this._setupModelViewerUI.bind(this)
      }, {
        name: 'shopify-xr',
        version: '1.0'
      }]);
    }

    _createClass(ProductModel, [{
      key: "destroy",
      value: function destroy() {}
    }, {
      key: "_attachListeners",
      value: function _attachListeners() {
        var _this = this;

        this.element.querySelector('model-viewer').addEventListener('shopify_model_viewer_ui_toggle_play', function () {
          _this.element.dispatchEvent(new CustomEvent('model:played', {
            bubbles: true
          }));
        });
        this.element.querySelector('model-viewer').addEventListener('shopify_model_viewer_ui_toggle_pause', function () {
          _this.element.dispatchEvent(new CustomEvent('model:paused', {
            bubbles: true
          }));
        });
      }
    }, {
      key: "hasBeenSelected",
      value: function hasBeenSelected() {
        // As per guidelines, we only need to autoplay when it's not a touch device
        if (Responsive.matchesBreakpoint('supports-hover')) {
          this.modelUi.play();
        }
      }
    }, {
      key: "hasBeenDeselected",
      value: function hasBeenDeselected() {
        // In all cases, we just turn it off
        this.modelUi.pause();
      }
    }, {
      key: "_setupModelViewerUI",
      value: function _setupModelViewerUI() {
        this.modelElement = this.element.querySelector('model-viewer');
        this.modelUi = new window.Shopify.ModelViewerUI(this.modelElement);
      }
    }]);

    return ProductModel;
  }();

  var ProductReviews = /*#__PURE__*/function () {
    function ProductReviews(container) {
      _classCallCheck(this, ProductReviews);

      this.element = container;
      this.delegateElement = new domDelegate.Delegate(this.element);
      this.delegateElement.on('click', '.spr-summary-actions-newreview', this._onNewReviewClicked.bind(this)); // Extending Shopify Reviews is a bit manual, but let's do it!

      window.SPRCallbacks = {};
      window.SPRCallbacks.onFormSuccess = this._onFormSuccess.bind(this);
      window.SPRCallbacks.onReviewsLoad = this._onReviewsLoad.bind(this);
    }

    _createClass(ProductReviews, [{
      key: "destroy",
      value: function destroy() {
        this.delegateElement.off();
      }
    }, {
      key: "_updatePagination",
      value: function _updatePagination(event, target) {
        // Unfortunately, we have to use this ugly jQuery style stuff
        SPR.$(target).data('page', parseInt(target.getAttribute('data-page')) + 1);
      }
    }, {
      key: "_onFormSuccess",
      value: function _onFormSuccess() {
        var formSuccess = this.element.querySelector('.spr-form-message-success');
        window.scrollTo(0, formSuccess.offsetTop - 45);
      }
    }, {
      key: "_onReviewsLoad",
      value: function _onReviewsLoad() {
        // We want to move "spr-pagination-next" before the "new review" button in the "spr-summary-actions" div
        var sprSummaryActions = this.element.querySelector('.spr-summary-actions'),
            previousSprPaginationNext = sprSummaryActions.querySelector('.spr-pagination-next'),
            sprPaginationNext = this.element.querySelector('.spr-pagination .spr-pagination-next');

        if (previousSprPaginationNext) {
          previousSprPaginationNext.remove();
        }

        if (sprPaginationNext) {
          sprSummaryActions.insertBefore(sprPaginationNext, sprSummaryActions.firstChild);
        }
      }
    }, {
      key: "_onNewReviewClicked",
      value: function _onNewReviewClicked(event, target) {
        target.style.display = 'none';

        if (target.previousElementSibling) {
          target.previousElementSibling.style.display = 'none';
        }
      }
    }]);

    return ProductReviews;
  }();

  /**
   * This implementation allows to serialize a form
   */
  var Form = /*#__PURE__*/function () {
    function Form() {
      _classCallCheck(this, Form);
    }

    _createClass(Form, null, [{
      key: "serialize",
      value: function serialize(form) {
        function stringKey(key, value) {
          var beginBracket = key.lastIndexOf('[');

          if (beginBracket === -1) {
            var _hash = {};
            _hash[key] = value;
            return _hash;
          }

          var newKey = key.substr(0, beginBracket);
          var newValue = {};
          newValue[key.substring(beginBracket + 1, key.length - 1)] = value;
          return stringKey(newKey, newValue);
        }

        var hash = {};

        for (var i = 0, len = form.elements.length; i < len; i++) {
          var formElement = form.elements[i];

          if (formElement.name === '' || formElement.disabled) {
            continue;
          }

          if (formElement.name && !formElement.disabled && (formElement.checked || /select|textarea/i.test(formElement.nodeName) || /hidden|text|search|tel|url|email|password|datetime|date|month|week|time|datetime-local|number|range|color/i.test(formElement.type))) {
            var stringKeys = stringKey(formElement.name, formElement.value);
            hash = Form.extend(hash, stringKeys);
          }
        }

        return hash;
      }
    }, {
      key: "extend",
      value: function extend() {
        var extended = {};
        var i = 0; // Merge the object into the extended object

        var merge = function merge(obj) {
          for (var prop in obj) {
            if (obj.hasOwnProperty(prop)) {
              // If property is an object, merge properties
              if (Object.prototype.toString.call(obj[prop]) === '[object Object]') {
                extended[prop] = Form.extend(extended[prop], obj[prop]);
              } else {
                extended[prop] = obj[prop];
              }
            }
          }
        }; // Loop through each object and conduct a merge


        for (; i < arguments.length; i++) {
          merge(arguments[i]);
        }

        return extended;
      }
    }]);

    return Form;
  }();

  var Currency = /*#__PURE__*/function () {
    function Currency() {
      _classCallCheck(this, Currency);
    }

    _createClass(Currency, null, [{
      key: "formatMoney",
      value:
      /**
       * Format money values based on your shop currency settings
       *
       * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents or 3.00 dollars
       * @param  {String} format - shop money_format setting
       * @return {String} value - formatted value
       */
      function formatMoney(cents, format) {
        if (typeof cents === 'string') {
          cents = cents.replace('.', '');
        }

        var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
            formatString = format || '${{amount}}';

        function defaultTo(value, defaultValue) {
          return value == null || value !== value ? defaultValue : value;
        }

        function formatWithDelimiters(number, precision, thousands, decimal) {
          precision = defaultTo(precision, 2);
          thousands = defaultTo(thousands, ',');
          decimal = defaultTo(decimal, '.');

          if (isNaN(number) || number == null) {
            return 0;
          }

          number = (number / 100.0).toFixed(precision);
          var parts = number.split('.'),
              dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
              centsAmount = parts[1] ? decimal + parts[1] : '';
          return dollarsAmount + centsAmount;
        }

        var value = '';

        switch (formatString.match(placeholderRegex)[1]) {
          case 'amount':
            value = formatWithDelimiters(cents, 2);
            break;

          case 'amount_no_decimals':
            value = formatWithDelimiters(cents, 0);
            break;

          case 'amount_with_space_separator':
            value = formatWithDelimiters(cents, 2, ' ', '.');
            break;

          case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(cents, 0, ',', '.');
            break;

          case 'amount_no_decimals_with_space_separator':
            value = formatWithDelimiters(cents, 0, ' ');
            break;

          case 'amount_with_comma_separator':
            value = formatWithDelimiters(cents, 2, '.', ',');
            break;
        }

        if (formatString.indexOf('with_comma_separator') !== -1) {
          return formatString.replace(placeholderRegex, value).replace(',00', '');
        } else {
          return formatString.replace(placeholderRegex, value).replace('.00', '');
        }
      }
    }]);

    return Currency;
  }();

  var VariantSelector = /*#__PURE__*/function () {
    function VariantSelector(element, parentProductVariants) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      _classCallCheck(this, VariantSelector);

      this.element = element;
      this.parentProductVariants = parentProductVariants;
      this.delegateElement = new domDelegate.Delegate(this.element);
      this.activator = options['activator'] || document.querySelector("[aria-controls=\"".concat(element.getAttribute('id'), "\"]"));

      this.onValueChangedCallback = options['onValueChanged'] || function () {};

      this.isOpen = false;
      this.pageOverlayElement = document.querySelector('.PageOverlay');
      this.variantChoiceList = Dom.nodeListToArray(this.element.querySelectorAll('.VariantSelector__Choice'));
      this.variantCarousel = new Carousel(this.element.querySelector('.VariantSelector__Carousel'), {
        onSelect: this._variantChanged.bind(this),
        onClick: this._variantSelected.bind(this)
      });

      this._attachListeners();
    }

    _createClass(VariantSelector, [{
      key: "destroy",
      value: function destroy() {
        this.element.removeEventListener('keyup', this._handleKeyboardListener);
        this.delegateElement.off('click');
        this.activator.removeEventListener('click', this._toggleListener);
        this.variantCarousel.destroy();
      }
    }, {
      key: "toggle",
      value: function toggle() {
        this.isOpen ? this.close() : this.open();
      }
    }, {
      key: "open",
      value: function open() {
        if (this.isOpen) {
          return;
        }

        this.element.setAttribute('aria-hidden', 'false');
        this.activator.setAttribute('aria-expanded', 'true');
        Accessibility.trapFocus(this.element, 'variant-selector');
        document.documentElement.classList.add('no-scroll'); // Prevent scrolling when popover is open

        this.element.setAttribute('style', '');
        this.pageOverlayElement.classList.add('is-visible');
        this.pageOverlayElement.addEventListener('click', this._closeListener);
        this.isOpen = true;
      }
    }, {
      key: "close",
      value: function close() {
        if (!this.isOpen) {
          return;
        }

        this.element.setAttribute('aria-hidden', 'true');
        this.activator.setAttribute('aria-expanded', 'false');
        Accessibility.removeTrapFocus(this.element, 'variant-selector');
        document.documentElement.classList.remove('no-scroll');
        this.pageOverlayElement.classList.remove('is-visible');
        this.pageOverlayElement.removeEventListener('click', this._closeListener);
        this.isOpen = false;
      }
    }, {
      key: "_attachListeners",
      value: function _attachListeners() {
        this._handleKeyboardListener = this._handleKeyboard.bind(this);
        this._closeListener = this.close.bind(this);
        this._toggleListener = this.toggle.bind(this);
        this.element.addEventListener('keyup', this._handleKeyboardListener);
        this.activator.addEventListener('click', this._toggleListener);
        this.delegateElement.on('click', '[data-action="select-variant"]', this._onVariantSelect.bind(this));
        this.parentProductVariants.delegateElement.on('variant:changed', this._onVariantChanged.bind(this));
      }
      /**
       * Called when the variant is changed (but not yet selected)
       */

    }, {
      key: "_variantChanged",
      value: function _variantChanged(selectedIndex) {
        var activeChoice = this.variantChoiceList[selectedIndex];
        activeChoice.classList.add('is-selected');
        Dom.getSiblings(activeChoice, '.is-selected').forEach(function (item) {
          return item.classList.remove('is-selected');
        });
      }
      /**
       * Called when a variant is clicked or selected
       */

    }, {
      key: "_variantSelected",
      value: function _variantSelected(cellElement, cellIndex) {
        if (this.variantCarousel.getSelectedIndex() === cellIndex) {
          this.onValueChangedCallback(cellElement.getAttribute('data-option-value'), cellElement, this.activator);
          this.close();
        } else {
          this.variantCarousel.selectCell(cellIndex);
        }
      }
    }, {
      key: "_onVariantChanged",
      value: function _onVariantChanged(event) {
        var _this = this;

        var selectedVariant = event.detail.variant,
            imageWrapperElements = this.element.querySelectorAll('.VariantSelector__ImageWrapper'),
            found = false;
        Dom.nodeListToArray(imageWrapperElements).forEach(function (image) {
          var colorPosition = parseInt(image.parentElement.getAttribute('data-option-position')) - 1,
              combinationExcludedColor = '';
          selectedVariant.options.forEach(function (optionValue, index) {
            if (index !== colorPosition) {
              combinationExcludedColor += optionValue;
            }
          });

          if (image.getAttribute('data-variant-title') === combinationExcludedColor) {
            image.setAttribute('aria-hidden', 'false');
            found = true;
          } else {
            image.setAttribute('aria-hidden', 'true');
          }
        });

        if (!found) {
          imageWrapperElements.children[0].setAttribute('aria-hidden', 'false');
        }

        var foundColorIndex = 0;
        Dom.nodeListToArray(this.element.querySelectorAll('.VariantSelector__ChoicePrice')).forEach(function (priceElement, index) {
          var colorPosition = parseInt(priceElement.getAttribute('data-color-position')) - 1;

          _this.parentProductVariants.productData['variants'].forEach(function (variant) {
            var matchOptionsExcludedColor = true;
            variant['options'].forEach(function (option, index) {
              if (index !== colorPosition) {
                if (variant['options'][index] !== selectedVariant['options'][index]) {
                  matchOptionsExcludedColor = false;
                }
              }
            });

            if (matchOptionsExcludedColor && variant['options'][colorPosition] === selectedVariant['options'][colorPosition]) {
              if (foundColorIndex++ === index) {
                priceElement.innerHTML = "<span class=\"Heading Text--subdued\">".concat(Currency.formatMoney(variant['price'], window.theme.moneyFormat), "</span>");
              }
            }
          });
        });
      }
      /**
       * Called when the button "choose this variant" is explicitly clicked
       */

    }, {
      key: "_onVariantSelect",
      value: function _onVariantSelect() {
        var selectedCell = this.variantCarousel.flickityInstance.selectedCell.element;
        this.onValueChangedCallback(selectedCell.getAttribute('data-option-value'), selectedCell, this.activator);
        this.close();
      }
      /**
       * Handle a11y events
       */

    }, {
      key: "_handleKeyboard",
      value: function _handleKeyboard(event) {
        if (this.isOpen && event.keyCode === 27) {
          this.close();
        }
      }
    }]);

    return VariantSelector;
  }();

  /**
   * Handle the store availability management. The parameter is the div that will hold the content. The function
   * "updateWithVariant" must be called whenever the variant is changed.
   */

  var StoreAvailability = /*#__PURE__*/function () {
    function StoreAvailability(element, productTitle) {
      _classCallCheck(this, StoreAvailability);

      this.element = element;
      this.productTitle = productTitle;
    }

    _createClass(StoreAvailability, [{
      key: "updateWithVariant",
      value: function updateWithVariant(variant) {
        if (!this.element) {
          return; // If the element to inject the store availability does not exist, we return immediately
        } // If the variant is null (for instance unavailable variant), we clear the container


        if (!variant) {
          this.element.textContent = '';
          return;
        } // If we have a new variant we render the section


        this._renderAvailabilitySection(variant['id']);
      }
    }, {
      key: "_renderAvailabilitySection",
      value: function _renderAvailabilitySection(id) {
        var _this = this;

        // First we clear the previous content
        this.element.innerHTML = ''; // If there is already an element with the given modal we remove it first

        var availabilityModal = document.getElementById("StoreAvailabilityModal-".concat(id));

        if (availabilityModal) {
          availabilityModal.remove();
        }

        return fetch("".concat(window.routes.rootUrlWithoutSlash, "/variants/").concat(id, "?section_id=store-availability")).then(function (response) {
          return response.text().then(function (content) {
            _this.element.innerHTML = content;
            _this.element.innerHTML = _this.element.firstElementChild.innerHTML; // The product title is not rendered so we have to render it manually

            var productTitle = _this.element.querySelector('.store-availabilities-modal__product-title');

            if (productTitle) {
              productTitle.textContent = _this.productTitle;
            } // In order for our modal system to work we have to append the modal to the body instead


            var availabilityModal = document.getElementById("StoreAvailabilityModal-".concat(id));
            document.body.appendChild(availabilityModal); // Create the drawer

            new Drawer(availabilityModal);
          });
        });
      }
    }]);

    return StoreAvailability;
  }();

  var ProductVariants = /*#__PURE__*/function () {
    function ProductVariants(container, options) {
      var _this = this;

      _classCallCheck(this, ProductVariants);

      this.element = container;
      this.delegateElement = new domDelegate.Delegate(this.element);
      this.options = options;
      var jsonData = JSON.parse(this.element.querySelector('[data-product-json]').innerHTML);
      this.productData = jsonData['product'];
      this.variantsInventories = jsonData['inventories'] || {};
      this.masterSelector = this.element.querySelector("#product-select-".concat(this.productData['id'])); // We init value with the first selected variant

      this.productData['variants'].forEach(function (variant) {
        if (variant['id'] === jsonData['selected_variant_id']) {
          _this.currentVariant = variant;
          _this.option1 = variant['option1'];
          _this.option2 = variant['option2'];
          _this.option3 = variant['option3'];
        }
      });
      this.storeAvailability = new StoreAvailability(this.element.querySelector('.ProductMeta__StoreAvailabilityContainer'), this.productData['title']);
      this.storeAvailability.updateWithVariant(this.currentVariant);

      this._attachListeners();

      this._createSelectors();
    }

    _createClass(ProductVariants, [{
      key: "destroy",
      value: function destroy() {
        this.delegateElement.off('click');
        this.formPopovers.forEach(function (popover) {
          return popover.destroy();
        });
        this.formVariantSelectors.forEach(function (selector) {
          return selector.destroy();
        });
      }
    }, {
      key: "_attachListeners",
      value: function _attachListeners() {
        this.delegateElement.on('click', '[data-action="add-to-cart"]', this._addToCart.bind(this));
        this.delegateElement.on('click', '[data-action="decrease-quantity"]', this._decreaseQuantity.bind(this));
        this.delegateElement.on('click', '[data-action="increase-quantity"]', this._increaseQuantity.bind(this));
        this.delegateElement.on('change', '[name="quantity"]', this._validateQuantity.bind(this)); // Hook when a radio button change

        this.delegateElement.on('change', '.ProductForm__Option [type="radio"]', this._onOptionChanged.bind(this));
      }
      /**
       * Selectors can either be popovers or dedicated variant selectors. We therefore pre-create them all here
       */

    }, {
      key: "_createSelectors",
      value: function _createSelectors() {
        var _this2 = this;

        // Create the instances for each selector
        this.formPopovers = [];
        this.formVariantSelectors = [];
        Dom.nodeListToArray(this.element.querySelectorAll('.OptionSelector')).forEach(function (item) {
          var popover = new Popover(item, {
            preferredPosition: 'left',
            onValueChanged: _this2._onOptionChanged.bind(_this2)
          });

          _this2.formPopovers.push(popover);
        });
        Dom.nodeListToArray(this.element.querySelectorAll('.VariantSelector')).forEach(function (item) {
          var variantSelector = new VariantSelector(item, _this2, {
            onValueChanged: _this2._onOptionChanged.bind(_this2)
          });

          _this2.formVariantSelectors.push(variantSelector);
        });
      }
      /**
       * ---------------------------------------------------------------------------------------------------
       * CODE THAT HANDLE VARIANT CHANGES IN THE FRONT
       *
       * Please note that this code is highly dependant on the markup and classes, so make sure to NOT
       * edit this code
       * ---------------------------------------------------------------------------------------------------
       */

      /**
       * This callback is called whenever the variant changes and allows to update data about the active variant
       */

    }, {
      key: "_onVariantChanged",
      value: function _onVariantChanged(previousVariant, newVariant) {
        // 1st: the prices
        this._updateProductPrices(newVariant, previousVariant); // 2nd: update inventory


        this._updateInventory(newVariant, previousVariant); // 3rd: update SKU


        this._updateSku(newVariant, previousVariant); // 4th: update the price measurement


        this._updateUnitPrice(newVariant, previousVariant); // 5th: the add to cart button


        this._updateAddToCartButton(newVariant, previousVariant); // 6th: store availability


        this.storeAvailability.updateWithVariant(newVariant); // Finally, we send an event so that other system could hook and do their own logic

        this.element.dispatchEvent(new CustomEvent('variant:changed', {
          bubbles: true,
          detail: {
            variant: newVariant,
            previousVariant: previousVariant
          }
        }));
      }
      /**
       * Update the prices (optionally showing compare at price)
       */

    }, {
      key: "_updateProductPrices",
      value: function _updateProductPrices(newVariant, previousVariant) {
        var productMetaPrices = this.element.querySelector('.ProductMeta__PriceList'),
            currencyFormat = window.theme.currencyCodeEnabled ? window.theme.moneyWithCurrencyFormat : window.theme.moneyFormat;

        if (!newVariant) {
          productMetaPrices.style.display = 'none';
        } else {
          if (previousVariant && previousVariant['price'] === newVariant['price'] && previousVariant['compare_at_price'] === newVariant['compare_at_price']) {
            return; // The price do not have changed so let's return to avoid changing the DOM for nothing
          }

          productMetaPrices.innerHTML = '';

          if (newVariant['compare_at_price'] > newVariant['price']) {
            productMetaPrices.innerHTML += "<span class=\"ProductMeta__Price Price Price--highlight Text--subdued u-h4\" data-money-convertible>".concat(Currency.formatMoney(newVariant['price'], currencyFormat), "</span>");
            productMetaPrices.innerHTML += "<span class=\"ProductMeta__Price Price Price--compareAt Text--subdued u-h4\" data-money-convertible>".concat(Currency.formatMoney(newVariant['compare_at_price'], currencyFormat), "</span>");
          } else {
            productMetaPrices.innerHTML += "<span class=\"ProductMeta__Price Price Text--subdued u-h4\" data-money-convertible>".concat(Currency.formatMoney(newVariant['price'], currencyFormat), "</span>");
          }

          productMetaPrices.style.display = '';
        }
      }
      /**
       * Update the inventory (if needed)
       */

    }, {
      key: "_updateInventory",
      value: function _updateInventory(newVariant) {
        if (!this.options['showInventoryQuantity']) {
          return;
        }

        var productFormInventory = this.element.querySelector('.ProductForm__Inventory'),
            variantInventory = newVariant ? this.variantsInventories[newVariant['id']] : null;

        if (!newVariant || null === variantInventory['inventory_management'] || variantInventory['inventory_quantity'] <= 0 || this.options['inventoryQuantityThreshold'] > 0 && variantInventory['inventory_quantity'] > this.options['inventoryQuantityThreshold']) {
          productFormInventory.style.display = 'none';
        } else {
          productFormInventory.innerHTML = variantInventory['inventory_message'];
          productFormInventory.style.display = '';
        }
      }
      /**
       * Update the SKU
       */

    }, {
      key: "_updateSku",
      value: function _updateSku(newVariant) {
        if (!this.options['showSku'] || !newVariant) {
          return;
        }

        var productSkuNumber = this.element.querySelector('.ProductMeta__SkuNumber');

        if (productSkuNumber && newVariant['sku']) {
          productSkuNumber.innerText = newVariant['sku'];
        }
      }
      /**
       * Update the unit price
       */

    }, {
      key: "_updateUnitPrice",
      value: function _updateUnitPrice(newVariant) {
        if (!newVariant) {
          return;
        }

        var unitPriceMeasurement = this.element.querySelector('.ProductMeta__UnitPriceMeasurement');

        if (!newVariant.hasOwnProperty('unit_price')) {
          unitPriceMeasurement.style.display = 'none';
          return;
        }

        unitPriceMeasurement.style.display = 'block';
        unitPriceMeasurement.querySelector('.UnitPriceMeasurement__Price').innerHTML = Currency.formatMoney(newVariant['unit_price'], window.theme.moneyFormat);
        unitPriceMeasurement.querySelector('.UnitPriceMeasurement__ReferenceUnit').textContent = newVariant['unit_price_measurement']['reference_unit'];
        var unitPriceReferenceValue = unitPriceMeasurement.querySelector('.UnitPriceMeasurement__ReferenceValue');
        unitPriceReferenceValue.textContent = newVariant['unit_price_measurement']['reference_value'];
        unitPriceReferenceValue.style.display = newVariant['unit_price_measurement']['reference_value'] === 1 ? 'none' : 'inline';
      }
      /**
       * Update the add to cart
       */

    }, {
      key: "_updateAddToCartButton",
      value: function _updateAddToCartButton(newVariant) {
        var addToCartButton = this.element.querySelector('.ProductForm__AddToCart'),
            shopifyPaymentButton = this.element.querySelector('.shopify-payment-button');

        if (addToCartButton) {
          addToCartButton.classList.remove('Button--secondary');
          addToCartButton.classList.remove('Button--primary');

          if (!newVariant) {
            addToCartButton.setAttribute('disabled', 'disabled');
            addToCartButton.removeAttribute('data-action');
            addToCartButton.classList.add('Button--secondary');
            addToCartButton.innerHTML = window.languages.productFormUnavailable;
          } else {
            if (newVariant['available']) {
              addToCartButton.removeAttribute('disabled');
              addToCartButton.classList.add(addToCartButton.getAttribute('data-use-primary-button') === 'true' ? 'Button--primary' : 'Button--secondary');
              addToCartButton.setAttribute('data-action', 'add-to-cart');

              if (undefined === this.options['showPriceInButton'] || this.options['showPriceInButton']) {
                addToCartButton.innerHTML = "\n            <span>".concat(window.languages.productFormAddToCart, "</span>\n            <span class=\"Button__SeparatorDot\"></span>\n            <span data-money-convertible>").concat(Currency.formatMoney(newVariant['price'], window.theme.moneyFormat), "</span>\n          ");
              } else {
                // use title from data-title, if any
                let dataTitle = addToCartButton.getAttribute('data-title');
                if (dataTitle) {
                  addToCartButton.innerHTML = "<span>".concat(dataTitle, "</span>");
                } else {
                  addToCartButton.innerHTML = "<span>".concat(window.languages.productFormAddToCart, "</span>");
                }
              }
            } else {
              addToCartButton.setAttribute('disabled', 'disabled');
              addToCartButton.classList.add('Button--secondary');
              addToCartButton.removeAttribute('data-action');
              addToCartButton.innerHTML = window.languages.productFormSoldOut;
            }
          }
        }

        if (this.options['showPaymentButton'] && shopifyPaymentButton) {
          if (!newVariant || !newVariant['available']) {
            shopifyPaymentButton.style.display = 'none';
          } else {
            shopifyPaymentButton.style.display = 'block';
          }
        }
      }
      /**
       * ---------------------------------------------------------------------------------------------------
       * INTERNAL CODE THAT HANDLE VARIANT CHANGES
       * ---------------------------------------------------------------------------------------------------
       */

      /**
       * Whenever an option is changed, this code fetch the corresponding active variant
       */

    }, {
      key: "_onOptionChanged",
      value: function _onOptionChanged(newValue, target, activator) {
        // We change the value associated with the activator, and check if we have a color swatch
        if (activator) {
          this['option' + target.getAttribute('data-option-position')] = newValue;
          activator.querySelector('.ProductForm__SelectedValue').innerHTML = newValue;
        } else {
          this['option' + target.getAttribute('data-option-position')] = target.value;
          var selectedValue = target.closest('.ProductForm__Option').querySelector('.ProductForm__SelectedValue');

          if (selectedValue) {
            selectedValue.innerHTML = target.value;
          }
        } // Finally, we get the new variant


        var previousVariant = this.currentVariant;
        this.currentVariant = this._getCurrentVariantFromOptions();

        this._onVariantChanged(previousVariant, this.currentVariant);

        if (this.currentVariant) {
          if (this.options['enableHistoryState']) {
            this._updateHistoryState(this.currentVariant);
          } // We need to modify the hidden select that contain the id attribute as well


          this.masterSelector.querySelector('[selected]').removeAttribute('selected');
          this.masterSelector.querySelector("[value=\"".concat(this.currentVariant['id'], "\"]")).setAttribute('selected', 'selected');
          this.masterSelector.dispatchEvent(new Event('change', {
            bubbles: true
          }));
        }
      }
      /**
       * Get the active variant based on the options
       */

    }, {
      key: "_getCurrentVariantFromOptions",
      value: function _getCurrentVariantFromOptions() {
        var _this3 = this;

        var found = false;
        this.productData['variants'].forEach(function (variant) {
          if (variant['option1'] === _this3.option1 && variant['option2'] === _this3.option2 && variant['option3'] === _this3.option3) {
            found = variant;
          }
        });
        return found || null;
      }
      /**
       * Update the history state for browsers that support it
       */

    }, {
      key: "_updateHistoryState",
      value: function _updateHistoryState(variant) {
        if (!history.replaceState) {
          return;
        }

        var newUrl = "".concat(window.location.protocol, "//").concat(window.location.host).concat(window.location.pathname, "?variant=").concat(variant.id);
        window.history.replaceState({
          path: newUrl
        }, '', newUrl);
      }
      /**
       * ---------------------------------------------------------------------------------------------------
       * INTERNAL CODE THAT HANDLE PRODUCT ADD TO CART
       * ---------------------------------------------------------------------------------------------------
       */

    }, {
      key: "_addToCart",
      value: function _addToCart(event) {
        var _this4 = this;

        if (!this.options['useAjaxCart']) {
          return; // When using a cart type of page, we just simply redirect to the cart page
        }

        event.preventDefault(); // Prevent form to be submitted

        var addToCartButton = this.element.querySelector('.ProductForm__AddToCart'); // First, we switch the status of the button

        addToCartButton.setAttribute('disabled', 'disabled');
        document.dispatchEvent(new CustomEvent('theme:loading:start')); // Then we add the product in Ajax

        var formElement = this.element.querySelector('form[action*="/cart/add"]');
        fetch("".concat(window.routes.cartAddUrl, ".js"), {
          body: JSON.stringify(Form.serialize(formElement)),
          credentials: 'same-origin',
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header

          }
        }).then(function (response) {
          document.dispatchEvent(new CustomEvent('theme:loading:end'));
          var quantityElement = formElement.querySelector('[name="quantity"]');

          if (response.ok) {
            addToCartButton.removeAttribute('disabled'); // We simply trigger an event so the mini-cart can re-render

            _this4.element.dispatchEvent(new CustomEvent('product:added', {
              bubbles: true,
              detail: {
                variant: _this4.currentVariant,
                quantity: quantityElement ? parseInt(quantityElement.value) : 1
              }
            }));
          } else {
            response.json().then(function (content) {
              var errorMessageElement = document.createElement('span');
              errorMessageElement.className = 'ProductForm__Error Alert Alert--error';
              errorMessageElement.innerHTML = content['description'];
              addToCartButton.removeAttribute('disabled');
              addToCartButton.insertAdjacentElement('afterend', errorMessageElement);
              setTimeout(function () {
                errorMessageElement.remove();
              }, 2500);
            });
          }
        });
        event.preventDefault();
      }
      /**
       * ---------------------------------------------------------------------------------------------------
       * OTHER
       * ---------------------------------------------------------------------------------------------------
       */

      /**
       * When using the quantity selector, this can be used to decrease the quantity (be ensuring it won't be lower than 1)
       */

    }, {
      key: "_decreaseQuantity",
      value: function _decreaseQuantity(event, target) {
        target.nextElementSibling.value = Math.max(parseInt(target.nextElementSibling.value) - 1, 1);
      }
      /**
       * When using the quantity selector, this can be used to increase the quantity
       */

    }, {
      key: "_increaseQuantity",
      value: function _increaseQuantity(event, target) {
        target.previousElementSibling.value = parseInt(target.previousElementSibling.value) + 1;
      }
      /**
       * Make sure the quantity does not go below when manually changed
       */

    }, {
      key: "_validateQuantity",
      value: function _validateQuantity(event, target) {
        target.value = Math.max(parseInt(target.value) || 1, 1);
      }
    }]);

    return ProductVariants;
  }();

  var ProductVideo = /*#__PURE__*/function () {
    function ProductVideo(element, stackProductImages, enableVideoLooping) {
      _classCallCheck(this, ProductVideo);

      this.element = element;
      this.delegateElement = new domDelegate.Delegate(this.element);
      this.stackProductImages = stackProductImages;
      this.enableVideoLooping = enableVideoLooping;
      this.player = null;

      switch (this.element.getAttribute('data-media-type')) {
        case 'video':
          var stylesheet = document.createElement('link');
          stylesheet.rel = 'stylesheet';
          stylesheet.href = 'https://cdn.shopify.com/shopifycloud/shopify-plyr/v1.0/shopify-plyr.css';
          document.head.appendChild(stylesheet);
          window.Shopify.loadFeatures([{
            name: 'video-ui',
            version: '1.0',
            onLoad: this._setupHtml5Video.bind(this)
          }]);
          break;

        case 'external_video':
          this._setupExternalVideo();

          break;
      }
    }

    _createClass(ProductVideo, [{
      key: "destroy",
      value: function destroy() {
        if (this.player) {
          this.player.destroy(); // Both Plyr and YouTube API use the same name
        }
      }
    }, {
      key: "hasBeenSelected",
      value: function hasBeenSelected() {
        // As per guidelines, we only need to autoplay when it's not a touch device
        if (Responsive.matchesBreakpoint('supports-hover')) {
          this.play();
        }
      }
    }, {
      key: "hasBeenDeselected",
      value: function hasBeenDeselected() {
        this.pause();
      }
    }, {
      key: "play",
      value: function play() {
        switch (this.element.getAttribute('data-media-type')) {
          case 'video':
            this.player.play();
            break;

          case 'external_video':
            this.player.playVideo();
            break;
        }
      }
    }, {
      key: "pause",
      value: function pause() {
        switch (this.element.getAttribute('data-media-type')) {
          case 'video':
            this.player.pause();
            break;

          case 'external_video':
            this.player.pauseVideo();
            break;
        }
      }
    }, {
      key: "_setupHtml5Video",
      value: function _setupHtml5Video() {
        var _this = this;

        this.player = new Shopify.Plyr(this.element.querySelector('video'), {
          controls: ['play', 'progress', 'mute', 'volume', 'play-large', 'fullscreen'],
          loop: {
            active: this.enableVideoLooping
          },
          hideControlsOnPause: true,
          clickToPlay: true,
          iconUrl: '//cdn.shopify.com/shopifycloud/shopify-plyr/v1.0/shopify-plyr.svg',
          tooltips: {
            controls: false,
            seek: true
          }
        });
        this.player.on('play', function () {
          _this.element.dispatchEvent(new CustomEvent('video:played', {
            bubbles: true
          }));
        });
        this.player.on('pause', function () {
          _this.element.dispatchEvent(new CustomEvent('video:paused', {
            bubbles: true
          }));
        });
      }
    }, {
      key: "_setupExternalVideo",
      value: function _setupExternalVideo() {
        if (this.element.getAttribute('data-video-host') === 'youtube') {
          this._loadYouTubeScript().then(this._setupYouTubePlayer.bind(this));
        }
      }
    }, {
      key: "_setupYouTubePlayer",
      value: function _setupYouTubePlayer() {
        var _this2 = this;

        var playerLoadingInterval = setInterval(function () {
          if (window.YT !== undefined && window.YT.Player !== undefined) {
            _this2.player = new YT.Player(_this2.element.querySelector('iframe'), {
              videoId: _this2.element.getAttribute('data-video-id'),
              events: {
                onStateChange: function onStateChange(event) {
                  if (event.data === window.YT.PlayerState.PLAYING) {
                    _this2.element.dispatchEvent(new CustomEvent('video:played', {
                      bubbles: true
                    }));
                  } else if (event.data === YT.PlayerState.PAUSED) {
                    _this2.element.dispatchEvent(new CustomEvent('video:paused', {
                      bubbles: true
                    }));
                  }

                  if (event.data === window.YT.PlayerState.ENDED && _this2.enableVideoLooping) {
                    event.target.seekTo(0);
                  }
                }
              }
            });
            clearInterval(playerLoadingInterval);
          }
        }, 50);
      }
    }, {
      key: "_loadYouTubeScript",
      value: function _loadYouTubeScript() {
        return new Promise(function (resolve, reject) {
          var script = document.createElement('script');
          document.body.appendChild(script);
          script.onload = resolve;
          script.onerror = reject;
          script.async = true;
          script.src = '//www.youtube.com/iframe_api';
        });
      }
    }]);

    return ProductVideo;
  }();

  /**
   * This code has been heavily inspired by this: https://kitaitimakoto.gitlab.io/scrollspy-example/index.en.html#whatsthis
   */
  var ScrollSpy = /*#__PURE__*/function () {
    function ScrollSpy(container, elementsToSpy, observerOptions) {
      var _this = this;

      _classCallCheck(this, ScrollSpy);

      this.container = container;
      this.targets = [];
      this.targetIndices = {};
      this.indicesInViewPort = [];
      this.observer = new IntersectionObserver(this._onIntersectionChange.bind(this), observerOptions);
      elementsToSpy.forEach(function (elementToSpy, index) {
        _this.targets.push(elementToSpy);

        _this.targetIndices[elementToSpy.id] = index;

        _this.observer.observe(elementToSpy);
      });
    }

    _createClass(ScrollSpy, [{
      key: "destroy",
      value: function destroy() {
        this.observer.disconnect();
      }
      /**
       * Called whenever there is a change of visibility
       */

    }, {
      key: "_onIntersectionChange",
      value: function _onIntersectionChange(changes) {
        var oldTargetIndex = this.indicesInViewPort[0] || 0;

        for (var i = changes.length - 1; i >= 0; i--) {
          this._updateIndicesInViewPort(changes[i], oldTargetIndex);
        } // Firefox generates duplicates so make sure to remove


        this.indicesInViewPort = this.indicesInViewPort.filter(function (value, index, self) {
          return self.indexOf(value) === index;
        });

        if (this.indicesInViewPort.length === 0 || oldTargetIndex === this.indicesInViewPort[0]) {
          return;
        }

        var event = new CustomEvent('scrollspy:target:changed', {
          detail: {
            newTarget: this.targets[this.indicesInViewPort[0]],
            oldTarget: this.targets[oldTargetIndex]
          }
        });
        this.container.dispatchEvent(event);
      }
      /**
       * Update indices visible in the view port
       */

    }, {
      key: "_updateIndicesInViewPort",
      value: function _updateIndicesInViewPort(change, oldTargetIndex) {
        var index = this.targetIndices[change.target.id];

        if (change.intersectionRatio === 0) {
          var indexInViewPort = this.indicesInViewPort.indexOf(index);

          if (indexInViewPort !== -1) {
            this.indicesInViewPort.splice(indexInViewPort, 1);
          }
        } else {
          if (index < oldTargetIndex) {
            this.indicesInViewPort.unshift(index);
          } else if (index > this.indicesInViewPort[this.indicesInViewPort.length - 1]) {
            this.indicesInViewPort.push(index);
          } else {
            this.indicesInViewPort.push(index);
            this.indicesInViewPort.sort();
          }
        }
      }
    }]);

    return ScrollSpy;
  }();

  var SearchBar = /*#__PURE__*/function () {
    function SearchBar() {
      _classCallCheck(this, SearchBar);

      this.documentDelegate = new domDelegate.Delegate(document.body);
      this.searchElement = document.getElementById('Search');
      this.searchInputElement = this.searchElement.querySelector('[name="q"]');
      this.searchResultsElement = this.searchElement.querySelector('.Search__Results');
      this.queryMap = {};
      this.isOpen = false;
      this.pageOverlayElement = document.querySelector('.PageOverlay');

      this._attachListeners();
    }

    _createClass(SearchBar, [{
      key: "destroy",
      value: function destroy() {
        this.searchInputElement.removeEventListener('keydown', this._preventSubmissionListener);
        this.searchInputElement.removeEventListener('input', this._onInputListener);
        this.documentDelegate.off();
      }
    }, {
      key: "_attachListeners",
      value: function _attachListeners() {
        this._preventSubmissionListener = this._preventSubmission.bind(this);
        this._onInputListener = this._debounce(this._onInput.bind(this), 250);
        this.searchInputElement.addEventListener('keydown', this._preventSubmissionListener);
        this.searchInputElement.addEventListener('input', this._onInputListener);
        this.documentDelegate.on('click', '[data-action="toggle-search"]', this._toggleSearch.bind(this));
        this.documentDelegate.on('click', '[data-action="open-search"]', this._openSearch.bind(this));
        this.documentDelegate.on('click', '[data-action="close-search"]', this._closeSearch.bind(this));
        this.documentDelegate.on('search:close', this._closeSearch.bind(this)); // Allow for third-party elements to close the bar
      }
      /**
       * Toggle the search
       */

    }, {
      key: "_toggleSearch",
      value: function _toggleSearch(event) {
        if (this.isOpen) {
          this._closeSearch(event);
        } else {
          this._openSearch(event);
        }

        event.preventDefault();
      }
      /**
       * Open the search form and trap focus
       */

    }, {
      key: "_openSearch",
      value: function _openSearch() {
        var _this = this;

        this.searchElement.setAttribute('aria-hidden', 'false');
        document.documentElement.classList.add('no-scroll');
        Accessibility.trapFocus(this.searchElement, 'search', this.searchElement.querySelector('[name="q"]'));

        var onFocusListener = function onFocusListener() {
          _this.searchInputElement.focus();

          _this.searchElement.removeEventListener('transitionend', onFocusListener);
        };

        this.searchElement.addEventListener('transitionend', onFocusListener);
        this.isOpen = true;
        this.pageOverlayElement.classList.add('is-visible');
        document.querySelector('#shopify-section-header').style.zIndex = 10;
      }
      /**
       * Close the search form and clear focus
       */

    }, {
      key: "_closeSearch",
      value: function _closeSearch() {
        var _this2 = this;

        this.searchElement.setAttribute('aria-hidden', 'true');
        document.documentElement.classList.remove('no-scroll');
        Accessibility.removeTrapFocus(this.searchElement, 'search');
        this.isOpen = false;

        var onTransitionEnd = function onTransitionEnd(event) {
          if (event.propertyName === 'visibility') {
            document.querySelector('#shopify-section-header').style.zIndex = '';

            _this2.pageOverlayElement.removeEventListener('transitionend', onTransitionEnd);
          }
        };

        this.pageOverlayElement.addEventListener('transitionend', onTransitionEnd);
        this.pageOverlayElement.classList.remove('is-visible');
      }
      /**
       * In order to prevent an odd UX where hitting the enter always choose the product results, if the search is set to product + something else,
       * then we disable submission using enter key
       */

    }, {
      key: "_preventSubmission",
      value: function _preventSubmission(event) {
        if (event.keyCode === 13 && window.theme.searchMode !== 'product') {
          event.preventDefault();
        }
      }
      /**
       * This is called when the user has stopped typing (after debounce delay)
       */

    }, {
      key: "_onInput",
      value: function _onInput(event) {
        var _this3 = this;

        if (event.keyCode === 13) {
          return;
        } // Unfortunately, fetch does not support as of today cancelling a request. As a consequence what we do is that we manually
        // keep track of sent requests, and only use the results of the last one


        this.lastInputValue = event.target.value;

        if (this.lastInputValue === '') {
          this._resetSearch();

          return;
        }

        var queryOptions = {
          method: 'GET',
          credentials: 'same-origin'
        };
        var queries = [fetch("".concat(window.routes.searchUrl, "?section_id=predictive-search&q=").concat(encodeURIComponent(this.lastInputValue), "*&type=product"), queryOptions)];

        if (window.theme.searchMode !== 'product') {
          queries.push(fetch("".concat(window.routes.searchUrl, "?section_id=predictive-search&q=").concat(encodeURIComponent(this.lastInputValue), "*&type=").concat(window.theme.searchMode.replace('product,', '')), queryOptions));
        }

        this.queryMap[this.lastInputValue] = true;
        document.dispatchEvent(new CustomEvent('theme:loading:start'));
        Promise.all(queries).then(function (responses) {
          // If we receive the result for a query that is not the last one, we simply do not process the result
          if (_this3.lastInputValue !== event.target.value) {
            return;
          }

          delete _this3.queryMap[event.target.value];
          Promise.all(responses.map(function (response) {
            return response.text();
          })).then(function (contents) {
            // If we have only one content then we only have product, otherwise we have products and articles
            if (window.theme.searchMode === 'product') {
              _this3.searchResultsElement.innerHTML = contents[0];
            } else {
              _this3.searchResultsElement.innerHTML = "<div class=\"PageLayout PageLayout--breakLap\">\n              <div class=\"PageLayout__Section\">".concat(contents[0], "</div>\n              <div class=\"PageLayout__Section PageLayout__Section--secondary\">").concat(contents[1], "</div>\n            </div>");
            }

            _this3.searchResultsElement.setAttribute('aria-hidden', 'false');
          });
          document.dispatchEvent(new CustomEvent('theme:loading:end'));
        });
      }
    }, {
      key: "_resetSearch",
      value: function _resetSearch() {
        if (window.theme.searchMode === 'product') {
          this.searchResultsElement.innerHTML = '';
        } else {
          this.searchResultsElement.innerHTML = "<div class=\"PageLayout PageLayout--breakLap\">\n              <div class=\"PageLayout__Section\"></div>\n              <div class=\"PageLayout__Section PageLayout__Section--secondary\"></div>\n            </div>";
        }

        this.searchResultsElement.setAttribute('aria-hidden', 'true');
        document.dispatchEvent(new CustomEvent('theme:loading:end')); // Just in case
      }
      /**
       * Simple function that allows to debounce
       */

    }, {
      key: "_debounce",
      value: function _debounce(fn, delay) {
        var _this4 = this;

        var timer = null;
        return function () {
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          clearTimeout(timer);
          timer = setTimeout(function () {
            fn.apply(_this4, args);
          }, delay);
        };
      }
    }]);

    return SearchBar;
  }();

  var CountrySelector = /*#__PURE__*/function () {
    function CountrySelector(countrySelect, provinceSelect) {
      _classCallCheck(this, CountrySelector);

      this.countrySelect = countrySelect;
      this.provinceSelect = provinceSelect;

      if (this.countrySelect && this.provinceSelect) {
        this._attachListeners();

        this._initSelectors();
      }
    }

    _createClass(CountrySelector, [{
      key: "destroy",
      value: function destroy() {
        if (this.countrySelect) {
          this.countrySelect.removeEventListener('change', this._onCountryChangedListener);
        }
      }
    }, {
      key: "_initSelectors",
      value: function _initSelectors() {
        // Check first the default value of country
        var defaultCountry = this.countrySelect.getAttribute('data-default');

        if (defaultCountry) {
          for (var i = 0; i !== this.countrySelect.options.length; ++i) {
            if (this.countrySelect.options[i].text === defaultCountry) {
              this.countrySelect.selectedIndex = i;
              break;
            }
          }
        } else {
          this.countrySelect.selectedIndex = 0;
        }

        var event = new Event('change', {
          bubbles: true
        });
        this.countrySelect.dispatchEvent(event); // Then the province

        var defaultProvince = this.provinceSelect.getAttribute('data-default');

        if (defaultProvince) {
          for (var _i = 0; _i !== this.provinceSelect.options.length; ++_i) {
            if (this.provinceSelect.options[_i].text === defaultProvince) {
              this.provinceSelect.selectedIndex = _i;
              break;
            }
          }
        }
      }
    }, {
      key: "_attachListeners",
      value: function _attachListeners() {
        this._onCountryChangedListener = this._onCountryChanged.bind(this);
        this.countrySelect.addEventListener('change', this._onCountryChangedListener);
      }
    }, {
      key: "_onCountryChanged",
      value: function _onCountryChanged() {
        var _this = this;

        var selectedOption = this.countrySelect.options[this.countrySelect.selectedIndex],
            provinces = JSON.parse(selectedOption.getAttribute('data-provinces') || '[]'); // First remove all options

        this.provinceSelect.innerHTML = '';

        if (provinces.length === 0) {
          this.provinceSelect.parentNode.style.display = 'none';
          return;
        } // We need to build the provinces array


        provinces.forEach(function (data) {
          _this.provinceSelect.options.add(new Option(data[1], data[0]));
        });
        this.provinceSelect.parentNode.style.display = 'block';
      }
    }]);

    return CountrySelector;
  }();

  var ShippingEstimator = /*#__PURE__*/function () {
    function ShippingEstimator(element) {
      _classCallCheck(this, ShippingEstimator);

      this.element = element;
      this.delegateElement = new domDelegate.Delegate(this.element);
      this.countrySelector = new CountrySelector(this.element.querySelector('[name="country"]'), this.element.querySelector('[name="province"]'));

      this._attachListeners();
    }

    _createClass(ShippingEstimator, [{
      key: "onUnload",
      value: function onUnload() {
        this.delegateElement.off('click');
        this.countrySelector.destroy();
      }
    }, {
      key: "_attachListeners",
      value: function _attachListeners() {
        this.delegateElement.on('click', '.ShippingEstimator__Submit', this._fetchRates.bind(this));
      }
    }, {
      key: "_fetchRates",
      value: function _fetchRates() {
        var _this = this;

        var country = this.element.querySelector('[name="country"]').value,
            province = this.element.querySelector('[name="province"]').value,
            zip = this.element.querySelector('[name="zip"]').value;
        document.dispatchEvent(new CustomEvent('theme:loading:start'));
        fetch("".concat(window.routes.cartUrl, "/shipping_rates.json?shipping_address[zip]=").concat(zip, "&shipping_address[country]=").concat(country, "&shipping_address[province]=").concat(province), {
          credentials: 'same-origin',
          method: 'GET'
        }).then(function (response) {
          response.json().then(function (result) {
            document.dispatchEvent(new CustomEvent('theme:loading:end'));

            var resultsContainer = _this.element.querySelector('.ShippingEstimator__Results'),
                errorContainer = _this.element.querySelector('.ShippingEstimator__Error');

            if (response.ok) {
              var shippingRates = result['shipping_rates'];

              if (shippingRates.length === 0) {
                resultsContainer.innerHTML = "<p>".concat(window.languages.shippingEstimatorNoResults, "</p>");
              } else {
                var html = '';

                if (shippingRates.length === 1) {
                  html += "<p>".concat(window.languages.shippingEstimatorOneResult, "</p><ul>");
                } else {
                  html += "<p>".concat(window.languages.shippingEstimatorMoreResults.replace('{{count}}', shippingRates.length), "</p><ul>");
                }

                shippingRates.forEach(function (item) {
                  html += "<li>".concat(item['name'], ": ").concat(Currency.formatMoney(item['price'], window.theme.moneyFormat), "</li>");
                });
                html += '</ul>';
                resultsContainer.firstElementChild.innerHTML = html;
              }

              TweenLite.fromTo(resultsContainer.firstElementChild, 0.6, {
                autoAlpha: 0,
                y: -15
              }, {
                autoAlpha: 1,
                y: 0,
                delay: 0.35
              });
              errorContainer.style.display = 'none';
              resultsContainer.style.display = 'block';
              Animation.slideDown(resultsContainer);
            } else {
              var errorHtml = '';
              Object.keys(result).forEach(function (key) {
                errorHtml += "<li class=\"Alert__ErrorItem\">".concat(key, " ").concat(result[key], "</li>");
              });
              errorContainer.innerHTML = "<ul class=\"Alert__ErrorList\">".concat(errorHtml, "</ul>");
              resultsContainer.style.display = 'none';
              errorContainer.style.display = 'block';
            }
          });
        });
      }
    }]);

    return ShippingEstimator;
  }();

  var AddressesSection = function AddressesSection() {
    var _this = this;

    _classCallCheck(this, AddressesSection);

    this.countrySelectors = [];
    Dom.nodeListToArray(document.querySelectorAll('.Modal--address')).forEach(function (modal) {
      _this.countrySelectors.push(new CountrySelector(modal.querySelector('[name="address[country]"]'), modal.querySelector('[name="address[province]"]')));
    });
  };

  var ArticleList = /*#__PURE__*/function () {
    function ArticleList(container) {
      var _this = this;

      _classCallCheck(this, ArticleList);

      this.element = container;

      if (window.theme.showElementStaggering) {
        this.timeline = new TimelineLite({
          delay: window.theme.showPageTransition ? 0.5 : 0
        });
        this.intersectionObserver = new IntersectionObserver(this._reveal.bind(this));
        Dom.nodeListToArray(this.element.querySelectorAll('.ArticleItem')).forEach(function (item) {
          _this.intersectionObserver.observe(item);
        });
      }
    }

    _createClass(ArticleList, [{
      key: "onUnload",
      value: function onUnload() {
        if (window.theme.showElementStaggering) {
          this.intersectionObserver.disconnect();
          this.timeline.kill();
        }
      }
    }, {
      key: "_reveal",
      value: function _reveal(results) {
        var _this2 = this;

        var toReveal = [];
        results.forEach(function (result) {
          if (result.isIntersecting || result.intersectionRatio > 0) {
            // isIntersecting does not exist on Samsung Android browser
            toReveal.push(result.target);

            _this2.intersectionObserver.unobserve(result.target);
          }
        });

        if (toReveal.length === 0) {
          return;
        }

        this.timeline.staggerFromTo(toReveal, 0.45, {
          autoAlpha: 0,
          y: 30
        }, {
          autoAlpha: 1,
          y: 0
        }, 0.2);
      }
    }]);

    return ArticleList;
  }();

  var ArticleSection = /*#__PURE__*/function () {
    function ArticleSection(container) {
      var _this = this;

      _classCallCheck(this, ArticleSection);

      this.element = container;
      this.toolbarElement = this.element.querySelector('.ArticleToolbar');
      this.articleNavElement = this.element.querySelector('.ArticleNav');
      var articleImageElement = this.element.querySelector('.Article__Image');

      if (articleImageElement && window.matchMedia('(-moz-touch-enabled: 0), (hover: hover)').matches) {
        this.parallaxInstance = new Rellax('.Article__Image', {
          speed: -7,
          center: false,
          round: true
        });
      }

      if (window.theme.showElementStaggering) {
        this.timeline = new TimelineLite({
          delay: window.theme.showPageTransition ? 0.5 : 0
        });
        this.intersectionObserver = new IntersectionObserver(this._reveal.bind(this));
        Dom.nodeListToArray(this.element.querySelectorAll('.ArticleItem')).forEach(function (item) {
          _this.intersectionObserver.observe(item);
        });
      }

      this._attachListeners();
    }

    _createClass(ArticleSection, [{
      key: "onUnload",
      value: function onUnload() {
        if (this.parallaxInstance) {
          this.parallaxInstance.destroy();
        }

        if (window.theme.showElementStaggering) {
          this.intersectionObserver.disconnect();
          this.timeline.kill();
        }

        window.removeEventListener('scroll', this._onScrollListener);
      }
    }, {
      key: "_attachListeners",
      value: function _attachListeners() {
        this._onScrollListener = this._checkToolbarVisibility.bind(this);
        window.addEventListener('scroll', this._onScrollListener);
      }
    }, {
      key: "_checkToolbarVisibility",
      value: function _checkToolbarVisibility() {
        var _this2 = this;

        var lastYPosition = 0,
            headerHeight = 0,
            navBottom = 0,
            isFixedHeader = 0,
            header = document.querySelector('.Header');
        fastdom.measure(function () {
          lastYPosition = window.pageYOffset;
          headerHeight = header.offsetHeight;
          isFixedHeader = parseInt(window.getComputedStyle(document.body).getPropertyValue('--use-sticky-header') || 0);

          if (_this2.articleNavElement) {
            navBottom = _this2.articleNavElement.offsetTop + _this2.articleNavElement.clientHeight - headerHeight;
          }
        });
        fastdom.mutate(function () {
          _this2.toolbarElement.style.top = isFixedHeader ? headerHeight + 'px' : null;

          if (_this2.articleNavElement) {
            if (lastYPosition > 150 && _this2.articleNavElement && lastYPosition < navBottom) {
              _this2.toolbarElement.classList.add('is-visible');
            } else {
              _this2.toolbarElement.classList.remove('is-visible');
            }
          } else {
            if (lastYPosition > 150) {
              _this2.toolbarElement.classList.add('is-visible');
            } else {
              _this2.toolbarElement.classList.remove('is-visible');
            }
          }
        });
      }
    }, {
      key: "_reveal",
      value: function _reveal(results) {
        var _this3 = this;

        var toReveal = [];
        results.forEach(function (result) {
          if (result.isIntersecting || result.intersectionRatio > 0) {
            // isIntersecting does not exist on Samsung Android browser
            toReveal.push(result.target);

            _this3.intersectionObserver.unobserve(result.target);
          }
        });

        if (toReveal.length === 0) {
          return;
        }

        this.timeline.staggerFromTo(toReveal, 0.45, {
          autoAlpha: 0,
          y: 30
        }, {
          autoAlpha: 1,
          y: 0
        }, 0.2);
      }
    }]);

    return ArticleSection;
  }();

  var CartSection = /*#__PURE__*/function () {
    function CartSection(container) {
      _classCallCheck(this, CartSection);

      this.element = container;
      this.delegateElement = new domDelegate.Delegate(this.element);
      this.documentDelegate = new domDelegate.Delegate(document.documentElement);
      this.options = JSON.parse(this.element.getAttribute('data-section-settings'));
      this.itemCount = this.options['itemCount'];
      this.isCartNoteOpen = false;

      if (this.options['drawer']) {
        this.sidebarDrawer = new Drawer(this.element, {
          onClose: this._onDrawerClosed.bind(this)
        });
      }

      if (this.options['hasShippingEstimator']) {
        this.shippingEstimator = new ShippingEstimator(this.element.querySelector('.ShippingEstimator'));
      }

      this._attachListeners();
      this._customerForm();
    }

    _createClass(CartSection, [{
      key: "onUnload",
      value: function onUnload() {
        if (this.options['hasShippingEstimator']) {
          this.shippingEstimator.destroy();
        }

        this.delegateElement.off();
        document.removeEventListener('product:added', this._onProductAddedListener);
      }
    }, {
      key: "_attachListeners",
      value: function _attachListeners() {
        this._onProductAddedListener = this._onProductAdded.bind(this);
        this.delegateElement.on('change', '#cart-note', this._updateCartNote.bind(this));

        if (this.options['type'] !== 'page') {
          this.delegateElement.on('click', '[data-action="update-item-quantity"], [data-action="remove-item"]', this._updateItemQuantity.bind(this));
          this.delegateElement.on('change', '.QuantitySelector__CurrentQuantity', this._updateItemQuantity.bind(this));
        } else {
          this.delegateElement.on('change', '.QuantitySelector__CurrentQuantity', this._reloadPageWithQuantity.bind(this));
        } // We have some listeners that are specific to the fact it's a drawer or the dedicated cart page


        if (this.options['drawer']) {
          this.delegateElement.on('click', '[data-action="toggle-cart-note"]', this._toggleCartNote.bind(this));
        }

        document.addEventListener('product:added', this._onProductAddedListener); // We attach a listener at page level which allows to re-render the cart

        this.documentDelegate.on('cart:refresh', this._rerenderCart.bind(this, false));
      }
    }, {
      key: "_updateCartNote",
      value: function _updateCartNote(event, target) {
        fetch("".concat(window.routes.cartUrl, "/update.js"), {
          body: JSON.stringify({
            note: target.value
          }),
          credentials: 'same-origin',
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header

          }
        });
      }
    }, {
      key: "_toggleCartNote",
      value: function _toggleCartNote() {
        var _this = this;

        var noteContainer = this.element.querySelector('.Cart__OffscreenNoteContainer'),
            cartNote = this.element.querySelector('#cart-note');
        this.element.classList.toggle('has-note-open');
        this.element.querySelector('.Cart__NoteButton').innerHTML = cartNote.value !== '' ? window.languages.cartEditNote : window.languages.cartAddNote;
        noteContainer.setAttribute('aria-hidden', noteContainer.getAttribute('aria-hidden') === 'true' ? 'false' : 'true');
        this.isCartNoteOpen = noteContainer.getAttribute('aria-hidden') === 'false';

        if (this.element.classList.contains('has-note-open')) {
          var transitionEndListener = function transitionEndListener() {
            _this.element.querySelector('#cart-note').focus();

            noteContainer.removeEventListener('transitionend', transitionEndListener);
          };

          noteContainer.addEventListener('transitionend', transitionEndListener);
        }
      }
    }, {
      key: "_updateItemQuantity",
      value: function _updateItemQuantity(event, target) {
        var _this2 = this;

        document.dispatchEvent(new CustomEvent('theme:loading:start'));
        var quantity = null,
            elementToAnimate = null;

        if (target.tagName === 'INPUT') {
          quantity = parseInt(Math.max(parseInt(target.value) || 1, 1));
        } else {
          quantity = parseInt(target.getAttribute('data-quantity'));
        } // If the quantity is 0, then we will animate the product with a removal effect


        if (quantity === 0) {
          elementToAnimate = target.closest('.CartItemWrapper');
        }

        fetch("".concat(window.routes.cartChangeUrl, ".js"), {
          body: JSON.stringify({
            line: target.getAttribute('data-line'),
            quantity: quantity
          }),
          credentials: 'same-origin',
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header

          }
        }).then(function (cart) {
          cart.json().then(function (content) {

            // // Auto remove product

            // // (function(){
            //   var autoRemoveTriggerTag = ''
            //   console.log('DEBUG: 🐯🐯🐯🐯', content);
            //   // NOTE: can use this method, because here we can't check tags of products
            //   // need to be done after cart is rendered. so it will have double refresh effect
            // // }());

            _this2.itemCount = content['item_count'];

            _this2._rerenderCart(elementToAnimate);

            document.dispatchEvent(new CustomEvent('theme:loading:end'));

            // ClueEdit: for free cheapest product
            document.dispatchEvent(new CustomEvent('cart:item-quantity-updated'));

            // _this2._bogo();

          });
        });
        event.preventDefault();
      }
    }, {
      key: "_reloadPageWithQuantity",
      value: function _reloadPageWithQuantity(event, target) {
        window.location.href = "".concat(window.routes.cartChangeUrl, "?quantity=").concat(parseInt(target.value), "&line=").concat(target.getAttribute('data-line'));
      }
    }, {
      key: "_onProductAdded",
      value: function _onProductAdded(event) {
        var _this3 = this;

        this.itemCount += event.detail.quantity;

        this._rerenderCart().then(function () {
          _this3.sidebarDrawer.open();
        });
      }
    }, {
      key: "_onDrawerClosed",
      value: function _onDrawerClosed() {
        if (this.isCartNoteOpen) {
          this._toggleCartNote();
        }
      }
      /**
       * This method is called internally to rerender the cart, based on the content returned by Shopify Ajax API.
       * We could save some performance by updating directly in JavaScript instead of doing a GET call to get the HTML
       * from Shopify, but by experience, this allows for easier app integration as it allows the Liquid to re-run
       * all the time and hence having easier logic.
       */

    }, {
      key: "_rerenderCart",
      value: function _rerenderCart(elementToAnimate) {
        var _this4 = this;

        // Note: appending a timestamp is necessary as the polyfill on IE11 and lower does not support the "cache" property
        return fetch("".concat(window.routes.cartUrl, "?section_id=").concat(this.options['drawer'] && window.theme.pageType !== 'cart' ? 'mini-cart' : 'main-cart', "&timestamp=").concat(Date.now()), {
          credentials: 'same-origin',
          method: 'GET'
        }).then(function (content) {
          // If there is an element to animate, we animate it using a transition
          if (_this4.options['drawer'] && elementToAnimate) {
            var timelineLite = new TimelineLite({
              onComplete: function onComplete() {
                content.text().then(function (html) {
                  _this4._replaceContent(html);
                  
                  // Auto remove product
                  _this4._autoRemoveProduct();

                  _this4._autoRemoveMedicalConsultationProduct();
                  _this4._autoUpdatePaidMedicalConsultationProduct();
                });
              }
            });
            timelineLite.to(elementToAnimate, 0.5, {
              height: 0,
              opacity: 0,
              ease: Cubic.easeOut
            }, 0);

            if (_this4.itemCount === 0) {
              timelineLite.to(_this4.element.querySelector('.Drawer__Footer'), 0.5, {
                y: '100%',
                transition: 'none',
                ease: Cubic.easeInOut
              }, 0);
            }
          } else {
            content.text().then(function (html) {
              _this4._replaceContent(html);

              // Auto remove product
              _this4._autoRemoveProduct();

              _this4._autoRemoveMedicalConsultationProduct();
              _this4._autoUpdatePaidMedicalConsultationProduct();
            });
          }
        });
      }
    }, {
      key: "_replaceContent",
      value: function _replaceContent(html) {
        var _this5 = this;

        var tempElement = document.createElement('div');
        tempElement.innerHTML = html;
        var cartNodeParent = this.element.querySelector('.Cart').parentNode;
        var $emptyState;

        if (this.options['drawer'] && window.theme.pageType !== 'cart') {
          var currentScrollPosition = this.element.querySelector('.Drawer__Main').scrollTop;
          cartNodeParent.replaceChild(tempElement.querySelector('.Cart'), this.element.querySelector('.Cart'));
          this.element.querySelector('.Drawer__Main').scrollTop = currentScrollPosition;
        } else {
          // For dedicated page we replace the whole section if there is no more product
          if (this.itemCount === 0) {
            //this.element.innerHTML = tempElement.querySelector('.shopify-section').firstElementChild.innerHTML;
            
            $emptyState = tempElement.querySelector('.EmptyState');
            if ($emptyState) {
              this.element.innerHTML = '<div class="EmptyState">'+$emptyState.innerHTML+'</div>';
            }
            
          } else {
            cartNodeParent.replaceChild(tempElement.querySelector('.Cart'), this.element.querySelector('.Cart'));
            this.element.querySelector('.PageHeader').innerHTML = tempElement.querySelector('.PageHeader').innerHTML;
          }

          // update medical questionaire related stuff
          if (window.cdApp && window.cdApp.updateDoneDisplay) {
            window.cdApp.updateDoneDisplay();
          }

          // this._bogo();  // DEPRECATED
          this._bogo2();

          // upsell
          // console.log('DEBUG: update infopopup');
          document.dispatchEvent(new CustomEvent('cart:main-cart-content-replace'));

        } // We can also update the dot and the quantity


        var cartResult = JSON.parse(tempElement.querySelector('[data-section-type="cart"]').getAttribute('data-section-settings'));
        var cartDot = Dom.nodeListToArray(document.querySelectorAll('.Header__CartDot')),
            cartQuantity = Dom.nodeListToArray(document.querySelectorAll('.Header__CartCount'));
        this.itemCount = cartResult['itemCount'];
        cartDot.forEach(function (item) {
          if (_this5.itemCount === 0) {
            item.classList.remove('is-visible'); // IE 11 and lower does not support second attribute of toggle :(
          } else {
            item.classList.add('is-visible');
          }
        });
        cartQuantity.forEach(function (item) {
          item.textContent = _this5.itemCount;
        });
      }
    }, {
      key: "_customerForm",
      value: function _customerForm() {
        var formScript = document.getElementById('cd-form-script');
        formScript.addEventListener('load', function () {
          // console.log('DEBUG: customer form run');
          if (document.body.classList.contains('template-cart')) {
            window.cdApp.cartForm();
          }

          // window.cdApp.resultList('cd-result-list');
        });
      }
    }, {
      key: "_bogo", // DEPRECATED, delete this
      value: function _bogo() {
        console.log('DEBUG: bogo');
        var bonusProductHandle = 'customisable-case';

        var containsSet = false;
        var bonusAdded = false;


        var $cartItems = document.querySelectorAll('.CartItem');
        console.log('DEBUG: cart items ??????', $cartItems);

        if (!$cartItems.length) {
            return cartProducts;
        }
        
        var i, handle, isSet;
        for (i = 0; i !== $cartItems.length; ++i) {
            isSet = $cartItems[i].getAttribute('data-cartitem-is-set');
            handle = $cartItems[i].getAttribute('data-cartitem-product-handle');

            if (isSet === 'true') {
              containsSet = true;
            }

            if (handle === bonusProductHandle) {
              bonusAdded = true;
            }
        }
        

        if (containsSet && !bonusAdded) {
          // console.log('DEBUG: need bonus!!');
          document.getElementById('cosmetic-case-special').parentElement.classList.remove('special-offer-hide');
        } else if (containsSet && bonusAdded) {
          // console.log('DEBUG: BONUS ADDED!!');
          document.getElementById('cosmetic-case-special').parentElement.classList.remove('special-offer-hide');
          document.getElementById('cosmetic-case-special').innerHTML = `<h3 class="offerbox-header">A Holiday Treat</h3><p class="offerbox-confirmation">Your monogrammed cosmetic case has been added to your order and your discount will be automatically applied at the checkout. If you would like to monogram your case with initials different to the name associated with your order please contact our team at <a href="mailto:info@thesecretskincare.com.au">info@thesecretskincare.com.au</a> within 48 hours of placing your order. </p>`;
        }

        console.log('DEBUG: contains set', containsSet);
        console.log('DEBUG: bonusAdded', bonusAdded);

        window.cdApp = window.cdApp || {};

        cdApp.addToCartCosmeticCase = function() {
          // $.post('/cart/add.js', {
          //     items: [{
          //       id: '40239940010031',
          //       quantity: 1
          //     }]
          //   },
          //   function (data) {
          //     document.getElementById('#cosmetic-case-special')
          //     .innerHTML = `<h1 class="offerbox-header">A Holiday Treat</h1><p class="offerbox-confirmation">Your monogrammed cosmetic case has been added to your order and your discount will be automatically applied at the checkout. If you would like to monogram your case with initials different to the name associated with your order please contact our team at <a href="mailto:info@thesecretskincare.com.au">info@thesecretskincare.com.au</a> within 48 hours of placing your order. </p>`;
          //   },
          //   "json"
          // );

          fetch('/cart/add.js', {
            body: JSON.stringify({
              items: [{
                id: '40239940010031',
                quantity: 1
              }]
            }),
            credentials: 'same-origin',
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
  
            }
          }).then(function (cart) {
            console.log('DEBUG: bonus cart added');
              // document.getElementById('#cosmetic-case-special').innerHTML = `<h1 class="offerbox-header">A Holiday Treat</h1><p class="offerbox-confirmation">Your monogrammed cosmetic case has been added to your order and your discount will be automatically applied at the checkout. If you would like to monogram your case with initials different to the name associated with your order please contact our team at <a href="mailto:info@thesecretskincare.com.au">info@thesecretskincare.com.au</a> within 48 hours of placing your order. </p>`;
              location.reload();

          });
  

        }



      

      }
    },
    {
      key: "_bogo2",
      value: function _bogo2() {
        console.log('DEBUG: bogo version 2');
        // var bonusProductHandle = 'customisable-case';
        
        var bogoTagList = this.options['bogoTagList'];
        var bogoMinimumSpend = this.options['bogoMinimumSpend'];
        var bogoQuantity = this.options['bogoQuantity'];
        var bogoStartDate = this.options['bogoStartDate'];
        var bogoEndDate = this.options['bogoEndDate'];
        var bogoGiftVariant = this.options['bogoGiftVariant'];

        var $el = document.querySelector('.bogo-special-offer');
        var $offerContent = document.getElementById('bogo-offer-content-template');
        var $redeemedContent = document.getElementById('bogo-redeemed-content-template');

        if (!(bogoTagList || bogoMinimumSpend) || !bogoQuantity || !bogoGiftVariant || !$el) {
          console.log('DEBUG: bogo inactive', bogoTagList, bogoQuantity, bogoGiftVariant, $el);
          return false;
        }

        var bogoTags = bogoTagList.split("\n");
        console.log('DEBUG: bogo tags', bogoTags);

        // if (!bogoTags.length) {
        //   console.log('DEBUG: bogo tags is empty');
        //   return false;
        // }

        // date set
        var startDate, endDate, currentDate;
        if (bogoStartDate && bogoEndDate) {
          startDate = new Date(bogoStartDate);
          endDate = new Date(bogoEndDate);
          currentDate = new Date();

				  if (!(currentDate > startDate && currentDate < endDate)) {
            console.log('DEBUG: bogo schedule: false');
            return false;
          }  
        }

        var containsQualifyingProduct = false;
        var bonusAdded = false;

        var $cartItems = document.querySelectorAll('.CartItem');
        console.log('DEBUG: BOGO 2: cart items', $cartItems);

        if (!$cartItems.length) {
            return cartProducts;
        }
        
        // when tags empty, the bogoTags data is [''], when it happen, just empty the array, so the bogoTags considered empty
        if (bogoTags.length === 1 && !bogoTags[0]) {
          bogoTags = [];
        }

        var i, j, variantId, isMatch, tags, qty, matchCount = 0, nonBonusProductCount = 0;
        for (i = 0; i !== $cartItems.length; ++i) {
            tags = JSON.parse($cartItems[i].getAttribute('data-cartitem-product-tags'));
            qty = parseInt($cartItems[i].getAttribute('data-cartitem-product-quantity'));

            // matched product based on tags
            if (bogoTags.length) {
            for (j=0; j<bogoTags.length; j++) {
              isMatch = (tags.indexOf(bogoTags[j]) > -1);
              if (isMatch) {
                matchCount+=qty;
                break;
              }
            }            
            }

            // console.log('isMatch', isMatch, tags, matchCount);
            variantId = $cartItems[i].getAttribute('data-cartitem-product-variant-id');

            // console.log('DEBUG: variant', variantId, bogoGiftVariant);

            if (variantId === bogoGiftVariant) {
              bonusAdded = true;
            } else {
              nonBonusProductCount++;
            }
        }

        console.log('DEBUG: match tags quantity', matchCount);
        
        if (matchCount >= bogoQuantity) {
          containsQualifyingProduct = true;
        }

        // no tags, just set to contains qualifying products, means any product is eligible
        if (!bogoTags.length && (nonBonusProductCount >= bogoQuantity)) {
          console.log('DEBUG: bogo, no tags setup');
          containsQualifyingProduct = true;
        }

        // based on minimum spend
        var $cartTotal = document.querySelector('.Cart__Total');
        var totalPrice = parseInt($cartTotal.getAttribute('data-total-price'));
        var cartTotalQualified = false;
        console.log('DEBUG: cart total', totalPrice);

        if (bogoMinimumSpend) {
          if (totalPrice >= (bogoMinimumSpend * 100)) {
            // containsQualifyingProduct = true;
            console.log('DEBUG: cart total condition match', totalPrice);
            cartTotalQualified = true;
          } else {
            // containsQualifyingProduct = false;
          }
        } else {
          // no bogoMinimumspend
          cartTotalQualified = true;
        }

        // final qualification based on tags & cart total
        containsQualifyingProduct = containsQualifyingProduct && cartTotalQualified;

        if (containsQualifyingProduct && !bonusAdded) {
          // console.log('DEBUG: need bonus!!');
          // document.getElementById('cosmetic-case-special').parentElement.classList.remove('special-offer-hide');
          $el.querySelector('.bogo-offer').innerHTML = $offerContent.innerHTML;


          $el.classList.remove('special-offer-hide');

        } else if (containsQualifyingProduct && bonusAdded) {
          // console.log('DEBUG: BONUS ADDED!!');

          $el.querySelector('.bogo-redeemed').innerHTML = $redeemedContent.innerHTML;
          $el.classList.remove('special-offer-hide');
        }

        // console.log('DEBUG: containsQualifyingProduct', containsQualifyingProduct);
        // console.log('DEBUG: bonusAdded', bonusAdded);

        window.cdApp = window.cdApp || {};

        cdApp.bogoRedeemOffer = function() {

          fetch('/cart/add.js', {
            body: JSON.stringify({
              items: [{
                id: bogoGiftVariant,
                quantity: 1
              }]
            }),
            credentials: 'same-origin',
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
  
            }
          }).then(function (cart) {
            console.log('DEBUG: bonus cart added');
            location.reload();

          });
        }

      }
    }, {
      key: "_autoRemoveProduct",
      value: function _autoRemoveProduct() {
        var _this4 = this;

        console.log('DEBUG: perform auto remove product check ===========');
        // var triggerTag = 'Serum';//'Skincare Set';
        // var removedVariantId = '40473424035887';

        var $cartList = document.querySelector('.Cart__ItemList');
        
        if (!$cartList) {
          return false;
        }

        var triggerTag = $cartList.getAttribute('data-cart-autoremove-trigger-tag');
        var removedVariantId = $cartList.getAttribute('data-cart-autoremove-product-variant');

        if (!triggerTag || !removedVariantId) {
          return false;
        }
        
        var $cartItems = $cartList.querySelectorAll('.CartItem');
        console.log('DEBUG: AutoRemoveProducts: cart items', $cartItems);

        if (!$cartItems || !$cartItems.length) {
          return false;
        }

        var triggerTagFound = false;
        var removedProductFound = false;
        var removedLine = undefined;

        var i, tags, variantId, line;
        for (i = 0; i !== $cartItems.length; ++i) {
          tags = JSON.parse($cartItems[i].getAttribute('data-cartitem-product-tags'));
          if (tags.indexOf(triggerTag) > -1) {
            console.log('DEBUG: triggertag found');
            triggerTagFound = true;
          }

          variantId = $cartItems[i].getAttribute('data-cartitem-product-variant-id');
          line = $cartItems[i].getAttribute('data-cartitem-product-line');
          if (variantId === removedVariantId) {
            removedProductFound = true;
            removedLine = line;
            console.log('DEBUG: removed product found, line', line);

          }
        }

        console.log('DEBUG: triggercart count', triggerTagFound);

        if (!triggerTagFound && removedProductFound) {
          console.log('DEBUG: need to perform auto delete', removedLine);

          document.dispatchEvent(new CustomEvent('theme:loading:start'));
          fetch("".concat(window.routes.cartChangeUrl, ".js"), {
            body: JSON.stringify({
              line: removedLine,
              quantity: 0
            }),
            credentials: 'same-origin',
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
  
            }
          }).then(function (cart) {
            cart.json().then(function (content) {
              _this4.itemCount = content['item_count'];
              _this4._rerenderCart();
              document.dispatchEvent(new CustomEvent('theme:loading:end'));
            });
          });          

        } else {
          console.log('DEBUG: no auto delete');
        }

      }
    }, {
      key: "_autoRemoveMedicalConsultationProduct",
      value: function _autoRemoveMedicalConsultationProduct() {
        var _this4 = this;

        console.log('DEBUG: Telehealth - perform auto remove medical practicioner consult product check ===========');
        // var triggerTag = 'Serum';//'Skincare Set';
        var removedVariantId = '43597787660335';//'43200698056751';

        var $cartList = document.querySelector('.Cart__ItemList');
        
        if (!$cartList) {
          return false;
        }

        // var triggerTag = $cartList.getAttribute('data-cart-autoremove-trigger-tag');
        // var removedVariantId = $cartList.getAttribute('data-cart-autoremove-product-variant');

        // if (!triggerTag || !removedVariantId) {
        //   return false;
        // }
        
        var $cartItems = $cartList.querySelectorAll('.CartItem');
        // console.log('DEBUG: AutoRemoveProducts: cart items', $cartItems);

        if (!$cartItems || !$cartItems.length) {
          return false;
        }

        // var triggerTagFound = false;
        var removedProductFound = false;
        var removedLine = undefined;

        var i, tags, variantId, line;
        for (i = 0; i !== $cartItems.length; ++i) {
          // tags = JSON.parse($cartItems[i].getAttribute('data-cartitem-product-tags'));
          // if (tags.indexOf(triggerTag) > -1) {
          //   console.log('DEBUG: triggertag found');
          //   triggerTagFound = true;
          // }

          variantId = $cartItems[i].getAttribute('data-cartitem-product-variant-id');
          line = $cartItems[i].getAttribute('data-cartitem-product-line');
          if (variantId === removedVariantId) {
            removedProductFound = true;
            removedLine = line;
            console.log('DEBUG: Telehealth - medical practicioner consult product found, line', line);

          }
        }

        // console.log('DEBUG: triggercart count', triggerTagFound);

        if (removedProductFound) {
          console.log('DEBUG: Telehealth - need to perform auto delete', removedLine);

          document.dispatchEvent(new CustomEvent('theme:loading:start'));
          fetch("".concat(window.routes.cartChangeUrl, ".js"), {
            body: JSON.stringify({
              line: removedLine,
              quantity: 0
            }),
            credentials: 'same-origin',
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
  
            }
          }).then(function (cart) {
            cart.json().then(function (content) {
              _this4.itemCount = content['item_count'];
              _this4._rerenderCart();
              document.dispatchEvent(new CustomEvent('theme:loading:end'));
            });
          });          

        } else {
          console.log('DEBUG: Telehealth - no auto delete');
        }

      }
    }, {
      key: "_autoUpdatePaidMedicalConsultationProduct",
      value: function _autoUpdatePaidMedicalConsultationProduct() {
        var _this4 = this;

        console.log('DEBUG: Telehealth - perform auto update qty paid medical practicioner consult product check ===========');
        var removedVariantId = '43597801062447';

        var $cartList = document.querySelector('.Cart__ItemList');
        
        if (!$cartList) {
          return false;
        }
        
        var $cartItems = $cartList.querySelectorAll('.CartItem');

        if (!$cartItems || !$cartItems.length) {
          return false;
        }

        // var triggerTagFound = false;
        var removedProductFound = false;
        var removedLine = undefined;
        var removedQty = 0;

        var i, tags, variantId, line, qty;
        for (i = 0; i !== $cartItems.length; ++i) {
          variantId = $cartItems[i].getAttribute('data-cartitem-product-variant-id');
          line = $cartItems[i].getAttribute('data-cartitem-product-line');
          qty = $cartItems[i].getAttribute('data-cartitem-product-quantity');

          if (variantId === removedVariantId) {
            removedProductFound = true;
            removedLine = line;
            console.log('DEBUG: Telehealth - paid medical practicioner consult product found, line', line);
            if (qty) {
              removedQty = parseInt(qty, 10);
            }
          }
        }

        if (removedProductFound && removedQty > 1) {
          console.log('DEBUG: Telehealth - paid medical need to perform auto update quantity', removedLine);

          document.dispatchEvent(new CustomEvent('theme:loading:start'));
          fetch("".concat(window.routes.cartChangeUrl, ".js"), {
            body: JSON.stringify({
              line: removedLine,
              quantity: 1
            }),
            credentials: 'same-origin',
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
  
            }
          }).then(function (cart) {
            cart.json().then(function (content) {
              _this4.itemCount = content['item_count'];
              _this4._rerenderCart();
              document.dispatchEvent(new CustomEvent('theme:loading:end'));
            });
          });          

        } else {
          console.log('DEBUG: Telehealth - no auto delete');
        }

      }
    }
  ]);

    return CartSection;
  }();

  var CollectionListSection = /*#__PURE__*/function () {
    function CollectionListSection(container) {
      _classCallCheck(this, CollectionListSection);

      this.element = container;
      var collectionListElement = this.element.querySelector('[data-flickity-config]');

      if (collectionListElement) {
        this.carousel = new Carousel(collectionListElement);
      }
    }

    _createClass(CollectionListSection, [{
      key: "onUnload",
      value: function onUnload() {
        if (this.carousel) {
          this.carousel.destroy();
        }
      }
    }, {
      key: "onBlockSelect",
      value: function onBlockSelect(event) {
        if (this.carousel) {
          this.carousel.selectCell(event.target.getAttribute('data-slide-index'), true, !event.detail.load);
        }
      }
    }, {
      key: "onBlockDeselect",
      value: function onBlockDeselect() {
        if (this.carousel) {
          this.carousel.unpausePlayer();
        }
      }
    }]);

    return CollectionListSection;
  }();

  /**
   * This class allows to automatically scrolls within a div when this div does not fit into the visible space
   */
  var OverflowScroller = /*#__PURE__*/function () {
    function OverflowScroller(element) {
      _classCallCheck(this, OverflowScroller);

      if (!element) {
        return;
      }

      this.element = element;
      this.lastKnownY = window.scrollY;
      this.currentTop = 0;
      this.initialTopOffset = parseInt(window.getComputedStyle(this.element).top);

      this._attachListeners();
    }

    _createClass(OverflowScroller, [{
      key: "destroy",
      value: function destroy() {
        window.removeEventListener('scroll', this._checkPositionListener);
      }
    }, {
      key: "_attachListeners",
      value: function _attachListeners() {
        this._checkPositionListener = this._checkPosition.bind(this);
        window.addEventListener('scroll', this._checkPositionListener);
      }
    }, {
      key: "_checkPosition",
      value: function _checkPosition() {
        var _this = this;

        fastdom.measure(function () {
          var bounds = _this.element.getBoundingClientRect(),
              maxTop = bounds.top + window.scrollY - _this.element.offsetTop + _this.initialTopOffset,
              minTop = _this.element.clientHeight - window.innerHeight;

          if (window.scrollY < _this.lastKnownY) {
            _this.currentTop -= window.scrollY - _this.lastKnownY;
          } else {
            _this.currentTop += _this.lastKnownY - window.scrollY;
          }

          _this.currentTop = Math.min(Math.max(_this.currentTop, -minTop), maxTop, _this.initialTopOffset);
          _this.lastKnownY = window.scrollY;
        });
        fastdom.mutate(function () {
          _this.element.style.top = "".concat(_this.currentTop, "px");
        });
      }
    }]);

    return OverflowScroller;
  }();

  var CollectionSection = /*#__PURE__*/function () {
    function CollectionSection(element) {
      _classCallCheck(this, CollectionSection);

      this.element = element;
      this.delegateElement = new domDelegate.Delegate(this.element);
      this.toolbarElement = this.element.querySelector('.CollectionToolbar');
      this.collectionInnerElement = this.element.querySelector('.CollectionInner__Products');
      this.settings = JSON.parse(this.element.getAttribute('data-section-settings')); // Create the popover if available

      var sortPopoverElement = document.getElementById('collection-sort-popover');

      if (sortPopoverElement) {
        this.sortPopover = new Popover(sortPopoverElement, {
          onValueChanged: this._sortByChanged.bind(this)
        });
      } 

      // ClueEdit: Categories popover
      var categoriesPopoverElement = document.getElementById('collection-categories-popover');
      if (categoriesPopoverElement) {
        this.categoriesPopover = new Popover(categoriesPopoverElement, {
          onValueChanged: this._gotoLink.bind(this)
        });
      }
      // ClueEdit: Skin concerns popover
      var skinConcernsPopoverElement = document.getElementById('collection-skinconcerns-popover');
      if (skinConcernsPopoverElement) {
        this.skinConcernsPopover = new Popover(skinConcernsPopoverElement, {
          onValueChanged: this._gotoLink.bind(this)
        });
      }

      // Create the filter drawer if available
      var filterDrawerElement = document.getElementById('collection-filter-drawer');

      if (filterDrawerElement) {
        this.filterDrawer = new Drawer(filterDrawerElement);
      } // Create scroller of sidebar


      if (this.settings['filterPosition'] === 'sidebar') {
        this.filterInnerSidebarScroller = new OverflowScroller(this.element.querySelector('.CollectionInner__Sidebar'));
      } // Setup parallax on image (if any)


      var collectionImageElement = this.element.querySelector('.PageHeader__ImageWrapper');

      if (collectionImageElement && window.matchMedia('(-moz-touch-enabled: 0), (hover: hover)').matches) {
        this.parallaxInstance = new Rellax('.PageHeader__ImageWrapper', {
          speed: -7,
          center: false,
          round: true
        });
      } // Setup product item color swatch


      new ProductItemColorSwatch(this.element.querySelector('.ProductList')); // Setup animation

      this.timeline = new TimelineLite({
        delay: window.theme.showPageTransition ? 0.5 : 0
      });

      this._setupAnimation();

      this._attachListeners();

      // ClueEdit: collection recommendations
      this._collectionRecommendations();

      // ClueEdit: clinic only
      this._clinicOnly();
    }

    _createClass(CollectionSection, [{
      key: "onUnload",
      value: function onUnload() {
        this.delegateElement.off('click');

        if (this.sortPopover) {
          this.sortPopover.destroy();
        }

        // ClueEdit: categories popover
        if (this.categoriesPopover) {
          this.categoriesPopover.destroy();
        }

        // ClueEdit: skin concerns popover
        if (this.skinConcernsPopover) {
          this.skinConcernsPopover.destroy();
        }

        if (this.filterDrawer) {
          this.filterDrawer.destroy();
        }

        if (this.filterInnerSidebarScroller) {
          this.filterInnerSidebarScroller.destroy();
        }

        if (this.parallaxInstance) {
          this.parallaxInstance.destroy();
        }

        if (window.theme.showElementStaggering) {
          this.intersectionObserver.disconnect();
          this.timeline.kill();
        }
      }
    }, {
      key: "_setupAnimation",
      value: function _setupAnimation() {
        var _this = this;

        var forceLoadFromTop = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

        if (!window.theme.showElementStaggering) {
          return;
        } // If there is already an observer set up, we remove it first


        if (this.intersectionObserver) {
          this.intersectionObserver.disconnect();
        }

        if (forceLoadFromTop) {
          this.timeline.clear();
          this.timeline.staggerFromTo(this.element.querySelectorAll('.ProductList .ProductItem'), 0.35, {
            autoAlpha: 0,
            y: 25
          }, {
            autoAlpha: 1,
            y: 0
          }, 0.15);
        } else {
          this.intersectionObserver = new IntersectionObserver(this._reveal.bind(this), {
            threshold: 0.3
          });
          Dom.nodeListToArray(this.element.querySelectorAll('.ProductList .ProductItem')).forEach(function (item) {
            _this.intersectionObserver.observe(item);
          });
        }
      }
    }, {
      key: "_reveal",
      value: function _reveal(results) {
        var _this2 = this;

        var toReveal = [];
        results.forEach(function (result) {
          if (result.isIntersecting || result.intersectionRatio > 0) {
            // isIntersecting does not exist on Samsung Android browser
            toReveal.push(result.target);

            _this2.intersectionObserver.unobserve(result.target);
          }
        });

        if (toReveal.length === 0) {
          return;
        }

        this.timeline.staggerFromTo(toReveal, 0.45, {
          autoAlpha: 0,
          y: 25
        }, {
          autoAlpha: 1,
          y: 0
        }, 0.2);
      }
    }, {
      key: "_changeLayoutMode",
      value: function _changeLayoutMode(event, target) {
        var _this3 = this;

        var layoutType = target.getAttribute('data-grid-type'),
            newCount = parseInt(target.getAttribute('data-count')); // Otherwise we detect the mode, and change all classes

        var productList = this.collectionInnerElement.querySelector('.ProductList');

        if (productList) {
          var previousCount = parseInt(productList.getAttribute("data-".concat(layoutType, "-count")));

          if (previousCount === newCount) {
            return; // Nothing has changed so we just return to avoid reflow
          }

          productList.setAttribute("data-".concat(layoutType, "-count"), newCount);
          Dom.nodeListToArray(productList.querySelectorAll('.Grid__Cell')).forEach(function (item) {
            if (layoutType === 'mobile') {
              item.classList.remove("1/".concat(previousCount, "--phone")); // IE11 and lower does not support classList.replace

              item.classList.add("1/".concat(newCount, "--phone"));
            } else {
              var previousTabletCount = previousCount === 2 ? 2 : 3,
                  newTabletCount = newCount === 2 ? 2 : 3;

              if (_this3.settings['filterPosition'] === 'drawer') {
                item.classList.remove("1/".concat(previousCount, "--lap-and-up"));
                item.classList.add("1/".concat(newCount, "--lap-and-up"));
              } else {
                item.classList.remove("1/".concat(previousCount, "--desk"));
                item.classList.add("1/".concat(newCount, "--desk"));
              }

              item.classList.remove("1/".concat(previousTabletCount, "--tablet-and-up"));
              item.classList.add("1/".concat(newTabletCount, "--tablet-and-up"));
            }

            if (window.theme.showElementStaggering) {
              item.firstElementChild.style.visibility = 'hidden'; // Make it as hidden so we can re-trigger the animation
            }
          }); // Force lazy sizes to recalculate item sizes

          lazySizes.autoSizer.checkElems();
        }

        target.classList.add('is-active');
        Dom.getSiblings(target)[0].classList.remove('is-active');

        this._setupAnimation(); // In order to prevent reflow and provide better user experience, we save into cart attributes (those are removed before the checkout
        // is submitted) the user choices so they are preserved on page reload, without the need to use JavaScript


        fetch("".concat(window.routes.cartUrl, "/update.js"), {
          body: JSON.stringify({
            attributes: _defineProperty({}, "collection_".concat(layoutType, "_items_per_row"), newCount)
          }),
          credentials: 'same-origin',
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header

          }
        });
      }
    }, {
      key: "_sortByChanged",
      value: function _sortByChanged(sortBy) {
        var currentUrl = new URL(location.href);
        currentUrl.searchParams.set('sort_by', sortBy);
        currentUrl.searchParams.delete('page');

        this._reloadProducts(currentUrl.toString());
      }
    }, {
      key: "_gotoLink",
      value: function _gotoLink(link) {
        // var currentUrl = new URL(location.href);
        window.location = link;
      }
    }, {
      key: "_onFiltersCleared",
      value: function _onFiltersCleared(event) {
        this._reloadProducts(event.target.getAttribute('data-url'));
      }
    }, {
      key: "_onFilterChanged",
      value: function _onFilterChanged(event) {
        var formData = new FormData(event.target.closest('form'));
        var searchParamsAsString = new URLSearchParams(formData).toString();

        this._reloadProducts("".concat(window.location.pathname, "?").concat(searchParamsAsString));
      }
    }, {
      key: "_reloadProducts",
      value: function _reloadProducts(url) {
        var _this4 = this;

        if (this.abortController) {
          this.abortController.abort();
        }

        document.dispatchEvent(new CustomEvent('theme:loading:start'));

          if (history.replaceState) {
            window.history.pushState({
              path: url
            }, '', url);
          }  

        var currentUrl = new URL(window.location);
        currentUrl.searchParams.set('section_id', this.settings['sectionId']);

        try {
          this.abortController = new AbortController();
          fetch(currentUrl.toString(), {
            signal: this.abortController.signal
          }).then(function (response) {
            response.text().then(function (content) {
              var tempElement = document.createElement('div');
              tempElement.innerHTML = content;
              _this4.collectionInnerElement.innerHTML = tempElement.querySelector('.CollectionInner__Products').innerHTML;
              var toolbarFilter = tempElement.querySelector('.CollectionToolbar__Item--filter');

              if (toolbarFilter) {
                var newToolbarFilter = _this4.element.querySelector('.CollectionToolbar__Item--filter');

                newToolbarFilter.innerHTML = toolbarFilter.innerHTML;
                newToolbarFilter.className = toolbarFilter.className;
              } // We also replace the filters


              var collectionFiltersDrawer = _this4.element.querySelector('#collection-filters-drawer-form'),
                  collectionFiltersSidebar = _this4.element.querySelector('#collection-filters-sidebar-form');

              if (collectionFiltersDrawer) {
                var newDrawerContent = tempElement.querySelector('#collection-filters-drawer-form');
                Array.from(collectionFiltersDrawer.querySelectorAll('.Collapsible')).forEach(function (collapsible) {
                  var newCollapsible = newDrawerContent.querySelector("[data-filter-index=\"".concat(collapsible.getAttribute('data-filter-index'), "\"]"));

                  if (collapsible.firstElementChild.getAttribute('aria-expanded') === 'true') {
                    newCollapsible.style.overflow = 'visible';
                    newCollapsible.firstElementChild.setAttribute('aria-expanded', 'true');
                    newCollapsible.lastElementChild.style.height = 'auto';
                    newCollapsible.lastElementChild.style.overflow = 'visible';
                  }
                });
                collectionFiltersDrawer.innerHTML = newDrawerContent.innerHTML;
              }

              if (collectionFiltersSidebar) {
                var newSidebarContent = tempElement.querySelector('#collection-filters-sidebar-form');
                Array.from(collectionFiltersSidebar.querySelectorAll('.Collapsible')).forEach(function (collapsible) {
                  var newCollapsible = newSidebarContent.querySelector("[data-filter-index=\"".concat(collapsible.getAttribute('data-filter-index'), "\"]"));

                  if (collapsible.firstElementChild.getAttribute('aria-expanded') === 'true') {
                    newCollapsible.style.overflow = 'visible';
                    newCollapsible.firstElementChild.setAttribute('aria-expanded', 'true');
                    newCollapsible.lastElementChild.style.height = 'auto';
                    newCollapsible.lastElementChild.style.overflow = 'visible';
                  }
                });
                collectionFiltersSidebar.innerHTML = newSidebarContent.innerHTML;
              }

              document.dispatchEvent(new CustomEvent('theme:loading:end'));

              _this4._setupAnimation(true); // We scroll to the top


              var elementOffset = _this4.element.querySelector('.CollectionMain').getBoundingClientRect().top - parseInt(document.documentElement.style.getPropertyValue('--header-height'));

              if (Responsive.matchesBreakpoint('lap-and-up') && _this4.toolbarElement && _this4.toolbarElement.clientHeight === 0) {
                elementOffset -= 50;
              }

              if (elementOffset < 0) {
                window.scrollBy({
                  top: elementOffset,
                  behavior: 'smooth'
                });
              }

              // this will recalculate recommended products and trigger event theme:form:recommendations
              // collection pages already handle event theme:form:recommendations
              if (window.cdApp.recommendations) {
                window.cdApp.recommendations();
              }

            });



          });
        } catch (exception) {}
      }
    }, {
      key: "_onAddToCart",
      value: function _onAddToCart(event, target) {
        console.log('DEBUG: ',target);
        console.log('DEBUG: ',target.getAttribute('data-action'));
        var productId = target.getAttribute('data-product-id');
        console.log('DEBUG: product id = ', productId);

        var _this4 = this;



        // ajax add to cart, reference: _addToCart

        target.setAttribute('disabled', 'disabled');

        document.dispatchEvent(new CustomEvent('theme:loading:start')); // Then we add the product in Ajax
        fetch("".concat(window.routes.cartAddUrl, ".js"), {
          body: '{"form_type":"product","utf8":"✓","id":"'+ productId +'"}',
          //JSON.stringify(Form.serialize(formElement)),
          credentials: 'same-origin',
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header

          }
        }).then(function (response) {
          document.dispatchEvent(new CustomEvent('theme:loading:end'));
          // var quantityElement = formElement.querySelector('[name="quantity"]');

          if (response.ok) {
            // todo, enable button, or disable loader
            target.removeAttribute('disabled');
            
            // We simply trigger an event so the mini-cart can re-render
            _this4.element.dispatchEvent(new CustomEvent('product:added', {
              bubbles: true,
              detail: {
                variant: _this4.currentVariant,
                quantity: 1//quantityElement ? parseInt(quantityElement.value) : 1
              }
            }));
          } else {
            response.json().then(function (content) {
              var errorMessageElement = document.createElement('span');
              errorMessageElement.className = 'ProductForm__Error Alert Alert--error';
              errorMessageElement.innerHTML = content['description'];
              target.removeAttribute('disabled');
              target.insertAdjacentElement('afterend', errorMessageElement);
              setTimeout(function () {
                errorMessageElement.remove();
              }, 2500);

              // alert(content['description']);
            });
          }
        });



        event.preventDefault();
      }
    }, {
      key: "_attachListeners",
      value: function _attachListeners() {
        this._changeLayoutModeListener = this._changeLayoutMode.bind(this);
        this.delegateElement.on('click', '[data-action="change-layout-mode"]', this._changeLayoutModeListener);
        this.delegateElement.on('click', '[data-action="clear-filters"]', this._onFiltersCleared.bind(this));
        this.delegateElement.on('change', '[name^="filter."]', this._onFilterChanged.bind(this));
        window.addEventListener('popstate', function (event) {
          if (event.state.path) {
            window.location.href = event.state.path;
          }
        });
        
        // Add to cart
        this.delegateElement.on('click', '[data-action="collection-add-to-cart"]', this._onAddToCart.bind(this));
        
      }
    }, {
      key: "_collectionRecommendationsPage",
      value: function _collectionRecommendationsPage() {
        // console.log('DEBUG, 💪', document.body.classList.contains('template-collection-recommendations'));
        return document.body.classList.contains('template-collection-recommendations');
      }
    }, {
      key: "_collectionRecommendations",
      value: function _collectionRecommendations() {
        var _this4 = this;
        
        console.log('DEBUG: _collectionRecommendations function');

        // // filter
        // var products = [
        //   'complimentary-jade-roller',
        //   'mens-day-brightening-elixir',
        //   'body-bundle',
        //   'mens-day-set'
        // ];

        // ClueEdit: move to global
        // function getHandleFromUrl(url) {
        //   var str = url.split('/products/');
        //   if (str.length > 1) {
        //     return str[1];
        //   }
        //   return '';
        // }

        // waiting for recommendations
        // TODO:
        // var $collectionProductsInner = document.querySelector('.CollectionInner__Products');
        // $collectionProductsInner.classList.add('CollectionInner__Products--loading');
        // var loadingClass = 'template-collection-recommendations--loading';
        // var noDataClass = 'template-collection-recommendations--nodata'; // when user hasn't took the quiz

        // // in collection recommendations page, it basically load all products. so dont display products, instead show loading
        // if (this._collectionRecommendationsPage()) {
        //   document.body.classList.add(loadingClass);
        // }      

        // listen to even recommendations
        document.addEventListener('theme:form:recommendations', function(event) {
          var status = event.detail.status; 
          var products = event.detail.products; 
          var refillProductSuffix = '-refill';

          console.log('DEBUG:🎉🎉🎉  recommendations received', status, products);

          // if (_this4._collectionRecommendationsPage() && (status === cdApp.RECOMMENDATION_STATUS.NODATA)) {
          //   console.log('DEBUG: you havent take the quiz');
          //   document.body.classList.add(noDataClass);
          // }

          // hide products other than recommendations
          var $productItems = document.querySelectorAll('.ProductItem');
          Array.from($productItems).forEach(function($el) {
            // console.log('DEBUG: $el', $el);
            var url = $el.querySelector('.ProductItem__Wrapper > a').getAttribute('href');
            var handle = getHandleFromUrl(url);
            // console.log('DEBUG: url', handle);
            var $parent = $el.parentElement;
            // console.log('DEBUG: parent', $parent);
            var $label = $el.querySelector('.ProductItem__LabelRecommended');
            var indexRefillSuffix = -1;
  
            if (!(products.indexOf(handle) > -1)) {
              // on collection recommendations page, hide non recommended page
              if (_this4._collectionRecommendationsPage()) {
                $parent.classList.add('Grid__Cell--hide');
              }      
            } else {
              // console.log('DEBUG: display', handle);
              // show label
              $label.style.display = 'block';

              // ClueEdit: Telehealth - remove recommended label - temporary fix
              // set parent as recommended, so we can order it with css
              // $parent.classList.add('Grid__Cell--recommended');

              // refill products
              // ClueEdit - hide refill products in doctors recommendations collection page
              // on collection recommendations page only
              if (_this4._collectionRecommendationsPage()) {
                indexRefillSuffix = handle.indexOf(refillProductSuffix);              
                if (indexRefillSuffix > -1 && handle.substring(indexRefillSuffix, (handle.length - 1))) {
                  $parent.classList.add('Grid__Cell--refill','Grid__Cell--hide');
                }  
              }      
            }
  
          });

          // // in collection recommendations page, remove loading, show products
          // if (_this4._collectionRecommendationsPage()) {
          //   document.body.classList.remove(loadingClass);
          // }      
          
  
        });
       

      }
    }, {
      key: "_clinicOnly",
      value: function _clinicOnly() {
        var _this4 = this;

        CF.customerReady(function() {
          // console.log('DEBUG: clinic customer ready!!!');

          // clinic
          let loggedIn = !!ShopifyAnalytics.meta.page.customerId;
          let clinicName = CF.customer.get('clinic_name');
          let reference = CF.customer.get('reference');

          // console.log('DEBUG: clinic', clinicName, reference, loggedIn);

          if (!loggedIn && clinicName && reference == 'Clinic') {
            console.log('DEBUG: this is clinic');
          } else {
            console.log('DEBUG: this is not clinic');

            var $productItems = document.querySelectorAll('.ProductItem--clinicOnly');
            if ($productItems && $productItems.length) {
              Array.from($productItems).forEach(function($el) {
                let button = $el.querySelector('.ProductItem__AddToCart');
                let text = $el.querySelector('.ProductItem__PriceList');
                text.textContent = 'Available through Clinic Partners Only';
                // button.style.pointerEvents = 'none';
                // button.removeEventListener('click', functionName);
                let clone = button.cloneNode(true);
                button.parentNode.replaceChild(clone, button);
                clone.setAttribute('href','/pages/partner-clinics');
              });  
            }
    
          }        

        });        

        
     

      }
    }]);

    return CollectionSection;
  }();

  var FaqSection = /*#__PURE__*/function () {
    function FaqSection(element) {
      _classCallCheck(this, FaqSection);

      this.element = element;
      this.delegateElement = new domDelegate.Delegate(this.element);

      this._attachListeners();
    }

    _createClass(FaqSection, [{
      key: "onUnload",
      value: function onUnload() {
        this.delegateElement.off();
      }
    }, {
      key: "onBlockSelect",
      value: function onBlockSelect(event) {
        this._openItem(event.target);
      }
    }, {
      key: "onBlockDeselect",
      value: function onBlockDeselect(event) {
        this._closeItem(event.target);
      }
    }, {
      key: "_attachListeners",
      value: function _attachListeners() {
        this.delegateElement.on('click', '.Faq__Question', this._toggleItem.bind(this));
        this.delegateElement.on('click', '.FaqSummary__Item', this._switchToCategory.bind(this));
      }
    }, {
      key: "_switchToCategory",
      value: function _switchToCategory(event, target) {
        target.classList.add('is-active');
        Dom.getSiblings(target, '.is-active').forEach(function (item) {
          item.classList.remove('is-active');
        });
      }
    }, {
      key: "_toggleItem",
      value: function _toggleItem(event, target) {
        var item = target.closest('.Faq__Item');

        if (item.getAttribute('aria-expanded') === 'true') {
          this._closeItem(item);
        } else {
          this._openItem(item);
        }
      }
    }, {
      key: "_openItem",
      value: function _openItem(item) {
        var answerWrapper = item.querySelector('.Faq__AnswerWrapper');
        item.setAttribute('aria-expanded', 'true');
        answerWrapper.setAttribute('aria-hidden', 'false');
        Animation.slideDown(answerWrapper, true);
        Dom.getSiblings(item, '[aria-expanded="true"]').forEach(function (siblingItem) {
          var siblingAnswerWrapper = siblingItem.querySelector('.Faq__AnswerWrapper');
          siblingItem.setAttribute('aria-expanded', 'false');
          siblingAnswerWrapper.setAttribute('aria-hidden', 'true');
          Animation.slideUp(siblingAnswerWrapper);
        });
      }
    }, {
      key: "_closeItem",
      value: function _closeItem(item) {
        var answerWrapper = item.querySelector('.Faq__AnswerWrapper');
        item.setAttribute('aria-expanded', 'false');
        answerWrapper.setAttribute('aria-hidden', 'true');
        Animation.slideUp(answerWrapper);
      }
    }]);

    return FaqSection;
  }();

  var FeaturedCollectionsSection = /*#__PURE__*/function () {
    function FeaturedCollectionsSection(container) {
      var _this = this;

      _classCallCheck(this, FeaturedCollectionsSection);

      this.element = container;
      this.delegateElement = new domDelegate.Delegate(this.element);
      this.options = JSON.parse(this.element.getAttribute('data-settings'));
      this.carousels = [];
      Dom.nodeListToArray(this.element.querySelectorAll('[data-flickity-config]')).forEach(function (item) {
        _this.carousels.push(new Carousel(item));
      }); // Setup product item color swatch

      new ProductItemColorSwatch(this.element);

      this._setupAnimation();

      this._attachListeners();
    }

    _createClass(FeaturedCollectionsSection, [{
      key: "onUnload",
      value: function onUnload() {
        this.carousels.forEach(function (item) {
          return item.destroy();
        });
        this.delegateElement.off('click');
        this.intersectionObserver.disconnect();
        this.timeline.kill();
      }
    }, {
      key: "onBlockSelect",
      value: function onBlockSelect(event) {
        // We simply trigger a click on the element that controls this tab
        this.element.querySelector("[aria-controls=\"".concat(event.target.id, "\"]")).click();
      }
    }, {
      key: "_attachListeners",
      value: function _attachListeners() {
        this.delegateElement.on('click', '[data-action="toggle-tab"]', this._switchTab.bind(this));
      }
    }, {
      key: "_switchTab",
      value: function _switchTab(event, target) {
        var _this2 = this;

        // If the tab is already active, do nothing
        if (target.classList.contains('is-active')) {
          return;
        } // First, switch the current tab


        target.classList.add('is-active');
        Dom.getSiblings(target, '.is-active').forEach(function (item) {
          item.classList.remove('is-active');
        }); // Then, display the panel

        var tabPanelToShow = this.element.querySelector("#".concat(target.getAttribute('aria-controls')));
        this.timeline.eventCallback('onReverseComplete', function () {
          tabPanelToShow.setAttribute('aria-hidden', 'false');
          Dom.getSiblings(tabPanelToShow, '.TabPanel[aria-hidden="false"]').forEach(function (item) {
            item.setAttribute('aria-hidden', 'true');
          });

          if (Responsive.matchesBreakpoint('lap-and-up')) {
            _this2.carousels.forEach(function (carousel) {
              // There is a bug in Safari where it cannot detect the pseudo-element "::after" if the tab panel is hidden. As a consequence,
              // we manually activate it
              carousel.flickityInstance.activate();
              carousel.flickityInstance.resize(); // Ugly hack
            });
          }

          _this2.timeline.clear();

          _this2._setupAnimation();
        });

        if (this.options['layout'] === 'grid' && window.theme.showElementStaggering) {
          this.timeline.reverse().timeScale(3);
        } else {
          this.timeline.reverse();
        }
      }
    }, {
      key: "_setupAnimation",
      value: function _setupAnimation() {
        var _this3 = this;

        if (this.intersectionObserver) {
          this.intersectionObserver.disconnect();
        }

        this.timeline = new TimelineLite({
          delay: 0.5
        });

        if (this.options['layout'] === 'grid' && window.theme.showElementStaggering) {
          this.intersectionObserver = new IntersectionObserver(this._reveal.bind(this));
          Dom.nodeListToArray(this.element.querySelectorAll('.TabPanel[aria-hidden="false"] .ProductList .ProductItem')).forEach(function (item) {
            _this3.intersectionObserver.observe(item);
          });
        } else {
          var productList = this.element.querySelector('.TabPanel[aria-hidden="false"] .ProductList');

          if (productList) {
            this.timeline.fromTo(productList, 0.6, {
              autoAlpha: 0,
              y: 25
            }, {
              autoAlpha: 1,
              y: 0
            });
          }
        }
      }
    }, {
      key: "_reveal",
      value: function _reveal(results) {
        var _this4 = this;

        var toReveal = [];
        results.forEach(function (result) {
          if (result.isIntersecting || result.intersectionRatio > 0) {
            // isIntersecting does not exist on Samsung Android browser
            toReveal.push(result.target);

            _this4.intersectionObserver.unobserve(result.target);
          }
        });

        if (toReveal.length === 0) {
          return;
        }

        this.timeline.staggerFromTo(toReveal, 0.45, {
          autoAlpha: 0,
          y: 25
        }, {
          autoAlpha: 1,
          y: 0
        }, 0.2);
      }
    }]);

    return FeaturedCollectionsSection;
  }();

  var FeaturedProductSection = /*#__PURE__*/function () {
    function FeaturedProductSection(container) {
      _classCallCheck(this, FeaturedProductSection);

      this.element = container;
      this.delegateElement = new domDelegate.Delegate(this.element);
      this.options = JSON.parse(this.element.getAttribute('data-section-settings'));

      if (!this.options['usePlaceholder'] && this.options['templateSuffix'] !== 'coming-soon') {
        this.productVariants = new ProductVariants(container, this.options);
      } // We have to re-order elements in the DOM


      var offscreenElement = this.element.querySelector('.Product__OffScreen');

      if (offscreenElement) {
        this.element.appendChild(offscreenElement);
      }

      this._attachListeners();
    }

    _createClass(FeaturedProductSection, [{
      key: "onUnload",
      value: function onUnload() {
        this.delegateElement.off('click');

        if (this.productVariants) {
          this.productVariants.destroy();
        }
      }
    }, {
      key: "_attachListeners",
      value: function _attachListeners() {
        this.delegateElement.on('variant:changed', this._updateMainImage.bind(this));
      }
      /**
       * Update the main featured image
       */

    }, {
      key: "_updateMainImage",
      value: function _updateMainImage(event) {
        var variant = event.detail.variant,
            previousVariant = event.detail.previousVariant;

        if (!variant || !variant['featured_image'] || previousVariant['featured_image'] && previousVariant['featured_image']['id'] === variant['featured_image']['id']) {
          return;
        } // Otherwise we are on the home page. It's a bit more complex as we have to rewrite some code normally written in Liquid


        var newImage = variant['featured_image'];
        var mainImageContainer = this.element.querySelector('.FeaturedProduct__Gallery .AspectRatio');
        mainImageContainer.style.cssText = "max-width: ".concat(newImage['width'], "px; --aspect-ratio: ").concat(newImage['width'] / newImage['height']);
        var newImageElement = document.createElement('img');
        newImageElement.classList.add('Image--lazyLoad');
        newImageElement.setAttribute('data-src', Image.getSizedImageUrl(newImage['src'], '1x1').replace('_1x1.', '_{width}x.'));
        newImageElement.setAttribute('data-widths', "[".concat(Image.getSupportedSizes(newImage, [200, 400, 600, 700, 800, 900, 1000]).join(','), "]"));
        newImageElement.setAttribute('data-sizes', 'auto');
        mainImageContainer.replaceChild(newImageElement, mainImageContainer.querySelector('img'));
      }
    }]);

    return FeaturedProductSection;
  }();

  var BackgroundVideoSection = /*#__PURE__*/function () {
    function BackgroundVideoSection(container) {
      _classCallCheck(this, BackgroundVideoSection);

      this.element = container;
      this.options = JSON.parse(this.element.getAttribute('data-section-settings'));

      var videoHolder = this.element.querySelector('.ImageHero__VideoHolder');
      if (!videoHolder) {
        return false;
      }

      this._loadScript().then(this._setupPlayer.bind(this));
    }

    _createClass(BackgroundVideoSection, [{
      key: "_loadScript",
      value: function _loadScript() {
        var _this = this;

        return new Promise(function (resolve, reject) {
          var script = document.createElement('script');
          document.body.appendChild(script);
          script.onload = resolve;
          script.onerror = reject;
          script.async = true;
          script.src = _this.options['videoType'] === 'youtube' ? '//www.youtube.com/iframe_api' : '//player.vimeo.com/api/player.js';
        });
      }
    }, {
      key: "onUnload",
      value: function onUnload() {
        if (this.player) {
          this.player.destroy(); // Both YouTube and Vimeo use the same function name
        }
      }
    }, {
      key: "_setupPlayer",
      value: function _setupPlayer() {
        var _this2 = this;

        var elementToInsert = this.element.querySelector('.ImageHero__VideoHolder');
        var playerLoadingInterval = setInterval(function () {
          if (_this2.options['videoType'] === 'youtube') {
            if (window.YT) {
              _this2.player = new YT.Player(elementToInsert, {
                videoId: _this2.options['videoId'],
                playerVars: {
                  showinfo: 0,
                  controls: 0,
                  fs: 0,
                  rel: 0,
                  height: '100%',
                  width: '100%',
                  iv_load_policy: 3,
                  html5: 1,
                  loop: 1,
                  playsinline: 1,
                  modestbranding: 1,
                  disablekb: 1,
                  origin: _this2.options['requestHost']
                },
                events: {
                  onReady: _this2._onYouTubeReady.bind(_this2),
                  onStateChange: _this2._onYouTubeStateChange.bind(_this2)
                }
              });
              clearInterval(playerLoadingInterval);
            }
          } else {
            if (window.Vimeo) {
              _this2.player = new Vimeo.Player(elementToInsert.parentNode, {
                id: _this2.options['videoId'],
                autoplay: true,
                autopause: false,
                muted: true,
                background: true,

                /*height: '100%',
                width: '100%',*/
                loop: true
              });
              clearInterval(playerLoadingInterval);
            }
          }
        }, 50);
      }
    }, {
      key: "_onYouTubeReady",
      value: function _onYouTubeReady(event) {
        this.player.mute();
        this.player.playVideo();
      }
    }, {
      key: "_onYouTubeStateChange",
      value: function _onYouTubeStateChange(event) {
        if (event.data === YT.PlayerState.ENDED) {
          this.player.playVideo();
        }
      }
    }]);

    return BackgroundVideoSection;
  }();

  var GiftCardSection = /*#__PURE__*/function () {
    function GiftCardSection(container) {
      _classCallCheck(this, GiftCardSection);

      this.element = container;

      this._createQrCode();

      this._setupPrint();
    }

    _createClass(GiftCardSection, [{
      key: "_createQrCode",
      value: function _createQrCode() {
        var qrCodeElement = document.getElementById('QrCode');
        new QRCode(qrCodeElement, {
          text: qrCodeElement.getAttribute('data-identifier'),
          width: 120,
          height: 120
        });
      }
    }, {
      key: "_setupPrint",
      value: function _setupPrint() {
        var printElement = document.getElementById('PrintGiftCard');

        if (printElement) {
          printElement.addEventListener('click', function () {
            window.print();
          });
        }
      }
    }]);

    return GiftCardSection;
  }();

  var HeaderSection = /*#__PURE__*/function () {
    function HeaderSection(container) {
      var _this = this;

      _classCallCheck(this, HeaderSection);

      this.element = container;
      this.delegateElement = new domDelegate.Delegate(this.element);
      this.options = JSON.parse(this.element.getAttribute('data-section-settings'));
      this.lastScrollPosition = -1;
      this.isTouch = window.matchMedia('(-moz-touch-enabled: 1), (hover: none)').matches;

      if (this.options['isSticky']) {
        Stickyfill.addOne(this.element.parentNode);
      } // Set up the search bar


      this.searchBar = new SearchBar();

      this._attachListeners();

      this._verifyNavigationOverlap(); // We set again some CSS variables that are used for some calculations in CSS


      var mainLogo = this.element.querySelector('.Header__LogoImage--primary');

      if (mainLogo && !mainLogo.complete) {
        mainLogo.addEventListener('load', function () {
          fastdom.measure(function () {
            document.documentElement.style.setProperty('--header-height', _this.element.clientHeight + 'px');
            document.documentElement.style.setProperty('--header-is-not-transparent', _this.options['hasTransparentHeader'] ? 0 : 1);
          });
        });
      } else {
        fastdom.measure(function () {
          document.documentElement.style.setProperty('--header-height', _this.element.clientHeight + 'px');
          document.documentElement.style.setProperty('--header-is-not-transparent', _this.options['hasTransparentHeader'] ? 0 : 1);
        });
      }

      window.addEventListener('pageshow', this._checkTransparentHeader.bind(this));

      this._setupLocalizationPopovers();



      /*
      // ugly hack. refactor later
      // tweak megamenu, merge 4th column into 3rd column (shop set and base range)
      var megamenu = document.querySelector('.Header__MainNav .MegaMenu__Inner');
      var megamenuCol3 = megamenu.querySelector('.MegaMenu__Item:nth-child(3)');
      var megamenuCol4 = megamenu.querySelector('.MegaMenu__Item:nth-child(4)');
      var megamenuCol4A = megamenuCol4.querySelector('.MegaMenu__Item:nth-child(4) > a');
      var megamenuCol4Ul = megamenuCol4.querySelector('.MegaMenu__Item:nth-child(4) > ul');

      // megamenuCol3.style.backgroundColor = 'fuchsia';
      megamenuCol3.appendChild(megamenuCol4A);
      megamenuCol3.appendChild(megamenuCol4Ul);
      megamenuCol4.remove();
      */

      
      // ugly hack. refactor later
      // tweak megamenu, merge 3rd column into 2nd column (shop set and medical grade)
      var megamenu = document.querySelector('.Header__MainNav .MegaMenu__Inner');
      var megamenuCol2 = megamenu.querySelector('.MegaMenu__Item:nth-child(2)');
      var megamenuCol3 = megamenu.querySelector('.MegaMenu__Item:nth-child(3)');
      var megamenuCol3A = megamenuCol3.querySelector('.MegaMenu__Item:nth-child(3) > a');
      var megamenuCol3Ul = megamenuCol3.querySelector('.MegaMenu__Item:nth-child(3) > ul');

      // also merge 5th to 4th
      var megamenuCol4 = megamenu.querySelector('.MegaMenu__Item:nth-child(4)');
      var megamenuCol5 = megamenu.querySelector('.MegaMenu__Item:nth-child(5)');
      var megamenuCol5A = megamenuCol5.querySelector('.MegaMenu__Item:nth-child(5) > a');
      var megamenuCol5Ul = megamenuCol5.querySelector('.MegaMenu__Item:nth-child(5) > ul');

      megamenuCol2.appendChild(megamenuCol3A);
      megamenuCol2.appendChild(megamenuCol3Ul);
      megamenuCol3.remove();
      
      if (megamenuCol4 && megamenuCol5) {
        megamenuCol4.appendChild(megamenuCol5A);
        megamenuCol4.appendChild(megamenuCol5Ul);
        megamenuCol5.remove();  

        // // if megamenuCol5A text is 'Accessories & Gifts', hide it
        // if (megamenuCol5A.textContent === 'Accessories & Gifts') {
        //   // console.log('DEBUG: merge menu Accessories & Gifts');
        //   megamenuCol5A.style.visibility = 'hidden';
        //   megamenuCol5A.style.marginTop = '0';
        // }
      }

    }

    _createClass(HeaderSection, [{
      key: "onUnload",
      value: function onUnload() {
        this.element.removeEventListener('mouseleave', this._closeNavigationListener);
        this.element.removeEventListener('mouseenter', this._focusNavigationListener);
        this.element.removeEventListener('focusin', this._focusNavigationListener);
        this.delegateElement.off();
        window.removeEventListener('scroll', this._checkTransparentHeaderListener);
        window.removeEventListener('resize', this._verifyNavigationOverlapListener);

        if (this.options['isSticky']) {
          Stickyfill.removeOne(this.element.parentNode);
        }

        this.searchBar.destroy();
        this.localizationPopovers.forEach(function (localizationPopover) {
          localizationPopover.destroy();
        });
      }
    }, {
      key: "onSelect",
      value: function onSelect() {
        this._checkTransparentHeader();
      }
    }, {
      key: "onBlockSelect",
      value: function onBlockSelect(event) {
        var _this2 = this;

        var listItem = event.target.closest('.HorizontalList__Item');
        fastdom.mutate(function () {
          event.target.setAttribute('aria-hidden', 'false');

          if (listItem) {
            listItem.classList.add('is-expanded');
            Dom.getSiblings(listItem, '.is-expanded').forEach(function (item) {
              item.classList.remove('is-expanded');
            });
          }

          _this2.element.classList.remove('Header--transparent'); // This is needed to make sure everything is visible

        });
      }
    }, {
      key: "onBlockDeselect",
      value: function onBlockDeselect(event) {
        var listItem = event.target.closest('.HorizontalList__Item');
        fastdom.mutate(function () {
          event.target.setAttribute('aria-hidden', 'true');

          if (listItem) {
            listItem.classList.remove('is-expanded');
          }
        });

        this._checkTransparentHeader();
      }
    }, {
      key: "_attachListeners",
      value: function _attachListeners() {
        this._checkTransparentHeaderListener = this._checkTransparentHeader.bind(this);
        this._closeNavigationListener = this._closeNavigation.bind(this);
        this._focusNavigationListener = this._focusNavigation.bind(this);
        this._verifyNavigationOverlapListener = this._verifyNavigationOverlap.bind(this);
        this.element.addEventListener('mouseleave', this._closeNavigationListener);
        this.delegateElement.on('mouseenter', '.Header__MainNav .HorizontalList__Item, [aria-haspopup]', this._openMenu.bind(this), true);
        this.delegateElement.on('focusin', '[aria-haspopup]', this._openMenu.bind(this), true);
        this.delegateElement.on('focusout', '[aria-haspopup]', this._closeMenu.bind(this), false);
        this.delegateElement.on('click', '[data-action="toggle-search"]', this._closeNavigationListener);
        this.delegateElement.on('mouseleave', '.DropdownMenu [aria-haspopup]', this._closeMenu.bind(this), true);
        this.delegateElement.on('mouseenter', '.DropdownMenu [aria-haspopup]', this._adjustDropdownPosition.bind(this), true);

        if (this.isTouch) {
          this.delegateElement.on('click', '.Header__MainNav [aria-haspopup]', this._handleTouchMenu.bind(this));
        }

        if (this.options['hasTransparentHeader']) {
          this.element.addEventListener('mouseenter', this._focusNavigationListener);
          this.element.addEventListener('focusin', this._focusNavigationListener);
        }

        if (this.options['isSticky'] && this.options['hasTransparentHeader']) {
          window.addEventListener('scroll', this._checkTransparentHeaderListener);
        }

        if (this.options['navigationStyle'] === 'inline' || this.options['navigationStyle'] === 'logoLeft') {
          window.addEventListener('resize', this._verifyNavigationOverlapListener);
        }
      }
    }, {
      key: "_setupLocalizationPopovers",
      value: function _setupLocalizationPopovers() {
        this.localizationPopovers = [];
        Dom.nodeListToArray(document.querySelectorAll('#header-locale-popover')).forEach(function (item, index) {
          item.id = "".concat(item.id, "-").concat(index);
        });
        Dom.nodeListToArray(document.querySelectorAll('[aria-controls="header-locale-popover"]')).forEach(function (item, index) {
          item.setAttribute('aria-controls', "".concat(item.getAttribute('aria-controls'), "-").concat(index));
        });
        Dom.nodeListToArray(document.querySelectorAll('#header-currency-popover')).forEach(function (item, index) {
          item.id = "".concat(item.id, "-").concat(index);
        });
        Dom.nodeListToArray(document.querySelectorAll('[aria-controls="header-currency-popover"]')).forEach(function (item, index) {
          item.setAttribute('aria-controls', "".concat(item.getAttribute('aria-controls'), "-").concat(index));
        });
        var localePopoverElement1 = document.getElementById('header-locale-popover-0');

        if (localePopoverElement1) {
          this.localizationPopovers.push(new Popover(localePopoverElement1, {
            preferredAlignment: 'center',
            preferredPosition: 'bottom',
            threshold: 12
          }));
        }

        var localePopoverElement2 = document.getElementById('header-locale-popover-1');

        if (localePopoverElement2) {
          this.localizationPopovers.push(new Popover(localePopoverElement2, {
            preferredAlignment: 'center',
            preferredPosition: 'bottom',
            threshold: 12
          }));
        }

        var currencyPopoverElement1 = document.getElementById('header-currency-popover-0');

        if (currencyPopoverElement1) {
          this.localizationPopovers.push(new Popover(currencyPopoverElement1, {
            preferredAlignment: 'center',
            preferredPosition: 'bottom',
            threshold: 12
          }));
        }

        var currencyPopoverElement2 = document.getElementById('header-currency-popover-1');

        if (currencyPopoverElement2) {
          this.localizationPopovers.push(new Popover(currencyPopoverElement2, {
            preferredAlignment: 'center',
            preferredPosition: 'bottom',
            threshold: 12
          }));
        }
      }
    }, {
      key: "_focusNavigation",
      value: function _focusNavigation() {
        var _this3 = this;

        fastdom.mutate(function () {
          if (!_this3.isTouch || Responsive.matchesBreakpoint('desk')) {
            _this3.element.classList.remove('Header--transparent');
          }
        });
      }
    }, {
      key: "_closeNavigation",
      value: function _closeNavigation() {
        var _this4 = this;

        fastdom.mutate(function () {
          Dom.nodeListToArray(_this4.element.querySelectorAll('.is-expanded')).forEach(function (item) {
            item.classList.remove('is-expanded');
          });
          Dom.nodeListToArray(_this4.element.querySelectorAll('.Header__MainNav [aria-hidden="false"]')).forEach(function (item) {
            item.setAttribute('aria-hidden', 'true');
          });
        });

        if (this.options['hasTransparentHeader']) {
          this._checkTransparentHeader();
        }
      }
    }, {
      key: "_openMenu",
      value: function _openMenu(event, target) {
        if (event.type === 'mouseenter' && target !== event.target) {
          return;
        }

        fastdom.mutate(function () {
          target.classList.add('is-expanded');
          Dom.nodeListToArray(target.children, '.Header__MainNav [aria-hidden="true"]').forEach(function (item) {
            item.setAttribute('aria-hidden', 'false');
          });
          Dom.getSiblings(target, '.is-expanded').forEach(function (item) {
            item.classList.remove('is-expanded');
            Dom.nodeListToArray(item.children, '.Header__MainNav [aria-hidden="false"]').forEach(function (item) {
              item.setAttribute('aria-hidden', 'true');
            });
          });
        });
      }
    }, {
      key: "_closeMenu",
      value: function _closeMenu(event, target) {
        if (event.type === 'mouseleave' && target !== event.target) {
          return;
        }

        fastdom.mutate(function () {
          target.classList.remove('is-expanded');
          Dom.nodeListToArray(target.children, '.Header__MainNav [aria-hidden="false"]').forEach(function (item) {
            item.setAttribute('aria-hidden', 'true');
          });
        });
      }
    }, {
      key: "_adjustDropdownPosition",
      value: function _adjustDropdownPosition(event, target) {
        var nestedMenus = Dom.nodeListToArray(target.querySelectorAll('.DropdownMenu')),
            shouldOpenLeft = false;
        fastdom.measure(function () {
          var windowWidth = window.innerWidth,
              rightEdge = target.getBoundingClientRect().right;
          nestedMenus.forEach(function (item) {
            if (rightEdge + item.offsetWidth > windowWidth) {
              shouldOpenLeft = true;
            }
          });
        });
        fastdom.mutate(function () {
          if (shouldOpenLeft) {
            nestedMenus.forEach(function (item) {
              item.classList.add('DropdownMenu--reversed');
            });
          } else {
            nestedMenus.forEach(function (item) {
              item.classList.remove('DropdownMenu--reversed');
            });
          }
        });
      }
      /**
       * On touch devices where we display the standard menu (like landscape iPad or Surface) we need to do additional code to properly
       * handle the opening of menu. Especially, what we do is that if an item has a sub-menu, a click does not follow the link but instead open
       * the sub-menu. If this link is clicked a second twice, then the menu is followed
       */

    }, {
      key: "_handleTouchMenu",
      value: function _handleTouchMenu(event, target) {
        if (!target.classList.contains('is-expanded')) {
          event.preventDefault();
        }
      }
    }, {
      key: "_verifyNavigationOverlap",
      value: function _verifyNavigationOverlap() {
        var _this5 = this;

        var isOverlapping = false,
            mainTopMenu = this.element.querySelector('.Header__MainNav');
        fastdom.measure(function () {
          // To detect if the navigation is overlapping, we take the height of a single item and check if its height is taller than the parent
          if (mainTopMenu) {
            // Get the first element
            var firstNavElementHeight = Dom.outerHeightWithMargin(mainTopMenu.querySelector('.HorizontalList__Item')),
                mainNavHeight = mainTopMenu.scrollHeight;

            if (mainNavHeight > firstNavElementHeight) {
              isOverlapping = true;
            }
          }
        });
        this.element.classList.remove('Header--logoLeft', 'Header--inline', 'Header--center');
        this.element.classList.add("Header--".concat(this.options['navigationStyle']));
        this.element.clientWidth; // Forces a reflow

        fastdom.mutate(function () {
          if (isOverlapping) {
            _this5.element.classList.remove("Header--".concat(_this5.options['navigationStyle']));

            // _this5.element.classList.add('Header--center'); // Check if still overlapping despite changing the mode
            _this5.element.classList.add('Header--logoLeft'); 


            if (mainTopMenu) {
              // Get the first element
              var itemTopSet = new Set();
              Array.from(mainTopMenu.querySelectorAll('.HorizontalList__Item')).forEach(function (item) {
                itemTopSet.add(item.getBoundingClientRect().top);
              });
              isOverlapping = itemTopSet.size > 1;
            }
          } else {
            _this5.element.classList.add("Header--".concat(_this5.options['navigationStyle']));

            // _this5.element.classList.remove('Header--center');
          }

          var logo = _this5.element.querySelector('.Header__FlexItem--logo');

          logo.classList.toggle('Header__FlexItem--increaseSpace', isOverlapping);

          _this5.element.classList.add('Header--initialized');

          fastdom.measure(function () {
            document.documentElement.style.setProperty('--header-height', _this5.element.clientHeight + 'px');
          });
        });
      }
      /**
       * If the header mode is set to "transparent", we have to do extra work to automatically make it with fill colors when the
       * user starts scrolling. For performance we are using fastDOM to do that (which relies of requestAnimationFrame instead of
       * scroll listener)
       */

    }, {
      key: "_checkTransparentHeader",
      value: function _checkTransparentHeader() {
        var _this6 = this;

        if (!this.options['hasTransparentHeader']) {
          return;
        }

        var scrollThreshold = 10;
        fastdom.measure(function () {
          _this6.lastScrollPosition = window.pageYOffset;
        });
        fastdom.mutate(function () {
          if (_this6.lastScrollPosition <= scrollThreshold) {
            _this6.element.classList.add('Header--transparent');
          } else {
            _this6.element.classList.remove('Header--transparent');
          }
        });
      }
    }]);

    return HeaderSection;
  }();

  var FooterSection = /*#__PURE__*/function () {
    function FooterSection(container) {
      _classCallCheck(this, FooterSection);

      this.element = container;
      var localePopoverElement = document.getElementById('footer-locale-popover');

      if (localePopoverElement) {
        this.localePopover = new Popover(localePopoverElement, {
          preferredAlignment: 'center',
          preferredPosition: 'top',
          threshold: 12
        });
      }

      var currencyPopoverElement = document.getElementById('footer-currency-popover');

      if (currencyPopoverElement) {
        this.currencyPopover = new Popover(currencyPopoverElement, {
          preferredAlignment: 'center',
          preferredPosition: 'top',
          threshold: 12
        });
      }
    }

    _createClass(FooterSection, [{
      key: "onUnload",
      value: function onUnload() {
        if (this.localePopover) {
          this.localePopover.destroy();
        }

        if (this.currencyPopover) {
          this.currencyPopover.destroy();
        }
      }
    }]);

    return FooterSection;
  }();

  var ImageWithTextBlockSection = /*#__PURE__*/function () {
    function ImageWithTextBlockSection(container) {
      _classCallCheck(this, ImageWithTextBlockSection);

      this.element = container;
    }

    _createClass(ImageWithTextBlockSection, [{
      key: "onUnload",
      value: function onUnload() {}
    }]);

    return ImageWithTextBlockSection;
  }();

  var LoginSection = /*#__PURE__*/function () {
    function LoginSection(container) {
      _classCallCheck(this, LoginSection);

      this.element = container;
      this.delegateElement = new domDelegate.Delegate(this.element);
      this.timelineLite = new TimelineLite();
      this.customerLoginForm = this.element.querySelector('#customer_login');
      this.recoverPasswordForm = this.element.querySelector('#recover_customer_password');
      this.delegateElement.on('click', '[data-action="toggle-recover-form"]', this._showRecoverPassword.bind(this));
    }

    _createClass(LoginSection, [{
      key: "_showRecoverPassword",
      value: function _showRecoverPassword() {
        var isLoginActive = this.customerLoginForm.style.display === 'block';

        if (isLoginActive) {
          this.timelineLite.fromTo(this.customerLoginForm, 0.5, {
            autoAlpha: 1,
            display: 'block',
            y: 0
          }, {
            autoAlpha: 0,
            y: 20,
            display: 'none'
          }).fromTo(this.recoverPasswordForm, 0.5, {
            autoAlpha: 0,
            display: 'none',
            y: 20
          }, {
            autoAlpha: 1,
            display: 'block',
            y: 0,
            delay: 0.25
          });
        } else {
          this.timelineLite.fromTo(this.recoverPasswordForm, 0.5, {
            autoAlpha: 1,
            display: 'block',
            y: 0
          }, {
            autoAlpha: 0,
            y: 20,
            display: 'none'
          }).fromTo(this.customerLoginForm, 0.5, {
            autoAlpha: 0,
            display: 'none',
            y: 20
          }, {
            autoAlpha: 1,
            display: 'block',
            y: 0,
            delay: 0.25
          });
        }
      }
    }]);

    return LoginSection;
  }();

  var MapSection = /*#__PURE__*/function () {
    function MapSection(element) {
      _classCallCheck(this, MapSection);

      this.element = element;
      this.options = JSON.parse(element.getAttribute('data-section-settings'));

      if (this.options['apiKey'] && this.options['mapAddress']) {
        this._loadScript().then(this._initMap.bind(this));
      }
    }

    _createClass(MapSection, [{
      key: "_loadScript",
      value: function _loadScript() {
        var _this = this;

        return new Promise(function (resolve, reject) {
          var script = document.createElement('script');
          document.body.appendChild(script);
          script.onload = resolve;
          script.onerror = reject;
          script.async = true;
          script.src = "https://maps.googleapis.com/maps/api/js?key=".concat(_this.options['apiKey']);
        });
      }
    }, {
      key: "_initMap",
      value: function _initMap() {
        var _this2 = this;

        var geocoder = new google.maps.Geocoder();
        geocoder.geocode({
          address: this.options['mapAddress']
        }, function (results, status) {
          if (status !== google.maps.GeocoderStatus.OK) {
            if (Shopify.designMode) ;
          } else {
            var mapOptions = {
              zoom: _this2.options['zoom'],
              center: results[0].geometry.location,
              draggable: false,
              clickableIcons: false,
              scrollwheel: false,
              disableDoubleClickZoom: true,
              disableDefaultUI: true
            };
            var map = new google.maps.Map(_this2.element.querySelector('.FeaturedMap__GMap'), mapOptions),
                center = map.getCenter();
            map.setCenter(center);
            var icon = {
              path: "M32.7374478,5.617 C29.1154478,1.995 24.2994478,0 19.1774478,0 C14.0544478,0 9.23944778,1.995 5.61744778,5.617 C-1.08555222,12.319 -1.91855222,24.929 3.81344778,32.569 L19.1774478,54.757 L34.5184478,32.6 C40.2734478,24.929 39.4404478,12.319 32.7374478,5.617 Z M19.3544478,26 C15.4954478,26 12.3544478,22.859 12.3544478,19 C12.3544478,15.141 15.4954478,12 19.3544478,12 C23.2134478,12 26.3544478,15.141 26.3544478,19 C26.3544478,22.859 23.2134478,26 19.3544478,26 Z",
              fillColor: _this2.options['markerColor'],
              fillOpacity: 1,
              anchor: new google.maps.Point(15, 55),
              strokeWeight: 0,
              scale: 0.6
            };
            new google.maps.Marker({
              map: map,
              position: map.getCenter(),
              icon: icon
            });
            var styledMapType = new google.maps.StyledMapType(JSON.parse(_this2.element.querySelector('[data-gmap-style]').innerHTML));
            map.mapTypes.set('styled_map', styledMapType);
            map.setMapTypeId('styled_map');
            google.maps.event.addDomListener(window, 'resize', function () {
              google.maps.event.trigger(map, 'resize');
              map.setCenter(center);
            });
          }
        });
      }
    }]);

    return MapSection;
  }();

  var NewsletterPopupSection = /*#__PURE__*/function () {
    function NewsletterPopupSection(element) {
      _classCallCheck(this, NewsletterPopupSection);

      this.element = element;
      this.delegateElement = new domDelegate.Delegate(this.element);
      this.options = JSON.parse(element.getAttribute('data-section-settings')); // If the popup has been already displayed, we do not display it

      try {
        if (window.location.hash === '#newsletter-popup' && window.theme.pageType !== null) {
          this._openPopup();
        } else if (!this.options['showOnlyOnce'] || this.options['showOnlyOnce'] && localStorage.getItem('themePopup') === null) {
          setTimeout(this._openPopup.bind(this), this.options['apparitionDelay'] * 1000);
        }
      } catch (error) {// Some browsers (especially in private mode) throw an exception when trying to access local storage, so we protect ourselves here
      }

      this._attachListeners();
    }

    _createClass(NewsletterPopupSection, [{
      key: "onUnload",
      value: function onUnload() {
        this.delegateElement.off();
      }
    }, {
      key: "onSelect",
      value: function onSelect() {
        this._openPopup();
      }
    }, {
      key: "onDeselect",
      value: function onDeselect() {
        this._closePopup();
      }
    }, {
      key: "_attachListeners",
      value: function _attachListeners() {
        this.delegateElement.on('click', '[data-action="close-popup"]', this._closePopup.bind(this));
      }
    }, {
      key: "_openPopup",
      value: function _openPopup() {
        this.element.setAttribute('aria-hidden', 'false');
        localStorage.setItem('themePopup', 'true');
      }
    }, {
      key: "_closePopup",
      value: function _closePopup() {
        this.element.setAttribute('aria-hidden', 'true');
      }
    }]);

    return NewsletterPopupSection;
  }();

  var ProductRecommendationsSection = /*#__PURE__*/function () {
    function ProductRecommendationsSection(container) {
      _classCallCheck(this, ProductRecommendationsSection);

      this.element = container;
      this.options = JSON.parse(this.element.getAttribute('data-section-settings'));

      if (this.options['useQuizRecommendations']) {
        // quiz recommendations
        this._loadQuizRecommendations();//.then(this._createSlideshow.bind(this));
      } else if (this.options['useRecommendations']) {
        this._loadRecommendations().then(this._createSlideshow.bind(this));
      } else {
        this._createSlideshow();
      }


      this._pairsRecommendations();


    }

    _createClass(ProductRecommendationsSection, [{
      key: "onUnload",
      value: function onUnload() {
        this.carousel.destroy();
      }
    }, {
      key: "_loadRecommendations",
      value: function _loadRecommendations() {
        var _this = this;

        var url = "".concat(window.routes.productRecommendationsUrl, "?section_id=").concat(this.element.getAttribute('data-section-id'), "&product_id=").concat(this.options['productId'], "&limit=").concat(this.options['recommendationsCount']);
        return fetch(url).then(function (response) {
          return response.text().then(function (content) {
            var container = document.createElement('div');
            container.innerHTML = content;
            _this.element.querySelector('.ProductRecommendations').innerHTML = container.querySelector('.ProductRecommendations').innerHTML;
          });
        });
      }
    }, {
      key: "_createSlideshow",
      value: function _createSlideshow() {
        var flickityElement = this.element.querySelector('.ProductRecommendations [data-flickity-config]');

        if (!flickityElement) {
          return;
        }

        this.carousel = new Carousel(flickityElement); // Setup product item color swatch

        new ProductItemColorSwatch(this.element);
      }
    }, {
      key: "_loadQuizRecommendations",
      value: function _loadQuizRecommendations() {
        console.log('DEBUG: 💪💪💪 this is quiz recommendations!');
        var _this = this;

        // we will fetch data from allproducts json collection, which is contains all products, then compare with products recommendation data

        document.addEventListener('theme:form:recommendations', function(event) {
          var status = event.detail.status; 
          var products = event.detail.products; 

          // // simulate empty product
          // products = [];

          console.log('DEBUG:🎉🎉🎉  recommendations received', status, products);
  

          if (products && products.length) {
            return fetch('/collections/all-products-json/?view=allproductsjson').then(function (response) {
              return response.text().then(function (data) {
                // console.log('DEBUG: fetched content', data);
  
                var parsed;
                var $data;
                var recommended = [];
                var html = ''; // html string, need to be same format as shopify ajax output from recommendation url window.routes.productRecommendationsUrl
                var container;
                var content;
                var recommendedVessel = [];
                var recommendedRefill = [];

                if (data) {
                  // in OS 2.0, section always wrapped by tag, so its not pure json code, we have to unwrap first
                  
                  $data = document.createElement('div');
                  $data.innerHTML = data;
                  
                  $data = $data.querySelector('.shopify-section');
                  data = $data.textContent; // json text
                  // console.log('DEBUG: textcontent', $data.textContent);
  
                  // convert to js object
                  try {
                    parsed = JSON.parse(data);
                    // filterMatchData(bottomMatchData, size);
                    // console.log('DEBUG: parsed', parsed);
      
                    // filter only recommended variants
                    parsed.products.forEach(function(product) {
                      if (products.indexOf(product.handle) > -1) {
      
                        // console.log('DEBUG: product', product.id, 'recommended');
                        recommended.push(product);
                      }
                    });
      
      
                  } catch(e) {
                      console.log('ERROR: Invalid data');
                  }
  
                  if (recommended.length) {
                    // Ordering recommendation, refill last
                    console.log('DEBUG: recommended', recommended);
                    // console.log('DEBUG: 💲💲💲💲💲💲💲 lets ordering the recommendation');
  
                    if (recommended.length) {
                      recommended.forEach(function(product) {
                        if (product.handle.indexOf('-refill') > -1) {
                          recommendedRefill.push(product);
                        } else {
                          recommendedVessel.push(product);
                        }
                      });

                      recommended = recommendedVessel.concat(recommendedRefill);

                    }

                    // console.log('recommended after sorting', recommended);
                    
                    // build html string for each product
                    recommended.forEach(function(product) {
                      html += `<div class="Carousel__Cell">`;
                      html += `<div class="ProductItem "><div class="ProductItem__Wrapper"><a href="${product.url}" class="ProductItem__ImageWrapper ">`;
                      // html += `hello`;
                      html += `<div class="AspectRatio AspectRatio--square"
                                  style="max-width: 1294px; --aspect-ratio: 0.994619523443505">
                                  <img class="ProductItem__Image Image--lazyLoad Image--fadeIn"
                                      data-src="${product.image}"
                                      data-widths="[200,400,600,700,800,900,1000,1200]" data-sizes="auto"
                                      alt="${product.title}">
                                  <span class="Image__Loader"></span>
                              </div>

                              <div class="ProductItem__LabelList">
                                <div class="ProductItem__LabelRecommended">Recommended</div>
                              </div>

                              <div class="ProductItem__Info ProductItem__Info--left ">
                                  <!--<p class="ProductItem__PrescriptionInfo">Clinical Strength</p>-->
                                  <h2 class="ProductItem__Title">
                                      ${product.title}
                                  </h2>
                              </div>
                        `;
                      html += ``;
                      html += ``;
                      html += ``;
                      html += ``;
                      html += ``;
                      html += `</a></div></div>`;
                      html += `</div>`;
                    });
  
                    // console.log('DEBUG: html', html);
  
                    // build html wrapper
                    html = `
                        <div class="ProductRecommendations">
                            <div class="ProductListWrapper flickity">
                                <div class="ProductList ProductList--carousel Carousel" data-flickity-config='{
                                "prevNextButtons": true,
                                "pageDots": false,
                                "wrapAround": false,
                                "contain": true,
                                "cellAlign": "center",
                                "watchCSS": true,
                                "dragThreshold": 8,
                                "groupCells": true,
                                "arrowShape": {"x0": 20, "x1": 60, "y1": 40, "x2": 60, "y2": 35, "x3": 25}
                              }'>` + html + ` </div>
                              </div>
                          </div>
                      `;
  
                    // append it to dom
                    container = document.createElement('div');
                    content = html;
                    container.innerHTML = content;
                    _this.element.querySelector('.ProductRecommendations').innerHTML = container.querySelector('.ProductRecommendations').innerHTML;    
  
  
                  } else {
                    // TODO: hide the recommended section
                  }
                  
                }
    
              })
              .then(_this._createSlideshow.bind(_this))
              .then(function() {
                // ClueEdit - resize, because when recommendations displayed, parent section shown, there are other carousel (pairs well with) within the section that need to be recalculated
                window.dispatchEvent(new Event('resize'));
              });
            });
              
          } else {
            console.log('DEBUG: recommendation not found, try to use default');
            _this._loadRecommendations().then(_this._createSlideshow.bind(_this))
            .then(function() {
              // ClueEdit - resize, because when recommendations displayed, parent section shown, there are other carousel (pairs well with) within the section that need to be recalculated
              window.dispatchEvent(new Event('resize'));
            });

          }


        });


        
      }
    }, {
      key: "_pairsRecommendations",
      value: function _pairsRecommendations() {
        console.log('DEBUG: 💪💪💪 this is pairs recommendations!');
        var _this = this;


        // tabs
        var tabs;
        var tabsEl = document.getElementById("product-recommendations-tabs");
        var recommendationTabContent;
        var recommendationsContent;
        var pairsFlickityElement;
        var pairsTabContent;
        var pairsContent;

        // var enablePairs = this.options
        console.log('DEBUG: options 🤑🤑',_this.options);
        var enablePairs = _this.options['enablePairs'];

        if (tabsEl && enablePairs) {
          tabs = new Tabs({
            elem: "product-recommendations-tabs",
            open: 0
          });  

          // move .ProductRecommendations
          recommendationTabContent = document.querySelector('.js-tabs__content--recommendations');
          recommendationsContent = document.querySelector('.ProductRecommendations');
  
          recommendationTabContent.appendChild(recommendationsContent);

          // move .ProductRecommendations
          pairsTabContent = document.querySelector('.js-tabs__content--pairs');
          pairsContent = document.querySelector('.ProductPairs');
          pairsTabContent.appendChild(pairsContent);


          tabsEl.style.display = '';

          // hide header
          document.querySelector('.SectionHeader--productRecommendations').style.display = 'none';

          pairsFlickityElement = _this.element.querySelector('.ProductPairs [data-flickity-config]');

          if (!pairsFlickityElement) {
            return;
          }
  
          _this.pairsCarousel = new Carousel(pairsFlickityElement);     
          
          
          // enable recommendation badge on productpairs
          // listen to even recommendations
          document.addEventListener('theme:form:recommendations', function(event) {
            var status = event.detail.status; 
            var products = event.detail.products; 

            console.log('DEBUG:🎉🎉🎉  recommendations received', status, products);
            // hide products other than recommendations
            var $productItems = document.querySelectorAll('.ProductPairs .ProductItem');
            Array.from($productItems).forEach(function($el) {
              // console.log('DEBUG: $el', $el);
              var url = $el.querySelector('.ProductItem__Wrapper > a').getAttribute('href');
              var handle = getHandleFromUrl(url);
              // console.log('DEBUG: url', handle);
              var $parent = $el.parentElement;
              // console.log('DEBUG: parent', $parent);
              var $label = $el.querySelector('.ProductItem__LabelRecommended');
              var indexRefillSuffix = -1;
    
              if ((products.indexOf(handle) > -1)) {
                // show label
                $label.style.display = 'block';
              }
    
            });

            // // in collection recommendations page, remove loading, show products
            // if (_this4._collectionRecommendationsPage()) {
            //   document.body.classList.remove(loadingClass);
            // }      
            
    
          });
          

        }


        
      }
    }]);

    return ProductRecommendationsSection;
  }();

  var ProductSection = /*#__PURE__*/function () {
    function ProductSection(container) {
      var _this = this;

      _classCallCheck(this, ProductSection);

      this.element = container;
      this.delegateElement = new domDelegate.Delegate(this.element);
      this.options = JSON.parse(this.element.getAttribute('data-section-settings'));
      this.viewInSpaceElement = this.element.querySelector('[data-shopify-xr]');

      if (this.options['templateSuffix'] !== 'coming-soon') {
        this.productVariants = new ProductVariants(container, this.options);
      }

      this.productReviews = new ProductReviews(container);
      var productSlideshowElement = this.element.querySelector('.Product__Slideshow'); // If there is no image at all, there is nothing to init

      if (productSlideshowElement) {
        this.productSlideshow = new Carousel(productSlideshowElement, {
          onSelect: this._onImageChanged.bind(this),
          onSettle: this._onImageSettled.bind(this)
        }, {
          draggable: !Responsive.matchesBreakpoint('supports-hover')
        });
        this.mediaList = {}; // We keep track of a list of media element

        this.previouslySelectedMedia = null; // Keep track of the previously selected media
        // For each model and video, we register a media

        productSlideshowElement.querySelectorAll('[data-media-type="model"]').forEach(function (model) {
          _this.mediaList[model.getAttribute('data-media-id')] = new ProductModel(model, _this.options['stackProductImages']);
        });
        productSlideshowElement.querySelectorAll('[data-media-type="video"], [data-media-type="external_video"]').forEach(function (video) {
          _this.mediaList[video.getAttribute('data-media-id')] = new ProductVideo(video, _this.options['stackProductImages'], _this.options['enableVideoLooping']);
        });

        if (this.options['stackProductImages']) {
          this.slideshowNavDots = this.element.querySelector('.Product__SlideshowNav--dots');
          this.slideshowNavDotsItems = this.slideshowNavDots ? Dom.nodeListToArray(this.slideshowNavDots.querySelectorAll('a')) : [];
        }

        if (this.options['showThumbnails']) {
          this.slideshowNavThumbnails = this.element.querySelector('.Product__SlideshowNav--thumbnails');
          this.slideshowNavThumbnailsItems = this.slideshowNavThumbnails ? Dom.nodeListToArray(this.slideshowNavThumbnails.querySelectorAll('.Product__SlideshowNavImage')) : [];
        }

        this.slideshowImages = Dom.nodeListToArray(productSlideshowElement.querySelectorAll('.Carousel__Cell')); // Setup the mobile nav

        this._setupSlideshowMobileNav();
      }

      this.productWrapperElement = this.element.querySelector('.Product__Wrapper');
      this.productInfoElement = this.element.querySelector('.Product__Info');
      this.productAsideElement = this.element.querySelector('.Product__Aside');
      this.productGalleryElement = this.element.querySelector('.Product__Gallery');
      this.quickNav = this.element.querySelector('.Product__QuickNav');

      if (this.options['enableImageZoom']) {
        this.imageZoomInstance = new ProductImageZoom(this.element, this.productSlideshow);
      }

      Stickyfill.addOne(this.productInfoElement); // We have to re-order elements in the DOM

      var offscreenElement = this.element.querySelector('.Product__OffScreen');

      if (offscreenElement) {
        this.element.appendChild(offscreenElement);
      }

      this._setupDeviceFeatures();

      this._attachListeners();

      this._productRecommendations();

      // refill button
      this._refillButton();

      // clinic only
      this._clinicOnly();

      console.log('DEBUG: products section');

      var tabs = new Tabs({
        elem: "tabs",
        open: 0
      });      

    }

    _createClass(ProductSection, [{
      key: "onUnload",
      value: function onUnload() {
        this.delegateElement.off('click');
        this.productReviews.destroy();

        if (this.productVariants) {
          this.productVariants.destroy();
        }

        if (this.productSlideshow) {
          this.productSlideshow.destroy();
        }

        if (this.options['enableImageZoom']) {
          this.imageZoomInstance.destroy();
        }

        if (this.carouselNavScrollSpy) {
          this.carouselNavScrollSpy.destroy();
        }

        if (this.quickNav) {
          window.removeEventListener('scroll', this._checkQuickNavListener);
        }

        if (this.productInfoScroller) {
          this.productInfoScroller.destroy();
        }

        if (this.productThumbnailsScroller) {
          this.productThumbnailsScroller.destroy();
        }

        if (window.ResizeObserver && this.productInfoResizeObserver) {
          this.productInfoResizeObserver.disconnect();
        }

        Stickyfill.removeOne(this.productInfoElement);
        document.removeEventListener('breakpoint:changed', this._onBreakpointChangedListener);
      }
    }, {
      key: "_attachListeners",
      value: function _attachListeners() {
        this._onBreakpointChangedListener = this._setupDeviceFeatures.bind(this);
        this._checkQuickNavListener = this._checkQuickNav.bind(this);
        this.delegateElement.on('click', '[data-action="toggle-social-share"]', this._toggleSocialShare.bind(this));
        this.delegateElement.on('variant:changed', this._updateSlideshowImage.bind(this));
        this.delegateElement.on('scrollspy:target:changed', this._onScrollTargetChanged.bind(this));
        this.delegateElement.on('model:played', this._onMediaPlayed.bind(this));
        this.delegateElement.on('video:played', this._onMediaPlayed.bind(this));
        this.delegateElement.on('model:paused', this._onMediaPaused.bind(this));
        this.delegateElement.on('video:paused', this._onMediaPaused.bind(this));
        document.addEventListener('breakpoint:changed', this._onBreakpointChangedListener);

        if (this.quickNav) {
          window.addEventListener('scroll', this._checkQuickNavListener);
        }

        if (!this.options['stackProductImages'] && this.options['showThumbnails']) {
          this.delegateElement.on('click', '.Product__SlideshowNavImage', this._switchToImage.bind(this));
        }
      }
    }, {
      key: "_setupSlideshowMobileNav",
      value: function _setupSlideshowMobileNav() {
        var _this2 = this;

        this.slideshowMobileNav = this.element.querySelector('.Product__SlideshowMobileNav');

        if (this.slideshowMobileNav) {
          var slideshowMobileNavDelegate = new domDelegate.Delegate(this.slideshowMobileNav); // Handle the dot

          slideshowMobileNavDelegate.on('click', '.dot', function (event, element) {
            _this2._slideWillChange();

            _this2.productSlideshow.selectCell(parseInt(element.getAttribute('data-index')));
          }); // Handle the buttons

          slideshowMobileNavDelegate.on('click', '.Product__SlideshowNavArrow', function (event, element) {
            _this2._slideWillChange();

            if (element.getAttribute('data-direction') === 'next') {
              _this2.productSlideshow.next();
            } else {
              _this2.productSlideshow.previous();
            }
          });
        }
      }
      /**
       * Update the main carousel image
       */

    }, {
      key: "_updateSlideshowImage",
      value: function _updateSlideshowImage(event) {
        var variant = event.detail.variant,
            previousVariant = event.detail.previousVariant;

        if (!variant || !variant['featured_media'] || previousVariant && previousVariant['featured_media'] && previousVariant['featured_media']['id'] === variant['featured_media']['id']) {
          return;
        } // We have two logic here: if we are on pocket mode, we switch using the carousel, otherwise we simulate a link to the anchor


        this._slideWillChange();

        if (Responsive.matchesBreakpoint('pocket') || !this.options['stackProductImages']) {
          for (var i = 0; i !== this.productSlideshow.flickityInstance.cells.length; ++i) {
            var cellElement = this.productSlideshow.flickityInstance.cells[i].element,
                mediaId = parseInt(cellElement.getAttribute('data-media-id'));

            if (mediaId === variant['featured_media']['id']) {
              this.productSlideshow.selectCell(parseInt(cellElement.getAttribute('data-media-position')) - 1);
            }
          }
        } else {
          document.querySelector("[href=\"#Media".concat(variant['featured_media']['id'], "\"]")).click(); //document.getElementById(`Media${variant['featured_media']['id']}`).scrollIntoView({behavior: 'smooth'});
        }
      }
      /**
       * This happens when a media is played
       */

    }, {
      key: "_onMediaPlayed",
      value: function _onMediaPlayed(event) {
        // Remove draggability
        this.productSlideshow.getFlickityInstance().options.draggable = false;
        this.productSlideshow.getFlickityInstance().unbindDrag(); // If there is a previously enabled media, we disable it

        if (this.previouslySelectedMedia && this.previouslySelectedMedia !== event.target) {
          this.mediaList[this.previouslySelectedMedia.getAttribute('data-media-id')].hasBeenDeselected();
        } // If the slideshow is configured to stack images, the "select" method from the carousel is not called, so we
        // have to keep track of it here


        if (this.options['stackProductImages']) {
          this.previouslySelectedMedia = event.target;
        }
      }
      /**
       * This happens when a given media is paused
       */

    }, {
      key: "_onMediaPaused",
      value: function _onMediaPaused() {
        // Enable draggability
        this.productSlideshow.getFlickityInstance().options.draggable = !Responsive.matchesBreakpoint('supports-hover');
        this.productSlideshow.getFlickityInstance().bindDrag();
      }
      /**
       * This method is called when a media changed in the slideshow
       */

    }, {
      key: "_handleMedia",
      value: function _handleMedia(item) {
        // First, we need to turn off the previous media (if any)
        if (this.previouslySelectedMedia && this.previouslySelectedMedia !== item) {
          switch (this.previouslySelectedMedia.getAttribute('data-media-type')) {
            case 'video':
            case 'external_video':
            case 'model':
              this.mediaList[this.previouslySelectedMedia.getAttribute('data-media-id')].hasBeenDeselected();
          } // If the previous media was a model, we need to adjust the "view in space" button to go back to initial value


          if (this.previouslySelectedMedia.getAttribute('data-media-type') === 'model' && this.viewInSpaceElement) {
            this.viewInSpaceElement.setAttribute('data-shopify-model3d-id', this.viewInSpaceElement.getAttribute('data-shopify-model3d-default-id'));
          }
        } // Then, we have to handle the currently selected media


        switch (item.getAttribute('data-media-type')) {
          case 'video':
          case 'external_video':
          case 'model':
            this.mediaList[item.getAttribute('data-media-id')].hasBeenSelected();
            break;
        } // If the media is a model, we need to adjust the "view in space" button


        if (item.getAttribute('data-media-type') === 'model' && this.viewInSpaceElement) {
          this.viewInSpaceElement.setAttribute('data-shopify-model3d-id', item.getAttribute('data-media-id'));
        } // We set the previously selected media to the currently new one, so that when it changes it can be properly accounted


        this.previouslySelectedMedia = item;
      }
      /**
       * Callback when the target changes
       */

    }, {
      key: "_onScrollTargetChanged",
      value: function _onScrollTargetChanged(event) {
        // The scrollspy emit also an "oldTarget", but when scrolling very fast with Firefox or Safari, it prevents the old to be removed, so we
        // manually iterate through all of them to remove it first
        if (this.options['stackProductImages']) {
          this.slideshowNavDotsItems.forEach(function (item) {
            return item.classList.remove('is-selected');
          });
          this.slideshowNavDotsItems[parseInt(event.detail.newTarget.getAttribute('data-media-position')) - 1].classList.add('is-selected');

          if (this.options['showThumbnails']) {
            this.slideshowNavThumbnailsItems.forEach(function (item) {
              return item.classList.remove('is-selected');
            });
            this.slideshowNavThumbnailsItems[parseInt(event.detail.newTarget.getAttribute('data-media-position')) - 1].classList.add('is-selected');
          }
        }
      }
    }, {
      key: "_switchToImage",
      value: function _switchToImage(event, target) {
        event.preventDefault();

        this._slideWillChange();

        for (var i = 0; i !== this.productSlideshow.flickityInstance.cells.length; ++i) {
          var cellElement = this.productSlideshow.flickityInstance.cells[i].element,
              mediaId = parseInt(cellElement.getAttribute('data-media-id'));

          if (mediaId === parseInt(target.getAttribute('data-media-id'))) {
            this.productSlideshow.selectCell(parseInt(cellElement.getAttribute('data-media-position')) - 1);
          }
        }
      }
      /**
       * Check the quick nav
       */

    }, {
      key: "_checkQuickNav",
      value: function _checkQuickNav() {
        var _this3 = this;

        var showAsideQuickNav = false;
        fastdom.measure(function () {
          showAsideQuickNav = window.scrollY >= _this3.productAsideElement.offsetTop - _this3.productAsideElement.clientHeight;
        });
        fastdom.mutate(function () {
          if (showAsideQuickNav) {
            _this3.quickNav.classList.add('is-flipped');
          } else {
            _this3.quickNav.classList.remove('is-flipped');
          }
        });
      }
      /**
       * Toggle the social share icons
       */

    }, {
      key: "_toggleSocialShare",
      value: function _toggleSocialShare(event, target) {
        target.classList.toggle('is-active');
        target.classList.toggle('RoundButton--secondaryState');
        target.setAttribute('aria-expanded', target.getAttribute('aria-expanded') === 'true' ? 'false' : 'true');
        target.nextElementSibling.setAttribute('aria-hidden', target.nextElementSibling.getAttribute('aria-hidden') === 'true' ? 'false' : 'true');
      }
    }, {
      key: "_onImageChanged",
      value: function _onImageChanged(event, cell) {
        // If cell is video or model, we hide the action list
        if (Responsive.matchesBreakpoint('pocket')) {
          var productGalleryActionListElement = this.element.querySelector('.Product__Gallery .Product__ActionList');

          if (productGalleryActionListElement) {
            if (cell.classList.contains('Product__SlideItem--image')) {
              productGalleryActionListElement.classList.remove('is-hidden');
            } else {
              productGalleryActionListElement.classList.add('is-hidden');
            }
          }
        } // If we have non-stacked with thumbnails, update it


        if (!this.options['stackProductImages'] && this.options['showThumbnails']) {
          var mediaId = cell.getAttribute('data-media-id');
          this.slideshowNavThumbnailsItems.forEach(function (thumbnail) {
            if (thumbnail.getAttribute('data-media-id') === mediaId) {
              thumbnail.classList.add('is-selected');
            } else {
              thumbnail.classList.remove('is-selected');
            }
          });
        } // If we have the mobile navigation, we also update it


        if (this.slideshowMobileNav) {
          var selectedIndex = parseInt(cell.getAttribute('data-media-position')) - 1; // The -1 is to make it 0 indexed

          Dom.nodeListToArray(this.slideshowMobileNav.querySelectorAll('.dot')).forEach(function (item, index) {
            if (index === selectedIndex) {
              item.classList.add('is-selected');
            } else {
              item.classList.remove('is-selected');
            }
          });
        }
      }
    }, {
      key: "_onImageSettled",
      value: function _onImageSettled(index, cell) {
        this._handleMedia(cell);

        if (Responsive.matchesBreakpoint('lap-and-up')) {
          var slides = this.element.querySelectorAll('.Product__SlideItem:not(.is-selected)');
          slides.forEach(function (slide) {
            slide.classList.add('Product__SlideItem--hidden');
          });
        }
      }
    }, {
      key: "_slideWillChange",
      value: function _slideWillChange() {
        if (Responsive.matchesBreakpoint('lap-and-up')) {
          var slides = this.element.querySelectorAll('.Product__SlideItem');
          slides.forEach(function (slide) {
            slide.classList.remove('Product__SlideItem--hidden');
          });
        }
      }
      /**
       * Verify when the screen size changes to create additional stuff on non pocket mode
       */

    }, {
      key: "_setupDeviceFeatures",
      value: function _setupDeviceFeatures(event) {
        var _this4 = this;

        var currentBreakpoint = event ? event.detail.currentBreakpoint : Responsive.getCurrentBreakpoint(),
            previousBreakpoint = event ? event.detail.previousBreakpoint : null;

        if (currentBreakpoint === previousBreakpoint) {
          return; // Nothing has changed, no specific setup to do
        }

        if (currentBreakpoint === 'phone' || currentBreakpoint === 'tablet') {
          if (this.carouselNavScrollSpy) {
            this.carouselNavScrollSpy.destroy();
          }

          if (this.productInfoScroller) {
            this.productInfoScroller.destroy();
          }

          if (this.productThumbnailsScroller) {
            this.productThumbnailsScroller.destroy();
          }

          if (this.productAsideElement) {
            this.productAsideElement.style.minHeight = null;
          } else {
            this.productWrapperElement.style.minHeight = null;
          }

          this.productInfoElement.parentNode.style.maxHeight = null;
        } else {
          // 1st: scrollspy for the dots and image
          if (this.slideshowImages && this.slideshowImages.length > 1) {
            var offsetTop = 0;

            if (this.options['stackProductImages'] && this.slideshowNavDots) {
              offsetTop = this.slideshowNavDots.firstElementChild.offsetTop;
            }

            if (this.options['showThumbnails'] && Responsive.matchesBreakpoint('desk')) {
              offsetTop = 250;
            }

            this.carouselNavScrollSpy = new ScrollSpy(this.element, this.slideshowImages, {
              rootMargin: "-".concat(offsetTop, "px 0px 0px 0px")
            });
          }

          var productInfoStyles = window.getComputedStyle(this.productInfoElement),
              productInfoPadding = parseInt(productInfoStyles.paddingTop) + parseInt(productInfoStyles.paddingBottom),
              productGalleryHeight = this.productGalleryElement ? parseInt(this.productGalleryElement.scrollHeight) : 0; // 2nd: making sure to set up enough space in aside part

          var calculateMinHeight = function calculateMinHeight() {
            if (_this4.productAsideElement) {
              _this4.productAsideElement.style.minHeight = "".concat(_this4.productInfoElement.scrollHeight - productInfoPadding - productGalleryHeight, "px");
              _this4.productInfoElement.closest('.Product__InfoWrapper').style.maxHeight = _this4.productAsideElement.offsetTop + _this4.productInfoElement.scrollHeight - productInfoPadding + 'px';
            } else {
              _this4.productWrapperElement.style.minHeight = "".concat(_this4.productInfoElement.scrollHeight - parseInt(productInfoStyles.paddingTop), "px");
            }
          };

          calculateMinHeight(); // This code actually works well, but if a merchant is using an app that dynamically adds content (such as ReCharge or any other widget-based app), this
          // will mess the min height. There is a clean solution to this issue, which is by using ResizeObserver. However it's only supported in Chrome for now,
          // but I feel it's already good to have a clean fix

          if (window.ResizeObserver) {
            this.productInfoResizeObserver = new ResizeObserver(function () {
              calculateMinHeight(); // We currently do not take advantage of the values returned by the observer as our calculation depends on other values
            });
            this.productInfoResizeObserver.observe(this.productInfoElement);
          } // 3rd: let's handle the scroll for the product info


          this.productInfoScroller = new OverflowScroller(this.productInfoElement); // 4th: let's handle the scroll for the thumbnails

          if (this.options['showThumbnails'] && this.slideshowNavThumbnails) {
            this.productThumbnailsScroller = new OverflowScroller(this.slideshowNavThumbnails);
          }
        }
      }
    }, {
      key: "_productRecommendations",
      value: function _productRecommendations() {
        var _this4 = this;

        // listen to even recommendations
        document.addEventListener('theme:form:recommendations', function(event) {
          var status = event.detail.status; 
          var products = event.detail.products; 

          console.log('DEBUG:🎉🎉🎉  recommendations received', status, products);

          // hide products other than recommendations
          var $label = document.querySelector('.Product__Info__LabelRecommended');

          var handle = $label.getAttribute('data-product-handle');
          let $addToCart = document.querySelector('.ProductForm__AddToCart');
          // $addToCart.style.display = 'block';

          let loggedIn = !!ShopifyAnalytics.meta.page.customerId;

          if ((products.indexOf(handle) > -1)) {
            // console.log('DEBUG: display', handle);
            // show label
            $label.style.display = 'inline-block';
          } else {
            // // if not recommended and not base range & accessories, dont let user add to cart
            // let $sectionProduct = document.querySelector('section.Product');
            // if (!($sectionProduct.classList.contains('Product--accessories') || $sectionProduct.classList.contains('Product--baseRange') || (loggedIn && $sectionProduct.classList.contains('Product--skincareSet')) /* for king options */)) {
            //   // prepend new <a href> in .ProductForm__BuyButtons
            //   let $newButton = document.createElement('a');
            //   $newButton.setAttribute('href', '/pages/skin-quiz');
            //   $newButton.setAttribute('class', 'Button Button--Primary Button--full');
            //   $newButton.innerHTML = (loggedIn?'Retake Skin Quiz':'Take Skin Quiz');
            //   let $skinQuizInfo = document.createElement('div');
            //   $skinQuizInfo.setAttribute('class','ProductForm__SkinQuizInfo');
            //   $skinQuizInfo.innerHTML = 'Your set is personalised for your skin needs.';
            //   if ($addToCart) {
            //     $addToCart.parentElement.prepend($skinQuizInfo);
            //     $addToCart.parentElement.prepend($newButton);
            //     $addToCart.style.display = 'none';
            //   }

            //   // hide king options, if any
            //   /*let $ymqBox = document.getElementById('ymq-box');
            //   if ($ymqBox) {
            //     $ymqBox.style.display = 'none';
            //   }*/
            // }

            // if (!loggedIn && $sectionProduct.classList.contains('Product--skincareSet')) {
            //   let $createSet = document.querySelector('.ProductForm__CreateYourSet');
            //   // prepend new <a href> in .ProductForm__BuyButtons
            //   let $newButton = document.createElement('a');
            //   $newButton.setAttribute('href', '/pages/skin-quiz');
            //   $newButton.setAttribute('class', 'Button Button--Primary Button--full');
            //   $newButton.innerHTML = 'Take Skin Quiz';
            //   let $skinQuizInfo = document.createElement('div');
            //   $skinQuizInfo.setAttribute('class','ProductForm__SkinQuizInfo');
            //   $skinQuizInfo.innerHTML = 'Your set is personalised for your skin needs.';
            //   if ($createSet) {
            //     $createSet.parentElement.prepend($skinQuizInfo);
            //     $createSet.parentElement.prepend($newButton);
            //     $createSet.style.display = 'none';
            //   }

            // }


          }
  
          // Prescribe for me v2
            let $sectionProduct = document.querySelector('section.Product');
            let purchaseType = $sectionProduct.getAttribute('data-purchase-type');
            let quizCheck = document.body.getAttribute('data-quiz-check');
            let clinicCheck = document.body.getAttribute('data-clinic');
            let prescribeForMeProduct = $sectionProduct.getAttribute('data-prescribe-for-me-product');
            let prescribeForMeVariant = $sectionProduct.getAttribute('data-prescribe-for-me-variant');

            console.log('DEBUG: purchaseType', purchaseType);
            console.log('DEBUG: quizCheck',quizCheck);

            let quizTaken = (quizCheck === 'quiz-taken');
            let clinic = (clinicCheck === 'true');

            if (purchaseType === 'quiz' || (purchaseType === 'after-quiz' && !quizTaken && !clinic)) {
              // prepend new <a href> in .ProductForm__BuyButtons

              let url = '/pages/skin-quiz';
              let title = 'Start My Journey';

              if (prescribeForMeProduct) {
                url = prescribeForMeProduct;
                title = 'Create My Formula';
              }

              let $newButton = document.createElement('a');
              $newButton.setAttribute('href', url);
              $newButton.setAttribute('class', 'Button Button--Primary Button--full');
              $newButton.innerHTML = title; //(loggedIn?'Retake Skin Quiz':'Take Skin Quiz');
              let $skinQuizInfo = document.createElement('div');
              $skinQuizInfo.setAttribute('class','ProductForm__SkinQuizInfo');
              $skinQuizInfo.innerHTML = 'Your product is personalised for your skin needs.';

              if (prescribeForMeVariant) {
                // set on click                
                let delegateNewButtonElement = new domDelegate.Delegate($newButton);
                delegateNewButtonElement.on('click', function(ev) {
                  // console.log('DEBUG: 🎉🎉🎉  click', prescribeForMeVariant);
                  $newButton.setAttribute('disabled', 'disabled');

                  document.dispatchEvent(new CustomEvent('theme:loading:start'));
                  fetch('/cart/add.js', {
                      body: JSON.stringify({
                        items: [{
                          id: prescribeForMeVariant,
                          quantity: 1
                        }]
                      }),
                      credentials: 'same-origin',
                      method: 'POST',
                      headers: {
                        'Content-Type': 'application/json',
                        'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
            
                      }
                    }).then(function (response) {
                      console.log('DEBUG: prescribe for me product added');
                      document.dispatchEvent(new CustomEvent('theme:loading:end'));
                      
                      // $newButton.removeAttribute('disabled');

                      // // document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                      // //   bubbles: true
                      // // }));          

                      // // We simply trigger an event so the mini-cart can re-render
                      // _this4.element.dispatchEvent(new CustomEvent('product:added', {
                      //   bubbles: true,
                      //   detail: {
                      //     variant: prescribeForMeVariant,
                      //     quantity: 1//quantityElement ? parseInt(quantityElement.value) : 1
                      //   }
                      // }));

                      if (response.ok) {
                        $newButton.removeAttribute('disabled');
                        
                        // We simply trigger an event so the mini-cart can re-render
                        _this4.element.dispatchEvent(new CustomEvent('product:added', {
                          bubbles: true,
                          detail: {
                            variant: prescribeForMeVariant,
                            quantity: 1//quantityElement ? parseInt(quantityElement.value) : 1
                          }
                        }));
                      } else {
                        response.json().then(function (content) {
                          var errorMessageElement = document.createElement('span');
                          errorMessageElement.className = 'ProductForm__Error Alert Alert--error';
                          errorMessageElement.innerHTML = content['description'];
                          $newButton.removeAttribute('disabled');
                          $newButton.insertAdjacentElement('afterend', errorMessageElement);
                          setTimeout(function () {
                            errorMessageElement.remove();
                          }, 2500);
            
                          // alert(content['description']);
                        });
                      }
            

                    });                

                    ev.preventDefault();

                });
              }

              if ($sectionProduct.classList.contains('Product--skincareSet')) {
                $skinQuizInfo.innerHTML = 'Your set is personalised for your skin needs.';
              }

              if ($addToCart) {
                $addToCart.parentElement.prepend($skinQuizInfo);
                $addToCart.parentElement.prepend($newButton);
                $addToCart.style.display = 'none';
                $addToCart.classList.add('force-hidden'); // workaround since there's another js that enable it
              }
            }
          
        });

        // DEBUG TEMP
        
      }
    }, {
      key: "_refillButton",
      value: function _refillButton() {
        var _this4 = this;

        var $button = document.querySelector('.Button--ShopRefill');
        var handle = '';
        var refillProduct = false;
        var refillProductSuffix = '-refill';
        var productIsSet = false;
        // refillProductSuffix = '-sensitive';   // TODO: delete this

        var vesselHandle;
        var refillHandle;

        var indexRefillSuffix = -1;
        if ($button) {
          handle = $button.getAttribute('data-product-handle');
          productIsSet = $button.getAttribute('data-product-set');
          // $button.style.background = 'fuchsia';
          // console.log('DEBUG: 👍👍👍 💪💪💪 ', handle, productIsSet);

          indexRefillSuffix = handle.indexOf(refillProductSuffix);
          
          // if handle end with -refill
          if (indexRefillSuffix > -1 && handle.substring(indexRefillSuffix, (handle.length - 1))) {
            // refill product
            refillProduct = true;
            vesselHandle = handle.substring(0, indexRefillSuffix);
            // console.log('DEBUG: 👍👍👍 💪💪💪 this is refill!!, vessel handle', vesselHandle);
          } else {
            refillProduct = false;
            refillHandle = handle + refillProductSuffix;
            // console.log('DEBUG: 👍👍👍 💪💪💪 this is non refill!!, refill handle', refillHandle);
          }

          // check linked product
          // console.log('DEBUG: routes', window.routes.rootUrlWithoutSlash);
          
          var linkedHandle = refillHandle;
          var buttonTitle = (productIsSet === 'true')?'Shop Refills':'Shop Refill';
          if (refillProduct) {
            linkedHandle = vesselHandle;
            buttonTitle = (productIsSet === 'true')?'Shop Vessels':'Shop Vessel';
          }

          fetch("".concat(window.routes.rootUrlWithoutSlash, "/products/").concat(linkedHandle).concat('.json'), {
            credentials: 'same-origin',
            method: 'GET'
          }).then(function (response) {
            // console.log('DEBUG: 🐯🐯🐯🐯🐯🐯', response);
            if (response && response.status === 200) {
              // show link
              // $button.style.background = 'yellow';
              $button.setAttribute('href',"".concat(window.routes.rootUrlWithoutSlash, "/products/").concat(linkedHandle));

              $button.innerHTML = buttonTitle;
              $button.style.display = 'block';

              // if (refillProduct) {
              //   $button.innerHTML = 'Shop Vessel';
              // } else {
              //   $button.innerHTML = 'Shop Refill';
              // }
            }
            // response.json()
            // .then(function (result) {
            //   console.log('DEBUG: 🐯🐯🐯🐯🐯🐯', result);
            // }) 
          });
        }

        
      }
    }, {
      key: "_clinicOnly",
      value: function _clinicOnly() {
        var _this4 = this;

        // console.log('DEBUG: clinic only');

        // Form API
        CF.ready(function () {
        });       

        var clinicOnlyButton = document.querySelector('.Button--ClinicOnly');
        var buyButton = document.querySelector('.ProductForm__BuyButtons .Button--Primary');
        var refillButton = document.querySelector('.Button--ShopRefill');
        if (clinicOnlyButton) {
          // hide
          if (buyButton) {
            buyButton.classList.add('hidden-phone');
            buyButton.classList.add('hidden-tablet-and-up');  
          }
          if (refillButton) {
            refillButton.classList.add('hidden-phone');
            refillButton.classList.add('hidden-tablet-and-up');  
          }
        }
        
        CF.customerReady(function() {
          // console.log('DEBUG: clinic customer ready!!!');

          // clinic
          let loggedIn = !!ShopifyAnalytics.meta.page.customerId;
          let clinicName = CF.customer.get('clinic_name');
          let reference = CF.customer.get('reference');

          // console.log('DEBUG: clinic', clinicName, reference, loggedIn);

          if (!loggedIn && clinicName && reference == 'Clinic') {
            // console.log('DEBUG: this is clinic');
            // show again
            if (buyButton) {
              buyButton.classList.remove('hidden-phone');
              buyButton.classList.remove('hidden-tablet-and-up');  
            }
            if (refillButton) {
              refillButton.classList.remove('hidden-phone');
              refillButton.classList.remove('hidden-tablet-and-up');  
            }

            if (clinicOnlyButton) {
              clinicOnlyButton.classList.add('hidden-phone');
              clinicOnlyButton.classList.add('hidden-tablet-and-up');  
            }
          } else {
            // console.log('DEBUG: this is not clinic');
          }        

        });        

      }
    }]);

    return ProductSection;
  }();

  var ProductRealResultsSection = /*#__PURE__*/function () {
    function ProductRealResultsSection(container) {
      _classCallCheck(this, ProductRealResultsSection);

      this.element = container;
      this.options = JSON.parse(this.element.getAttribute('data-section-settings'));

      console.log('DEBUG: 👍👍👍👍👍👍👍👍👍 products real results');

      this._loadResults();
    }

    _createClass(ProductRealResultsSection, [{
      key: "onUnload",
      value: function onUnload() {
        this.carousel.destroy();
      }
    }, {
      key: "_createSlideshow",
      value: function _createSlideshow() {
        var flickityElement = this.element.querySelector('.ProductResults [data-flickity-config]');

        if (!flickityElement) {
          return;
        }

        this.carousel = new Carousel(flickityElement); // Setup product item color swatch

        new ProductItemColorSwatch(this.element);
      }
    }, {
      key: "_loadResults",
      value: function _loadResults() {
        console.log('DEBUG: 💪💪💪 this is products real results!');
        var _this = this;

          // get results sections data from /pages/the-results
          // there are 2 possible way:
          // 1) fetching entire page
          //    
          // 2) using shopify section rendering API
          //  only load specific section by id, eg: /pages/the-results?section_id=template--15621618106415__1637109471a1a1c200
          // option 2 is the ideal one because it more efficient and only return limited sections data and designed for ajax usage. however the cons is because we are calling it from different page (product page), we dont know the target section id. and need to manually check it in the results page output, and then store it somewhere (either hardcoded or within section settings as csv). since we got multiple sections (because of shopify block limit) and they are editable by client, we then need to keep maintaining the list of sections ids. make this solutions not automatic. until we find a way to get section list id of the page (without fetching entire page like point 1, of course)

          // for now im using option 1. more hacky and the data is larger, but its working more automatically
          // both are requires us to work with html markup. so the process are kind of similar, just different way to fetch the sections markup

          var resultsPageUrl = '/pages/the-results';
          return fetch(resultsPageUrl).then(function (response) {
            return response.text().then(function (data) {
              // console.log('DEBUG: 👍👍👍👍👍👍👍👍 fetched content', data);

              var $data;
              var matchCount = 0;
              var productNames = []; // from real results page
              var concernNames = [];

              if (data) {
                $data = document.createElement('div');
                $data.innerHTML = data;
                
                $data = $data.querySelectorAll('.real-results .ResultsGrid .Grid__Cell');//.querySelectorAll('.ResultItem.testimonial-content');
                
                let productList = _this.element.querySelector('.ProductResults .ProductList');
                if ($data.length) {
                  $data.forEach(function($gridCell){
                    let productsFilterData = $gridCell.getAttribute('data-products');
                    if (!productsFilterData) {
                      return;
                    }
                    let productsFilter = JSON.parse(productsFilterData);
                    console.log('DEBUG: data-products',productsFilter);


                    let $result = $gridCell.querySelector('.ResultItem.testimonial-content');
  
                    // product usage
                    let $treatments = $result.querySelector('.treatment');
                    if (!$treatments) { return; }


                    /*
                    let $spanElement = $treatments.querySelector('span');
                    if (!$spanElement) { return; }
                    
                    $treatments.removeChild($spanElement);
                    let treatments = $treatments.textContent.trim();

                    if (typeof treatments !== 'string' || treatments.length <= 0) {
                      return;
                    }

                    let treatmentsArr = treatments.split(',');
                    let productMatch = false;
                    treatmentsArr.forEach(function(treatment){
                      treatment = treatment.trim();
                      productNames.push(treatment);
                      if (treatment.toLowerCase() === _this.options.productTitle.toLowerCase()) {
                        productMatch = true;
                      }
                    });
                    */

                    let productMatch = false;
                    productsFilter.forEach(function(product){
                      product = product.trim();
                      productNames.push(product);
                      if (product.toLowerCase() === _this.options.productTitle.toLowerCase()) {
                        productMatch = true;
                      }
                    });

                    /* ClueEdit: special conditions for 
                        https://thesecretskincare.com/products/the-acne-set
                        https://thesecretskincare.com/products/the-anti-ageing-set
                        https://thesecretskincare.com/products/the-rosacea-set
                        https://thesecretskincare.com/products/the-pigmentation-set
                    */
                    let concernsFilterData = $gridCell.getAttribute('data-concerns');
                    let concernsFilter = JSON.parse(concernsFilterData);
                    console.log('DEBUG: data-concerns',concernsFilter);
                    concernsFilter.forEach(function(concern){
                      concern = concern.trim();
                      concernNames.push(concern);
                      // if (product.toLowerCase() === _this.options.productTitle.toLowerCase()) {
                      //   productMatch = true;
                      // }
                      if (
                        (_this.options.productHandle.toLowerCase() === 'the-acne-set' && concern.toLowerCase() === 'acne') ||
                        (_this.options.productHandle.toLowerCase() === 'the-anti-ageing-set' && concern.toLowerCase() === 'ageing skin') ||
                        (_this.options.productHandle.toLowerCase() === 'the-rosacea-set' && concern.toLowerCase() === 'rosacea') ||
                        (_this.options.productHandle.toLowerCase() === 'the-pigmentation-set' && concern.toLowerCase() === 'pigmentation')
                      ) {
                        productMatch = true;
                      }
                    });


                    // console.log('DEBUG: treatments', treatments);

                    if (productMatch) {
                      let $wrapper1 = document.createElement('div');
                      $wrapper1.classList.add('Carousel__Cell');
    
                      $result.parentNode.insertBefore($wrapper1, $result);
                      $wrapper1.appendChild($result);

                      //// remove treatments
                      //$treatments.parentNode.removeChild($treatments);

                      // update testimonials link
                      let $testimonialButton = $result.querySelector('.read-testimonial');
                      if ($testimonialButton) {
                        let currentHref = $testimonialButton.getAttribute('href');
                        let newHref = resultsPageUrl + '/' + currentHref;
                        $testimonialButton.setAttribute('href', newHref);

                        // change from button to a
                        let $linkElement = document.createElement('a');

                        // Copy the attributes from the button to the link
                        Array.from($testimonialButton.attributes).forEach((attribute) => {
                          $linkElement.setAttribute(attribute.name, attribute.value);
                        });

                        // Copy the content from the button to the link
                        $linkElement.innerHTML = $testimonialButton.innerHTML;

                        // Replace the button with the new link
                        $testimonialButton.parentNode.replaceChild($linkElement, $testimonialButton);     
                      }
  
                      productList.appendChild($wrapper1);
                      matchCount ++;
                    }
                    // console.log('DEBUG: result', $result);


                  });

                }

                // console.log('DEBUG: product names', productNames);
                console.log('DEBUG: real results match found', matchCount);
                if (matchCount > 0) {
                  // show section
                  _this.element.parentNode.style.display = 'block';
                }

              }
  
            })
            .then(_this._createSlideshow.bind(_this))
            .then(function() {
              // ClueEdit - resize, because when recommendations displayed, parent section shown, there are other carousel (pairs well with) within the section that need to be recalculated
              window.dispatchEvent(new Event('resize'));
            });
          });
              




        
      }
    }]);

    return ProductRealResultsSection;
  }();

  var ConcernRealResultsSection = /*#__PURE__*/function () {
    function ConcernRealResultsSection(container) {
      _classCallCheck(this, ConcernRealResultsSection);

      this.element = container;
      this.options = JSON.parse(this.element.getAttribute('data-section-settings'));
      this.delegateElement = new domDelegate.Delegate(this.element);

      console.log('DEBUG: 👍👍👍👍👍👍👍👍👍 concern real results');

      this._loadResults();
    }

    _createClass(ConcernRealResultsSection, [{
      key: "onUnload",
      value: function onUnload() {
        this.carousel.destroy();
      }
    }, {
      key: "_loadResults",
      value: function _loadResults() {
        console.log('DEBUG: 💪💪💪 this is products real results!');
        var _this = this;

          // get results sections data from /pages/the-results
          // there are 2 possible way:
          // 1) fetching entire page
          //    
          // 2) using shopify section rendering API
          //  only load specific section by id, eg: /pages/the-results?section_id=template--15621618106415__1637109471a1a1c200
          // option 2 is the ideal one because it more efficient and only return limited sections data and designed for ajax usage. however the cons is because we are calling it from different page (product page), we dont know the target section id. and need to manually check it in the results page output, and then store it somewhere (either hardcoded or within section settings as csv). since we got multiple sections (because of shopify block limit) and they are editable by client, we then need to keep maintaining the list of sections ids. make this solutions not automatic. until we find a way to get section list id of the page (without fetching entire page like point 1, of course)

          // for now im using option 1. more hacky and the data is larger, but its working more automatically
          // both are requires us to work with html markup. so the process are kind of similar, just different way to fetch the sections markup

          var resultsPageUrl = '/pages/the-results';
          return fetch(resultsPageUrl).then(function (response) {
            return response.text().then(function (data) {
              // console.log('DEBUG: 👍👍👍👍👍👍👍👍 fetched content', data);

              var $dataResults;
              var matchCount = 0;
              let popupIds = [];
              let testimonialButtons = [];

              if (data) {
                $dataResults = document.createElement('div');
                $dataResults.innerHTML = data;
                
                let $gridCells = $dataResults.querySelectorAll('.real-results .ResultsGrid .Grid__Cell');//.querySelectorAll('.ResultItem.testimonial-content');
                
                let concernList = _this.element.querySelector('.ConcernResults');
                let concernPopups = _this.element.querySelector('.ConcernPopups');


                if ($gridCells.length) {
                  $gridCells.forEach(function($gridCell){
                    let concernsFilterData = $gridCell.getAttribute('data-concerns');
                    if (!concernsFilterData) {
                      return;
                    }
                    let concernsFilter = JSON.parse(concernsFilterData);
                    // console.log('DEBUG: data-concerns',concernsFilter);
  
                    let concernMatch = false;
                    concernsFilter.forEach(function(concern){
                      if (concern.toLowerCase() === _this.options.concern.toLowerCase()) {
                        concernMatch = true;
                      }
                    });

                    if (concernMatch) {  

                      // check popup
                      let $testimonial = $gridCell.querySelector('.testimonial .read-testimonial');
                      if ($testimonial) {
                        let id = $testimonial.getAttribute('href');
                        if (id) {
                          popupIds.push(id.replace('#', ''));
                          testimonialButtons.push($testimonial);
                        }
                      }

                      concernList.appendChild($gridCell);
                      matchCount ++;

                    }
                  });

                }

                console.log('DEBUG: popupIds', popupIds);

                console.log('DEBUG: real results match found', matchCount);
                if (matchCount > 0) {
                  // show section
                  _this.element.parentNode.style.display = 'block';
                }

                // popups
                let $infoPopups = $dataResults.querySelectorAll('.InfoPopup.RealResults');
                if ($infoPopups.length) {
                  $infoPopups.forEach(function($infoPopup){
                    let popupId = $infoPopup.getAttribute('id');
                    if (popupId && popupIds.indexOf(popupId) > -1) {
                      concernPopups.appendChild($infoPopup);

                      // new InfoPopupSection($infoPopup);
                    }
                  });

                  // infopopups supposed to be shopify sections, but its too late to initialize
                  // we replicate the infopopup initialization logic here
                  let _openPopup = function(ev) {
                      console.log('DEBUG: open popup', ev, ev.target.getAttribute('href'));
                      // this.element.classList.add('InfoPopup--show');
                      _this.element.querySelector(ev.target.getAttribute('href')).classList.add('InfoPopup--show');
                  }
                  let _closePopup = function() {
                      console.log('DEBUG: close popup');
                      _this.element.querySelector('.InfoPopup.RealResults.InfoPopup--show').classList.remove('InfoPopup--show');
                  }

                  _this.delegateElement.on('click', '.InfoPopup.RealResults .InfoPopup__Close', _closePopup);
                  _this.delegateElement.on('click', '.testimonial .read-testimonial', _openPopup);

                }




              }
  
            });
          });
              




        
      }
    }]);

    return ConcernRealResultsSection;
  }();

  var PrescribeForMeFormulationSection = /*#__PURE__*/function () {
    function PrescribeForMeFormulationSection(container) {
      _classCallCheck(this, PrescribeForMeFormulationSection);
  
      this.element = container;
      this.options = JSON.parse(this.element.getAttribute('data-section-settings'));
  
      if (this.options.enable) {
        this._loadPFMRecommendations();
      }
    }
  
    _createClass(PrescribeForMeFormulationSection, [{
      key: "onUnload",
      value: function onUnload() {
        this.carousel.destroy();
      }
    }, {
      key: "_createSlideshow",
      value: function _createSlideshow() {
        var flickityElement = this.element.querySelector('.PFMRecommendations [data-flickity-config]');
  
        if (!flickityElement) {
          return;
        }
  
        this.carousel = new Carousel(flickityElement); // Setup product item color swatch
  
        new ProductItemColorSwatch(this.element);
      }
    }, {
      key: "_loadPFMRecommendations",
      value: function _loadPFMRecommendations() {
        console.log('DEBUG: 💪💪💪 this is PFM recommendations!');
        var _this = this;
  
        // we will fetch data from allproducts json collection, which is contains all products, then compare with products recommendation data
        var collection = _this.options.collection;

        return fetch('/collections/'+ collection +'/?view=allproductsjson').then(function (response) {
          return response.text().then(function (data) {
            // console.log('DEBUG: fetched content', data);
  
            var parsed;
            var $data;
            var recommended = [];
            var html = ''; // html string, need to be same format as shopify ajax output from recommendation url window.routes.productRecommendationsUrl
            var container;
            var content;
            var recommendedVessel = [];
            var recommendedRefill = [];
  
            if (data) {
              // in OS 2.0, section always wrapped by tag, so its not pure json code, we have to unwrap first
              
              $data = document.createElement('div');
              $data.innerHTML = data;
              
              $data = $data.querySelector('.shopify-section');
              data = $data.textContent; // json text
              // console.log('DEBUG: textcontent', $data.textContent);
  
              // convert to js object
              try {
                parsed = JSON.parse(data);
                // filterMatchData(bottomMatchData, size);
                // console.log('DEBUG: parsed', parsed);
  
                // filter only recommended variants
                parsed.products.forEach(function(product) {
                    recommended.push(product);
                });
  
  
              } catch(e) {
                  console.log('ERROR: Invalid data');
              }
  
              if (recommended.length) {
                // Ordering recommendation, refill last
                console.log('DEBUG: PFM recommended', recommended);
                // console.log('DEBUG: 💲💲💲💲💲💲💲 lets ordering the recommendation');
  
                if (recommended.length) {
                  recommended.forEach(function(product) {
                    if (product.handle.indexOf('-refill') > -1) {
                      recommendedRefill.push(product);
                    } else {
                      recommendedVessel.push(product);
                    }
                  });
  
                  recommended = recommendedVessel.concat(recommendedRefill);
  
                }
  
                // console.log('recommended after sorting', recommended);
                
                // build html string for each product
                recommended.forEach(function(product) {
                  html += `<div class="Carousel__Cell">`;
                  html += `<div class="ProductItem "><div class="ProductItem__Wrapper"><a href="${product.url}" class="ProductItem__ImageWrapper ">`;
                  // html += `hello`;
                  html += `<div class="AspectRatio AspectRatio--square"
                              style="max-width: 1294px; --aspect-ratio: 0.994619523443505">
                              <img class="ProductItem__Image Image--lazyLoad Image--fadeIn"
                                  data-src="${product.image}"
                                  data-widths="[200,400,600,700,800,900,1000,1200]" data-sizes="auto"
                                  alt="${product.title}">
                              <span class="Image__Loader"></span>
                          </div>
  
                          <div class="ProductItem__LabelList">
                            
                          </div>
  
                          <div class="ProductItem__Info ProductItem__Info--left ">
                              <!--<p class="ProductItem__PrescriptionInfo">Clinical Strength</p>-->
                              <h2 class="ProductItem__Title">
                                  ${product.title}
                              </h2>
                          </div>
                    `;
                  html += ``;
                  html += ``;
                  html += ``;
                  html += ``;
                  html += ``;
                  html += `</a></div></div>`;
                  html += `</div>`;
                });
  
                // console.log('DEBUG: html', html);
  
                // build html wrapper
                html = `
                    <div class="PFMRecommendations">
                        <div class="ProductListWrapper flickity">
                            <div class="ProductList ProductList--carousel Carousel" data-flickity-config='{
                            "prevNextButtons": true,
                            "pageDots": false,
                            "wrapAround": false,
                            "contain": true,
                            "cellAlign": "center",
                            "watchCSS": true,
                            "dragThreshold": 8,
                            "groupCells": true,
                            "arrowShape": {"x0": 20, "x1": 60, "y1": 40, "x2": 60, "y2": 35, "x3": 25}
                          }'>` + html + ` </div>
                          </div>
                      </div>
                  `;
  
                // append it to dom
                container = document.createElement('div');
                content = html;
                container.innerHTML = content;
                _this.element.querySelector('.PFMRecommendations').innerHTML = container.querySelector('.PFMRecommendations').innerHTML;    
  
                var $section = _this.element.closest('.shopify-section');
                if ($section) {
                  $section.classList.add('shopify-section--PFMRecommendations--show');
                }
              } else {
                // TODO: hide the recommended section
              }
              
            }
  
          })
          .then(_this._createSlideshow.bind(_this))
          .then(function() {
            // ClueEdit - resize, because when recommendations displayed, parent section shown, there are other carousel (pairs well with) within the section that need to be recalculated
            window.dispatchEvent(new Event('resize'));
          });
        });
  
  
        
      }
    }]);
  
    return PrescribeForMeFormulationSection;
  }();
  

  // just for handling add to cart
  var QuickAddToCart = {
    
  };


  var RecentlyViewedProductsSection = /*#__PURE__*/function () {
    function RecentlyViewedProductsSection(container) {
      _classCallCheck(this, RecentlyViewedProductsSection);

      this.element = container;
      this.options = JSON.parse(this.element.getAttribute('data-section-settings')); // Setup product item color swatch

      new ProductItemColorSwatch(this.element);

      this._fetchProducts();
    }

    _createClass(RecentlyViewedProductsSection, [{
      key: "onUnload",
      value: function onUnload() {
        if (this.carousel) {
          this.carousel.destroy();
        }
      }
      /**
       * In order to get the products to display, we hit the search template with the given IDS
       */

    }, {
      key: "_fetchProducts",
      value: function _fetchProducts() {
        var _this = this;

        var queryString = this._getSearchQueryString();

        if (queryString === '') {
          return;
        } // If we have a non empty query string we do a search query


        fetch("".concat(window.routes.searchUrl, "?section_id=").concat(this.element.getAttribute('data-section-id'), "&type=product&q=").concat(queryString), {
          credentials: 'same-origin',
          method: 'GET'
        }).then(function (response) {
          response.text().then(function (content) {
            var tempElement = document.createElement('div');
            tempElement.innerHTML = content; // Set the content

            _this.element.innerHTML = tempElement.querySelector('.Section').innerHTML; // Show the section

            _this.element.parentNode.style.display = 'block'; // And finally let's create the carousel !

            _this.carousel = new Carousel(_this.element.querySelector('[data-flickity-config]'));
          });
        });
      }
    }, {
      key: "_getSearchQueryString",
      value: function _getSearchQueryString() {
        var items = JSON.parse(localStorage.getItem('recentlyViewedProducts') || '[]'); // If we are on a product template, we make sure to remove the main product from the related product

        if (items.includes(this.options['productId'])) {
          items.splice(items.indexOf(this.options['productId']), 1);
        }

        return items.map(function (item) {
          return 'id:' + item;
        }).join(' OR ');
      }
    }]);

    return RecentlyViewedProductsSection;
  }();

  /**
   * This code is extracted from Slate
   */

  var SectionContainer = /*#__PURE__*/function () {
    function SectionContainer() {
      _classCallCheck(this, SectionContainer);

      this.constructors = [];
      this.instances = [];

      this._attachListeners();
    }

    _createClass(SectionContainer, [{
      key: "_attachListeners",
      value: function _attachListeners() {
        document.addEventListener('shopify:section:load', this._onSectionLoad.bind(this));
        document.addEventListener('shopify:section:unload', this._onSectionUnload.bind(this));
        document.addEventListener('shopify:section:select', this._onSelect.bind(this));
        document.addEventListener('shopify:section:deselect', this._onDeselect.bind(this));
        document.addEventListener('shopify:section:reorder', this._onReorder.bind(this));
        document.addEventListener('shopify:block:select', this._onBlockSelect.bind(this));
        document.addEventListener('shopify:block:deselect', this._onBlockDeselect.bind(this));
      }
    }, {
      key: "register",
      value: function register(type, constructor) {
        var _this = this;

        this.constructors[type] = constructor;
        Dom.nodeListToArray(document.querySelectorAll("[data-section-type=".concat(type, "]"))).forEach(function (container) {
          _this._createInstance(container, constructor);
        });
      }
      /**
       * Return an object from an array of objects that matches the provided key and value
       */

    }, {
      key: "_findInstance",
      value: function _findInstance(array, key, value) {
        for (var i = 0; i < array.length; i++) {
          if (array[i][key] === value) {
            return array[i];
          }
        }
      }
      /**
       * Remove an object from an array of objects by matching the provided key and value
       */

    }, {
      key: "_removeInstance",
      value: function _removeInstance(array, key, value) {
        var i = array.length;

        while (i--) {
          if (array[i][key] === value) {
            array.splice(i, 1);
            break;
          }
        }

        return array;
      }
    }, {
      key: "_onSectionLoad",
      value: function _onSectionLoad(event) {
        var container = event.target.querySelector('[data-section-id]');

        if (container) {
          this._createInstance(container);
        }
      }
    }, {
      key: "_onSectionUnload",
      value: function _onSectionUnload(event) {
        var instance = this._findInstance(this.instances, 'id', event.detail.sectionId);

        if (!instance) {
          return;
        }

        if (typeof instance.onUnload === 'function') {
          instance.onUnload(event);
        }

        this.instances = this._removeInstance(this.instances, 'id', event.detail.sectionId);
      }
    }, {
      key: "_onSelect",
      value: function _onSelect(event) {
        var instance = this._findInstance(this.instances, 'id', event.detail.sectionId);

        if (instance && typeof instance.onSelect === 'function') {
          instance.onSelect(event);
        }
      }
    }, {
      key: "_onDeselect",
      value: function _onDeselect(event) {
        var instance = this._findInstance(this.instances, 'id', event.detail.sectionId);

        if (instance && typeof instance.onDeselect === 'function') {
          instance.onDeselect(event);
        }
      }
    }, {
      key: "_onReorder",
      value: function _onReorder(event) {
        var instance = this._findInstance(this.instances, 'id', event.detail.sectionId);

        if (instance && typeof instance.onReorder === 'function') {
          instance.onReorder(event);
        }
      }
    }, {
      key: "_onBlockSelect",
      value: function _onBlockSelect(event) {
        var instance = this._findInstance(this.instances, 'id', event.detail.sectionId);

        if (instance && typeof instance.onBlockSelect === 'function') {
          instance.onBlockSelect(event);
        }
      }
    }, {
      key: "_onBlockDeselect",
      value: function _onBlockDeselect(event) {
        var instance = this._findInstance(this.instances, 'id', event.detail.sectionId);

        if (instance && typeof instance.onBlockDeselect === 'function') {
          instance.onBlockDeselect(event);
        }
      }
    }, {
      key: "_createInstance",
      value: function _createInstance(container, constructor) {
        var id = container.getAttribute('data-section-id'),
            type = container.getAttribute('data-section-type');
        constructor = constructor || this.constructors[type];

        if (typeof constructor === 'undefined') {
          return;
        }

        var instance = Object.assign(new constructor(container), {
          id: id,
          type: type,
          container: container
        });
        this.instances.push(instance);
      }
    }]);

    return SectionContainer;
  }();

  var SearchSection = /*#__PURE__*/function () {
    function SearchSection(container) {
      _classCallCheck(this, SearchSection);

      this.element = container;
      this.delegateElement = new domDelegate.Delegate(this.element);

      this._setupAnimation();
    }

    _createClass(SearchSection, [{
      key: "onUnload",
      value: function onUnload() {
        this.intersectionObserver.disconnect();
        this.timeline.kill();
      }
    }, {
      key: "_setupAnimation",
      value: function _setupAnimation() {
        var _this = this;

        if (this.intersectionObserver) {
          this.intersectionObserver.disconnect();
        }

        this.timeline = new TimelineLite({
          delay: 0.5
        });

        if (window.theme.showElementStaggering) {
          this.intersectionObserver = new IntersectionObserver(this._reveal.bind(this));
          Dom.nodeListToArray(this.element.querySelectorAll('.ProductList .ProductItem, .ArticleList .ArticleItem')).forEach(function (item) {
            _this.intersectionObserver.observe(item);
          });
        }
      }
    }, {
      key: "_reveal",
      value: function _reveal(results) {
        var _this2 = this;

        var toReveal = [];
        results.forEach(function (result) {
          if (result.isIntersecting || result.intersectionRatio > 0) {
            // isIntersecting does not exist on Samsung Android browser
            toReveal.push(result.target);

            _this2.intersectionObserver.unobserve(result.target);
          }
        });

        if (toReveal.length === 0) {
          return;
        }

        this.timeline.staggerFromTo(toReveal, 0.6, {
          autoAlpha: 0,
          y: 25
        }, {
          autoAlpha: 1,
          y: 0
        }, 0.2);
      }
    }]);

    return SearchSection;
  }();

  var ShopNowSection = /*#__PURE__*/function () {
    function ShopNowSection(container) {
      _classCallCheck(this, ShopNowSection);

      this.element = container;
      this.carousel = new Carousel(this.element.querySelector('[data-flickity-config]')); // Setup product item color swatch

      new ProductItemColorSwatch(this.element);
    }

    _createClass(ShopNowSection, [{
      key: "onUnload",
      value: function onUnload() {
        this.carousel.destroy();
      }
    }]);

    return ShopNowSection;
  }();

  var ShopTheLookSection = /*#__PURE__*/function () {
    function ShopTheLookSection(container) {
      _classCallCheck(this, ShopTheLookSection);

      this.element = container;
      this.delegateElement = new domDelegate.Delegate(this.element);
      this.usePocketMode = Responsive.matchesBreakpoint('pocket');
      this.pocketActivatorButton = this.element.querySelector('[data-action="open-look"]');

      this._createOuterCarousel();

      this._createPocketPopovers();

      this._attachListeners();
    }

    _createClass(ShopTheLookSection, [{
      key: "onUnload",
      value: function onUnload() {
        this.outerCarousel.destroy();
        this.innerCarousels.forEach(function (item) {
          item.forEach(function (innerItem) {
            return innerItem.destroy();
          });
        });
        this.popovers.forEach(function (item) {
          return item.destroy();
        });
        this.delegateElement.off();
      }
    }, {
      key: "onBlockSelect",
      value: function onBlockSelect(event) {
        this.outerCarousel.selectCell(event.target.getAttribute('data-slide-index'), true, !event.detail.load);
      }
      /**
       * Attach all the listeners
       */

    }, {
      key: "_attachListeners",
      value: function _attachListeners() {
        this.delegateElement.on('click', '.ShopTheLook__Dot', this._onDotClicked.bind(this));
      }
      /**
       * There is one mobile and tablet popover per look, so we pre-create them
       */

    }, {
      key: "_createPocketPopovers",
      value: function _createPocketPopovers() {
        var _this = this;

        this.popovers = [];
        Dom.nodeListToArray(this.element.querySelectorAll('.Popover')).forEach(function (popover) {
          _this.popovers.push(new Popover(popover, {
            activator: _this.pocketActivatorButton,
            showOverlay: false,
            onOpen: _this._openPocketZoom.bind(_this),
            onClose: _this._closePocketZoom.bind(_this)
          }));
        });
      }
      /**
       * The outer carousel is the carousel that holds the main one (all the looks). Internally, it also creates
       * a sub-carousel for each inner carousel
       */

    }, {
      key: "_createOuterCarousel",
      value: function _createOuterCarousel() {
        var _this2 = this;

        this.outerCarousel = new Carousel(this.element.querySelector('.ShopTheLook'), {
          onSelect: this._onLookChanged.bind(this)
        });
        this.innerCarousels = new Array(this.outerCarousel.flickityInstance.cells.length);

        for (var i = 0; i !== this.innerCarousels.length; ++i) {
          this.innerCarousels[i] = [];
        } // We need to create ALL the carousels (both in desktop and mobile). Fortunately Flickity is quite fast, but
        // we have no other choices if we want to have proper animations everywhere.


        Dom.nodeListToArray(this.element.querySelectorAll('.ShopTheLook__ProductList')).forEach(function (item) {
          var lookIndex = parseInt(item.getAttribute('data-look-index'));

          _this2.innerCarousels[lookIndex].push(new Carousel(item, {
            onSelect: _this2._onProductChanged.bind(_this2)
          })); // By default, Flickity will append the carousel, hence making the "ViewButton" before the carousel. We need to manipulate it to move it after


          item.insertBefore(item.querySelector('.flickity-viewport'), item.querySelector('.ShopTheLook__ViewButton'));
        });
        this.outerCarousel.resize(); // Needed in case the products are taller than the image
      }
      /**
       * This function is called whenever the main look has changed, so that we can modify the popover activator
       */

    }, {
      key: "_onLookChanged",
      value: function _onLookChanged(selectedIndex, selectedCell) {
        // Then, we update the mobile button so that it opens the correct block
        this.pocketActivatorButton.setAttribute('aria-controls', "".concat(selectedCell.getAttribute('id'), "-popover"));
      }
      /**
       * This function is called whenever a product is changed in the list for a given look. This allows to focus the main dot
       */

    }, {
      key: "_onProductChanged",
      value: function _onProductChanged(selectedIndex, selectedCell) {
        var lookItem = this.outerCarousel.getSelectedCell(),
            activeDot = null;
        Dom.nodeListToArray(lookItem.querySelectorAll('.ShopTheLook__Dot')).forEach(function (dot, index) {
          dot.classList.remove('is-active'); // IE11 and lower does not support "toggle" with second parameter :(

          if (index === selectedIndex) {
            dot.classList.add('is-active');
            activeDot = dot;
          }
        }); // Update the link to the product (if using the desktop view)

        lookItem.querySelector('.ShopTheLook__ViewButton').setAttribute('href', selectedCell.getAttribute('data-product-url')); // We trigger an event so that when the dot change we can recalculate the position

        lookItem.dispatchEvent(new CustomEvent('product:changed', {
          detail: {
            dot: activeDot
          }
        }));
      }
      /**
       * This function is called whenever you explicitly click on a dot.
       *
       * On mobile and tablet, this must open the appropriate popver
       */

    }, {
      key: "_onDotClicked",
      value: function _onDotClicked(event, target) {
        var shouldAnimateCarousel = false,
            hasOnePopoverOpen = false,
            lookIndex = this.outerCarousel.getSelectedIndex();
        this.popovers.forEach(function (item) {
          if (item.isOpen) {
            hasOnePopoverOpen = true;
            shouldAnimateCarousel = true;
          }
        }); // Each inner carousel has a mobile AND desktop version, so we change both

        this.innerCarousels[lookIndex].forEach(function (innerCarousel) {
          innerCarousel.selectCell(parseInt(target.getAttribute('data-product-index')) - 1, false, shouldAnimateCarousel);
        });

        if (this.usePocketMode && !hasOnePopoverOpen) {
          this.popovers[lookIndex].open();
        }
      }
      /**
       * This is called when, on mobile, the popover is open. We must open the image in full resolution
       */

    }, {
      key: "_openPocketZoom",
      value: function _openPocketZoom(popover) {
        var _this3 = this;

        this._calculateImageTransform(popover);

        fastdom.mutate(function () {
          // We need to animate the header to avoid a slightly ugly effect if image overlap the header
          document.getElementById('shopify-section-header').style.cssText = 'transform: translateY(-100%); transition: transform 0.3s ease-in-out;';

          _this3.outerCarousel.flickityInstance.unbindDrag(); // Prevent changing the active slide


          _this3.outerCarousel.flickityInstance.element.classList.add('is-zoomed');

          _this3.outerCarousel.getSelectedCell().classList.add('is-expanded');
        });
      }
      /**
       * When the mobile zoom is open, and whenever the active dot changes, we need to potentially re-calculate the transform
       */

    }, {
      key: "_calculateImageTransform",
      value: function _calculateImageTransform(openPopover) {
        var _this4 = this;

        var selectedCell = this.outerCarousel.getSelectedCell();
        fastdom.measure(function () {
          // We first need to compute the initial transform and scale factor
          var scale = window.innerWidth / (selectedCell.offsetWidth - parseInt(window.getComputedStyle(selectedCell).paddingLeft) * 2),
              heightAfterScale = Math.round(selectedCell.offsetHeight * scale),
              // Height of the selected cell once the scale transform is applied
          hiddenImageHeight = Math.round(Math.max(heightAfterScale - (window.innerHeight - openPopover.element.offsetHeight), 0)),
              // Part of image that is below popover
          visibleImageHeight = heightAfterScale - hiddenImageHeight,
              // Part of the image that is visible in the viewport
          minTranslateY = Math.round(-(selectedCell.getBoundingClientRect().top - (heightAfterScale - selectedCell.offsetHeight) / 2)),
              // The minimum translate Y transform allowed so that image is visible
          maxTranslateY = Math.round(minTranslateY - hiddenImageHeight); // The maximum translate Y transform allowed so that image is visible

          _this4._calculateTransformForDotListener = function (event) {
            var dotTopPosition = Math.round((event.detail.dot.offsetTop + event.detail.dot.offsetHeight / 2) * scale),
                offsetToMove = Math.round(dotTopPosition - visibleImageHeight / 2),
                translateY = Math.min(Math.max(minTranslateY - offsetToMove, maxTranslateY), minTranslateY);
            fastdom.mutate(function () {
              _this4.outerCarousel.flickityInstance.viewport.style.transform = "translate3d(0, ".concat(Math.round(translateY), "px, 0) scale(").concat(scale, ")");
            });
          }; // We manually generate an event the first time to trigger the positioning


          selectedCell.addEventListener('product:changed', _this4._calculateTransformForDotListener);
          selectedCell.dispatchEvent(new CustomEvent('product:changed', {
            detail: {
              dot: selectedCell.querySelector('.ShopTheLook__Dot.is-active')
            }
          }));
        });
      }
      /**
       * Close the mobile zoom (which close the popover and remove any transform
       */

    }, {
      key: "_closePocketZoom",
      value: function _closePocketZoom() {
        var _this5 = this;

        var selectedCell = this.outerCarousel.getSelectedCell();
        selectedCell.removeEventListener('product:changed', this._calculateTransformForDotListener);
        fastdom.mutate(function () {
          document.getElementById('shopify-section-header').style.cssText = 'transform: translateY(0); transition: transform 0.3s ease-in-out 0.3s;';

          _this5.outerCarousel.flickityInstance.bindDrag();

          _this5.outerCarousel.flickityInstance.element.classList.remove('is-zoomed');

          _this5.outerCarousel.flickityInstance.viewport.style.transform = null;
          selectedCell.classList.remove('is-expanded');
        });
      }
    }]);

    return ShopTheLookSection;
  }();

  var SidebarMenuSection = /*#__PURE__*/function () {
    function SidebarMenuSection(container) {
      _classCallCheck(this, SidebarMenuSection);

      this.element = container;
      this.sidebarDrawer = new Drawer(container);
    }

    _createClass(SidebarMenuSection, [{
      key: "onUnload",
      value: function onUnload() {
        this.sidebarDrawer.destroy();
      }
    }, {
      key: "onSelect",
      value: function onSelect() {
        this.sidebarDrawer.open();
      }
    }, {
      key: "onDeselect",
      value: function onDeselect() {
        this.sidebarDrawer.close();
      }
    }]);

    return SidebarMenuSection;
  }();

  var SlideshowSection = /*#__PURE__*/function () {
    function SlideshowSection(container) {
      _classCallCheck(this, SlideshowSection);

      this.element = container;
      this.delegateElement = new domDelegate.Delegate(this.element);
      this.slideshow = new Carousel(this.element.querySelector('[data-flickity-config]'), {
        onSelect: this._onSlideChanged.bind(this)
      });
      this.selectedSlide = null;
      this.shouldAnimate = true;
      this.timeline = new TimelineLite({
        delay: window.theme.showPageTransition ? 0.5 : 0
      });

      if (this.slideshow.flickityInstance.cells.length > 0) {
        this._transitionToSlide(this.slideshow.flickityInstance.selectedCell.element, true);
      }

      this._attachListeners();
    }

    _createClass(SlideshowSection, [{
      key: "onUnload",
      value: function onUnload() {
        this.slideshow.destroy();
        this.timeline.kill();
        this.delegateElement.off();
        document.removeEventListener('breakpoint:changed', this._onBreakpointChangedListener);
      }
    }, {
      key: "onBlockSelect",
      value: function onBlockSelect(event) {
        if (this.slideshow.flickityInstance.options.autoPlay) {
          this.slideshow.flickityInstance.stopPlayer();
        }

        this.shouldAnimate = !event.detail.load;
        this.slideshow.selectCell(event.target.getAttribute('data-slide-index'), false, !event.detail.load);
      }
    }, {
      key: "onBlockDeselect",
      value: function onBlockDeselect() {
        this.shouldAnimate = true;

        if (this.slideshow.flickityInstance.options.autoPlay) {
          this.slideshow.flickityInstance.playPlayer();
        }
      }
    }, {
      key: "_attachListeners",
      value: function _attachListeners() {
        this._onBreakpointChangedListener = this._onBreakpointChanged.bind(this);
        this.delegateElement.on('mouseenter', '.Button', this._pauseSlideshow.bind(this), true);
        this.delegateElement.on('mouseleave', '.Button', this._resumeSlideshow.bind(this), true);
        document.addEventListener('breakpoint:changed', this._onBreakpointChangedListener);
      }
    }, {
      key: "_pauseSlideshow",
      value: function _pauseSlideshow() {
        if (this.slideshow.flickityInstance.options.autoPlay) {
          this.slideshow.flickityInstance.pausePlayer();
        }
      }
    }, {
      key: "_resumeSlideshow",
      value: function _resumeSlideshow() {
        if (this.slideshow.flickityInstance.options.autoPlay) {
          this.slideshow.flickityInstance.unpausePlayer();
        }
      }
    }, {
      key: "_onSlideChanged",
      value: function _onSlideChanged(index, element) {
        this._transitionToSlide(element);
      }
    }, {
      key: "_transitionToSlide",
      value: function _transitionToSlide(slide) {
        var _this = this;

        this.timeline.clear(); // First, we check if there is a previous slide selected, if that's the case

        if (this.selectedSlide) {
          this._slideLeave(this.selectedSlide);

          this.timeline.addLabel('enter', this.shouldAnimate ? '-=0.4' : 0);
        } // We get the next slide (if any) to preload it


        this._lazyLoadNextImage();

        this.timeline.fromTo(slide, this.selectedSlide && this.shouldAnimate ? 0.3 : 0, {
          autoAlpha: 0
        }, {
          autoAlpha: 1,
          ease: Cubic.easeInOut
        }, 'enter'); // The image may take 1s or more to load depending on the network, so we make sure to pause the player, and restart it once it has transitioned

        if (this.slideshow.flickityInstance.options.autoPlay && this.slideshow.flickityInstance.player.state === 'playing') {
          this.slideshow.flickityInstance.pausePlayer();
        }

        Dom.nodeListToArray(slide.querySelectorAll('.Slideshow__Image')).forEach(function (image) {
          if (image.classList.contains('Image--lazyLoading') || image.classList.contains('Image--lazyLoad')) {
            image.addEventListener('lazyloaded', _this._slideEnter.bind(_this, slide));
          } else {
            _this._slideEnter(slide);
          }
        });
        this.selectedSlide = slide;
      }
    }, {
      key: "_slideLeave",
      value: function _slideLeave(slide) {
        var content = slide.querySelector('.SectionHeader'),
            buttonWrapper = slide.querySelector('.SectionHeader__ButtonWrapper');
        this.timeline.fromTo(slide, this.shouldAnimate ? 0.3 : 0, {
          autoAlpha: 1
        }, {
          autoAlpha: 0,
          ease: Cubic.easeInOut,
          delay: this.shouldAnimate ? 0.35 : 0
        });

        if (content) {
          this.timeline.fromTo(content, this.shouldAnimate ? 0.4 : 0, {
            autoAlpha: 1,
            y: 0
          }, {
            autoAlpha: 0,
            y: 20,
            ease: Cubic.easeIn
          }, 0);
        }

        if (buttonWrapper) {
          this.timeline.fromTo(buttonWrapper, this.shouldAnimate ? 0.4 : 0, {
            autoAlpha: 1,
            y: 0
          }, {
            autoAlpha: 0,
            y: 10,
            ease: Cubic.easeIn
          }, 0);
        }
      }
    }, {
      key: "_slideEnter",
      value: function _slideEnter(slide) {
        var images = slide.querySelectorAll('.Slideshow__Image'),
            content = slide.querySelector('.SectionHeader'),
            buttonWrapper = slide.querySelector('.SectionHeader__ButtonWrapper');

        if (this.slideshow.flickityInstance.options.autoPlay && this.slideshow.flickityInstance.player.state === 'paused') {
          this.slideshow.flickityInstance.unpausePlayer();
        }

        if (window.CSS && window.CSS.supports('(object-fit: cover) or (-o-object-fit: cover)')) {
          if (window.theme.showImageZooming) {
            this.timeline.fromTo(images, this.shouldAnimate ? 1.2 : 0, {
              opacity: 0,
              scale: 1.2
            }, {
              opacity: 1,
              scale: 1,
              ease: Quad.easeOut
            }, 'enter');
          } else {
            this.timeline.fromTo(images, this.shouldAnimate ? 1.2 : 0, {
              opacity: 0
            }, {
              opacity: 1,
              ease: Quad.easeOut
            }, 'enter');
          }
        }

        if (content) {
          this.timeline.fromTo(content, this.shouldAnimate ? 0.8 : 0, {
            autoAlpha: 0,
            y: 30
          }, {
            autoAlpha: 1,
            y: 0,
            delay: this.shouldAnimate ? 0.8 : 0,
            ease: Cubic.easeOut
          }, 'enter');
        }

        if (buttonWrapper) {
          this.timeline.fromTo(buttonWrapper, this.shouldAnimate ? 0.8 : 0, {
            autoAlpha: 0,
            y: 20
          }, {
            autoAlpha: 1,
            y: 0,
            delay: this.shouldAnimate ? 0.8 : 0,
            ease: Cubic.easeOut
          }, 'enter');
        }
      }
    }, {
      key: "_lazyLoadNextImage",
      value: function _lazyLoadNextImage() {
        var currentIndex = this.slideshow.flickityInstance.selectedIndex,
            breakpoint = Responsive.getCurrentBreakpoint();

        if (this.slideshow.flickityInstance.cells.length - 1 > currentIndex) {
          var nextCellElement = this.slideshow.flickityInstance.cells[currentIndex + 1].element,
              imageContainers = Dom.nodeListToArray(nextCellElement.querySelectorAll('.Slideshow__ImageContainer')),
              imageToReveal = null;

          if (breakpoint === 'phone') {
            imageToReveal = imageContainers[0];
          } else {
            imageToReveal = imageContainers[1];
          }

          if (window.lazySizes && imageToReveal && imageToReveal.classList.contains('Image--lazyLoad')) {
            lazySizes.loader.unveil(imageToReveal.firstElementChild);
          }
        }
      }
    }, {
      key: "_onBreakpointChanged",
      value: function _onBreakpointChanged(event) {
        if (event.detail.previousBreakpoint === 'phone' && event.detail.currentBreakpoint !== 'phone' || event.detail.previousBreakpoint !== 'phone' && event.detail.currentBreakpoint === 'phone') {
          this.selectedSlide = null;

          this._transitionToSlide(this.slideshow.flickityInstance.selectedElement);
        }
      }
    }]);

    return SlideshowSection;
  }();

  var TestimonialsSection = /*#__PURE__*/function () {
    function TestimonialsSection(container) {
      _classCallCheck(this, TestimonialsSection);

      this.element = container;
      this.delegateElement = new domDelegate.Delegate(this.element);
      this.navItems = Dom.nodeListToArray(this.element.querySelectorAll('.TestimonialNav__Item'));
      this.carousel = new Carousel(this.element.querySelector('.TestimonialList'), {
        onSelect: this._testimonialChanged.bind(this)
      });

      this._attachListeners();
    }

    _createClass(TestimonialsSection, [{
      key: "onUnload",
      value: function onUnload() {
        this.carousel.destroy();
        this.delegateElement.off('click');
      }
    }, {
      key: "onBlockSelect",
      value: function onBlockSelect(event) {
        this.carousel.selectCell(event.target.getAttribute('data-slide-index'), true);
      }
    }, {
      key: "onBlockDeselect",
      value: function onBlockDeselect() {
        this.carousel.unpausePlayer();
      }
    }, {
      key: "_testimonialClicked",
      value: function _testimonialClicked(event, target) {
        this.carousel.pausePlayer();
        this.carousel.selectCell(parseInt(target.getAttribute('data-index')));
        this.carousel.unpausePlayer();
      }
    }, {
      key: "_testimonialChanged",
      value: function _testimonialChanged(newIndex) {
        this.navItems.forEach(function (item, index) {
          item.classList.remove('is-selected'); // IE11 and lower does not support classList.toggle

          if (newIndex === index) {
            item.classList.add('is-selected');
          }
        });
      }
    }, {
      key: "_attachListeners",
      value: function _attachListeners() {
        this.delegateElement.on('click', '.TestimonialNav__Item', this._testimonialClicked.bind(this));
      }
    }]);

    return TestimonialsSection;
  }();

  var TimelineSection = /*#__PURE__*/function () {
    function TimelineSection(container) {
      _classCallCheck(this, TimelineSection);

      this.element = container;
      this.delegateElement = new domDelegate.Delegate(this.element);
      this.items = Dom.nodeListToArray(this.element.querySelectorAll('.Timeline__Item'));
      this.navItems = Dom.nodeListToArray(this.element.querySelectorAll('.Timeline__NavItem'));

      this._attachListeners();
    }

    _createClass(TimelineSection, [{
      key: "onUnload",
      value: function onUnload() {
        this.delegateElement.off('click');
      }
    }, {
      key: "onBlockSelect",
      value: function onBlockSelect(event) {
        this.navItems[parseInt(event.target.getAttribute('data-index'))].click(); // Simulate a click on the given nav item
      }
    }, {
      key: "_attachListeners",
      value: function _attachListeners() {
        this.delegateElement.on('click', '.Timeline__NavItem', this._clickOnNavItem.bind(this));
      }
    }, {
      key: "_clickOnNavItem",
      value: function _clickOnNavItem(event, target) {
        var newItem = this.items[parseInt(target.getAttribute('data-index'))];

        if (newItem.classList.contains('is-selected')) {
          return;
        }

        var isContentLarger = false,
            navWrapper = target.parentNode,
            scrollableOffset = 0;
        fastdom.measure(function () {
          var scrollableWidth = navWrapper.scrollWidth,
              visibleWidth = navWrapper.offsetWidth;
          isContentLarger = visibleWidth < scrollableWidth;

          if (isContentLarger) {
            var beginBound = target.offsetLeft,
                endBound = beginBound + target.offsetWidth,
                closerToLeft = beginBound <= visibleWidth - endBound;
            var itemToUse = null;

            if (closerToLeft) {
              // If closer to left, we try to make the previous item visible (if possible)
              itemToUse = target.previousElementSibling || target;
            } else {
              // If closer to right, we try to make the next item visible (if possible)
              itemToUse = target.nextElementSibling || target;
            }

            var itemBeginBound = itemToUse.offsetLeft - navWrapper.scrollLeft,
                itemEndBound = itemBeginBound + itemToUse.offsetWidth;

            if (itemEndBound > visibleWidth) {
              // Element is not visible from the right, so we must move by a given amount so that endBound is within viewable screen
              scrollableOffset = itemEndBound - visibleWidth;
            } else if (itemBeginBound < 0) {
              // Element is not visible from the left, so we simply use the opposite of the negative offset
              scrollableOffset = itemBeginBound;
            }
          }
        });
        fastdom.mutate(function () {
          if (isContentLarger) {
            navWrapper.scrollBy({
              behavior: 'smooth',
              left: scrollableOffset
            });
          } // First we set the class on the selected item and remove it on siblings


          target.classList.add('is-selected');
          Dom.getSiblings(target, '.is-selected').forEach(function (item) {
            item.classList.remove('is-selected');
          }); // Then we slide to the appropriate element

          newItem.classList.add('is-selected');
          Dom.getSiblings(newItem, '.is-selected').forEach(function (item) {
            item.classList.remove('is-selected');
          });
        });
      }
    }]);

    return TimelineSection;
  }();

  var PriceRange = /*#__PURE__*/function (_HTMLElement) {
    _inherits(PriceRange, _HTMLElement);

    var _super = _createSuper(PriceRange);

    function PriceRange() {
      _classCallCheck(this, PriceRange);

      return _super.apply(this, arguments);
    }

    _createClass(PriceRange, [{
      key: "connectedCallback",
      value: function connectedCallback() {
        var _this = this;

        this.rangeLowerBound = this.querySelector('.price-range__range-group input:first-child');
        this.rangeHigherBound = this.querySelector('.price-range__range-group input:last-child');
        this.textInputLowerBound = this.querySelector('.price-range__input:first-child input');
        this.textInputHigherBound = this.querySelector('.price-range__input:last-child input'); // Select whole text on focus for text field to improve user experience

        this.textInputLowerBound.addEventListener('focus', function () {
          return _this.textInputLowerBound.select();
        });
        this.textInputHigherBound.addEventListener('focus', function () {
          return _this.textInputHigherBound.select();
        }); // Keep in sync the range with the text input fields

        this.textInputLowerBound.addEventListener('change', function (event) {
          event.target.value = Math.max(Math.min(parseInt(event.target.value), parseInt(_this.textInputHigherBound.value || event.target.max) - 1), event.target.min);
          _this.rangeLowerBound.value = event.target.value;

          _this.rangeLowerBound.parentElement.style.setProperty('--range-min', "".concat(parseInt(_this.rangeLowerBound.value) / parseInt(_this.rangeLowerBound.max) * 100, "%"));
        });
        this.textInputHigherBound.addEventListener('change', function (event) {
          event.target.value = Math.min(Math.max(parseInt(event.target.value), parseInt(_this.textInputLowerBound.value || event.target.min) + 1), event.target.max);
          _this.rangeHigherBound.value = event.target.value;

          _this.rangeHigherBound.parentElement.style.setProperty('--range-max', "".concat(parseInt(_this.rangeHigherBound.value) / parseInt(_this.rangeHigherBound.max) * 100, "%"));
        });
        this.rangeLowerBound.addEventListener('change', function (event) {
          _this.textInputLowerBound.value = event.target.value;

          _this.textInputLowerBound.dispatchEvent(new Event('change', {
            bubbles: true
          }));
        });
        this.rangeHigherBound.addEventListener('change', function (event) {
          _this.textInputHigherBound.value = event.target.value;

          _this.textInputHigherBound.dispatchEvent(new Event('change', {
            bubbles: true
          }));
        }); // We also have to bound the two range sliders

        this.rangeLowerBound.addEventListener('input', function (event) {
          event.target.value = Math.min(parseInt(event.target.value), parseInt(_this.textInputHigherBound.value || event.target.max) - 1); // Bound the value

          event.target.parentElement.style.setProperty('--range-min', "".concat(parseInt(event.target.value) / parseInt(event.target.max) * 100, "%"));
          _this.textInputLowerBound.value = event.target.value;
        });
        this.rangeHigherBound.addEventListener('input', function (event) {
          event.target.value = Math.max(parseInt(event.target.value), parseInt(_this.textInputLowerBound.value || event.target.min) + 1); // Bound the value

          event.target.parentElement.style.setProperty('--range-max', "".concat(parseInt(event.target.value) / parseInt(event.target.max) * 100, "%"));
          _this.textInputHigherBound.value = event.target.value;
        });
      }
    }]);

    return PriceRange;
  }( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
  window.customElements.define('price-range', PriceRange);


  // ClueEdit
  var InfoPopupSection = /*#__PURE__*/function () {
    function InfoPopupSection(element) {
      _classCallCheck(this, InfoPopupSection);

      this.element = element;
      this.delegateElement = new domDelegate.Delegate(this.element);
      // this.options = JSON.parse(element.getAttribute('data-section-settings'));

      if (window.location.hash === '#'+element.id && window.theme.pageType !== null) {
        this._openPopup();
      }

      // so we can target links that trigger this popup (href id)
      this.documentDelegate = new domDelegate.Delegate(document.body);

      this._attachListeners();
    }

    _createClass(InfoPopupSection, [{
      key: "onUnload",
      value: function onUnload() {
        this.delegateElement.off();
        this.documentDelegate.off();
      }
    }, {
      key: "onSelect",
      value: function onSelect() {
        this._openPopup();
      }
    }, {
      key: "onDeselect",
      value: function onDeselect() {
        this._closePopup();
      }
    }, {
      key: "_attachListeners",
      value: function _attachListeners() {
        this.delegateElement.on('click', '.InfoPopup__Close', this._closePopup.bind(this));
        this.documentDelegate.on('click', '[href="#'+this.element.id+'"]', this._openPopup.bind(this));
        
      }
    }, {
      key: "_openPopup",
      value: function _openPopup() {
        this.element.classList.add('InfoPopup--show');
      }
    }, {
      key: "_closePopup",
      value: function _closePopup() {
        this.element.classList.remove('InfoPopup--show');
      }
    }]);

    return InfoPopupSection;
  }();


  var ShowcaseSection = /*#__PURE__*/function () {
    function ShowcaseSection(container) {
      _classCallCheck(this, ShowcaseSection);

      this.element = container;
      this.delegateElement = new domDelegate.Delegate(this.element);
      // this.customerLoginForm = this.element.querySelector('#customer_login');
      // this.recoverPasswordForm = this.element.querySelector('#recover_customer_password');
      // this.delegateElement.on('click', '[data-action="toggle-recover-form"]', this._showRecoverPassword.bind(this));
      this.sectionId = this.element.getAttribute('id');

      console.log('DEBUG: showcase', this.sectionId);
      this._run();
    }

    _createClass(ShowcaseSection, [{
      key: "_run",
      value: function _run() {
        this.parallaxInstance1 = new Rellax('#' + this.sectionId + ' .Showcase__Image_1', {
          speed: 5,
          center: true
          // round: true
        });
        this.parallaxInstance2 = new Rellax('#' + this.sectionId + ' .Showcase__Image_2', {
          speed: -5,
          center: true
          // round: true
        });
      }
    }]);

    return ShowcaseSection;
  }();

  // real result list page, using shuffle script
  // this script associated to real-result.liquid section, which is header of the page
  // we expect the page to have other sections named "real-result-list"
  var RealResults = /*#__PURE__*/function () {
    function RealResults(container) {
      _classCallCheck(this, RealResults);

      this.element = container;
      this.delegateElement = new domDelegate.Delegate(this.element);
      // this.customerLoginForm = this.element.querySelector('#customer_login');
      // this.recoverPasswordForm = this.element.querySelector('#recover_customer_password');
      // this.delegateElement.on('click', '[data-action="toggle-recover-form"]', this._showRecoverPassword.bind(this));
      this.sectionId = this.element.getAttribute('id');

      console.log('DEBUG: real result', this.sectionId);
      // setTimeout(function() {
        this._run();
      // }.bind(this),9000);
    }

    _createClass(RealResults, [{
      key: "_run",
      value: function _run() {
        // merge shopify-section real-results-list
        
        // first real-result-list section
        var $list = document.querySelector('.shopify-section.real-results-list .ResultsGrid');
        console.log('DEBUG: $list', $list);

        var concernValues = [];
        var productValues = [];

        // move all grid cells on all real-result-list sections to first real-result-list section
        var $gridCells = document.querySelectorAll('.shopify-section.real-results-list .Grid__Cell');
        Dom.nodeListToArray($gridCells).forEach(function(el) {
          var concerns = JSON.parse(el.getAttribute('data-concerns'));
          var products = JSON.parse(el.getAttribute('data-products'));
          
          concernValues = concernValues.concat(concerns);
          productValues = productValues.concat(products);

          // console.log('DEBUG: cell', el, concerns);
          $list.append(el);
        });

        // as array filter callback, to get unique/distict values
        function onlyUnique(value, index, self) {
            return self.indexOf(value) === index;
        }    
        
        concernValues = concernValues.filter(onlyUnique).sort();
        productValues = productValues.filter(onlyUnique).sort();

        // console.log('DEBUG: cencernValues', concernValues);
        // console.log('DEBUG: productValues', productValues);

        // implement shuffle
        var resultShuffle = new Shuffle($list, {
          itemSelector: '.Grid__Cell',
          // sizer: '.my-sizer-element',
          buffer: 1,
        });


        // generate list filter
        var $concernFilter = document.querySelector('.filter-set.concerns-filter .filter-dropdown');
        var concernHtml = '';        
        concernHtml += `<li><input type="radio" name="concern-data"       id="radio-concern-all" value="" checked>
                        <label for="radio-concern-all">All</label>
                        </li>`
        concernValues.forEach(function(v,i) {
          concernHtml += `<li>
                        <input type="radio" name="concern-data" id="radio-concern-${i}" value="${v}">
                        <label for="radio-concern-${i}">${v}</label>
                        </li>`;
        });
        // console.log('DEBUG: cocnernhtml', concernHtml);
        $concernFilter.innerHTML = concernHtml;

        var $productFilter = document.querySelector('.filter-set.products-filter .filter-dropdown');
        var productHtml = '';        
        productHtml += `<li><input type="radio" name="product-data"       id="radio-product-all" value="" checked>
                        <label for="radio-product-all">All</label>
                        </li>`
        productValues.forEach(function(v,i) {
          productHtml += `<li>
                        <input type="radio" name="product-data" id="radio-product-${i}" value="${v}">
                        <label for="radio-product-${i}">${v}</label>
                        </li>`;
        });
        // console.log('DEBUG: cocnernhtml', productHtml);
        $productFilter.innerHTML = productHtml;


        var shuffleFilterDelegate = new domDelegate.Delegate(document.querySelector('.shuffle-filters'));
        shuffleFilterDelegate.on('change', 'input', function(ev, element) {
          applyFilter();
        });

        function applyFilter() {
          var concern = document.querySelector('.concerns-filter input[name="concern-data"]:checked');          
          concern = (concern)?concern.value:'';          

          var product = document.querySelector('.products-filter input[name="product-data"]:checked');
          product = (product)?product.value:'';          
          
          var gender = document.querySelector('.gender-filter input[name="gender-data"]:checked');
          gender = (gender)?gender.value:'';          

          // console.log('DEBUG: concern', concern);
          // console.log('DEBUG: product', product);
          // console.log('DEBUG: gender', gender);


          resultShuffle.filter(function (el) {
            var dataConcerns = el.getAttribute('data-concerns');
            var dataProducts = el.getAttribute('data-products');
            var dataGender = el.getAttribute('data-gender');
            
            // console.log('DEBUG: concerns', concerns);
            if (dataConcerns) {                            
              dataConcerns = JSON.parse(dataConcerns);
            } else {
              dataConcerns = [];
            }

            if (dataProducts) {                            
              dataProducts = JSON.parse(dataProducts);
            } else {
              dataProducts = [];
            }
            
            dataGender = dataGender || 'Undefined';

            // true/false
            var concernFilter = (concern)?(dataConcerns.indexOf(concern) > -1):true;
            var productFilter = (product)?(dataProducts.indexOf(product) > -1):true;
            var genderFilter = (gender)?(dataGender === gender):true;

            // console.log('DEBUG: concern Filter', concernFilter);
            // console.log('DEBUG: product Filter', productFilter);
            // console.log('DEBUG: gender Filter', genderFilter);

            return concernFilter && productFilter && genderFilter;
          });          

        }


        
        // document.querySelectorAll('.shopify-section.real-results-list .Grid__Cell');

        // $categoryNav.on('click', function(ev) {
        //   // console.log('target',$(ev.target),ev.target.hasAttribute('data-group'));
        //   if ($(ev.target).is('[data-group]')) {
        //     // console.log('TARGET',$(ev.target).data('group'));
        //     $(this).find('li a').removeClass('active');
        //     $(ev.target).addClass('active');
        //     resultShuffle.filter($(ev.target).data('group'));
        //   }
        //   ev.preventDefault();
        // })



        
      }
    }]);

    return RealResults;
  }();

  var FeaturedSliderSection = /*#__PURE__*/function () {
    function FeaturedSliderSection(container) {
      var _this = this;

      _classCallCheck(this, FeaturedSliderSection);

      this.element = container;
      this.delegateElement = new domDelegate.Delegate(this.element);
      this.options = JSON.parse(this.element.getAttribute('data-settings'));
      this.carousels = [];

      this.flickityOptions = {
        // options
        "freeScroll": true, 
        "cellAlign": "left", 
        "contain": true,
        // prevNextButtons: false,
        pageDots: false
      };

      this.contentWrapper = this.element.querySelector('.FeaturedSlider__ContentWrapper');
      this.content = this.element.querySelector('.FeaturedSlider__Content');
      this.carouselCellContent = this.element.querySelector('.FeaturedSlider__CarouselCell--content');


      Dom.nodeListToArray(this.element.querySelectorAll('[data-flickity-config]')).forEach(function (item) {
        _this.carousels.push(new Carousel(item));
      });

      // this._setupAnimation();

      this._attachListeners();
      console.log('DEBUG: featured slider section');

      // this._setupSlider();

      var currentBreakpoint = Responsive.getCurrentBreakpoint();
      if (this.contentWrapper && this.content && this.carouselCellContent) {
        console.log('DEBUG: this.currentBreakpoint 💲', currentBreakpoint);
        this._reloadSlider(currentBreakpoint);  
      }

      // equal height
      this._equalizeHeight('.FeaturedSlider__CarouselCell--product .ProductItem__Title');
      window.addEventListener("resize", function(){
        setTimeout(function(){
          _this._equalizeHeight('.FeaturedSlider__CarouselCell--product .ProductItem__Title');
        })
      })      
    }

    _createClass(FeaturedSliderSection, [{
      key: "onUnload",
      value: function onUnload() {
        this.carousels.forEach(function (item) {
          return item.destroy();
        });
        this.intersectionObserver.disconnect();
        this.timeline.kill();
        document.removeEventListener('breakpoint:changed', this._onBreakpointChangedListener);

        if (this.carousel) {
          this.carousel.destroy();
        }
      }
    }, {
      key: "onBlockSelect",
      value: function onBlockSelect(event) {
        // We simply trigger a click on the element that controls this tab
        this.element.querySelector("[aria-controls=\"".concat(event.target.id, "\"]")).click();
      }
    }, {
      key: "_onAddToCart",
      value: function _onAddToCart(event, target) {
        console.log('DEBUG: ',target);
        console.log('DEBUG: ',target.getAttribute('data-action'));
        var productId = target.getAttribute('data-product-id');
        console.log('DEBUG: product id = ', productId);

        var _this4 = this;



        // ajax add to cart, reference: _addToCart

        target.setAttribute('disabled', 'disabled');

        document.dispatchEvent(new CustomEvent('theme:loading:start')); // Then we add the product in Ajax
        fetch("".concat(window.routes.cartAddUrl, ".js"), {
          body: '{"form_type":"product","utf8":"✓","id":"'+ productId +'"}',
          //JSON.stringify(Form.serialize(formElement)),
          credentials: 'same-origin',
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header

          }
        }).then(function (response) {
          document.dispatchEvent(new CustomEvent('theme:loading:end'));
          // var quantityElement = formElement.querySelector('[name="quantity"]');

          if (response.ok) {
            // todo, enable button, or disable loader
            target.removeAttribute('disabled');
            
            // We simply trigger an event so the mini-cart can re-render
            _this4.element.dispatchEvent(new CustomEvent('product:added', {
              bubbles: true,
              detail: {
                variant: _this4.currentVariant,
                quantity: 1//quantityElement ? parseInt(quantityElement.value) : 1
              }
            }));
          } else {
            response.json().then(function (content) {
              var errorMessageElement = document.createElement('span');
              errorMessageElement.className = 'ProductForm__Error Alert Alert--error';
              errorMessageElement.innerHTML = content['description'];
              target.removeAttribute('disabled');
              target.insertAdjacentElement('afterend', errorMessageElement);
              setTimeout(function () {
                errorMessageElement.remove();
              }, 2500);

              // alert(content['description']);
            });
          }
        });



        event.preventDefault();
      }
    }, {
      key: "_attachListeners",
      value: function _attachListeners() {
        // Add to cart
        this.delegateElement.on('click', '[data-action="collection-add-to-cart"]', this._onAddToCart.bind(this));

        this._onBreakpointChangedListener = this._breakpointChanged.bind(this);
        document.addEventListener('breakpoint:changed', this._onBreakpointChangedListener);
      }
    }/*, {
      key: "_setupAnimation",
      value: function _setupAnimation() {
        var _this3 = this;

        if (this.intersectionObserver) {
          this.intersectionObserver.disconnect();
        }

        this.timeline = new TimelineLite({
          delay: 0.5
        });

        if (window.theme.showElementStaggering) {
          console.log('DEBUG: window.theme.showElementStaggering', window.theme.showElementStaggering);
          console.log('DEBUG: element', this.element);
          this.intersectionObserver = new IntersectionObserver(this._reveal.bind(this));
          Dom.nodeListToArray(this.element.querySelectorAll('.ProductList .ProductItem')).forEach(function (item) {
            console.log('DEBUG: item', item);
            _this3.intersectionObserver.observe(item);
          });
        }
      }
    }, {
      key: "_reveal",
      value: function _reveal(results) {
        var _this4 = this;

        var toReveal = [];
        results.forEach(function (result) {
          if (result.isIntersecting || result.intersectionRatio > 0) {
            // isIntersecting does not exist on Samsung Android browser
            toReveal.push(result.target);

            _this4.intersectionObserver.unobserve(result.target);
          }
        });

        if (toReveal.length === 0) {
          return;
        }

        this.timeline.staggerFromTo(toReveal, 0.45, {
          autoAlpha: 0,
          y: 25
        }, {
          autoAlpha: 1,
          y: 0
        }, 0.2);
      }
    }*/, {
      key: "_flickity_handle_wheel_event",
      value: function _flickity_handle_wheel_event(e, flickity_instance, flickity_is_animating) {

          // do not trigger a slide change if another is being animated
          if (!flickity_is_animating) {    
            // pick the larger of the two delta magnitudes (x or y) to determine nav direction
            // var direction = e.deltaX; //(Math.abs(e.deltaX) > Math.abs(e.deltaY)) ? e.deltaX : e.deltaY;
            
            // console.log("wheel scroll ", e.deltaX, e.deltaY, direction);
            
            if (/*direction*/ e.deltaX && e.deltaX > 10) {
              // next slide
              flickity_instance.next();
            } else if (e.deltaX && e.deltaX < -10) {
              // prev slide
              flickity_instance.previous();
            }
          }
      }
    }, {
      key: "_carouselOnSettle",
      value: function _carouselOnSettle(index) {
        this.carousel_is_animating = false;
      }
    }, {
      key: "_carouselOnSelect",
      value: function _carouselOnSelect(index) {
        this.carousel_is_animating = true;
      }
    }, {
      key: "_carouselOnWheel",
      value: function _carouselOnWheel(e) {
        this._flickity_handle_wheel_event(e, this.carousel, this.carousel_is_animating);
      }
    }, {
      key: "_setupSlider",
      value: function _setupSlider() {
        var _this3 = this;

        this.carousel = new Flickity(this.element.querySelector('.FeaturedSlider__Carousel') , this.flickityOptions);

        this.$carousel = this.element.querySelector('.FeaturedSlider__Carousel');
        this.carousel_is_animating = false;
        
        // this.carousel.on("settle", function(index) {
        //   // console.log("Slide settle " + index);
        //   _this3.carousel_is_animating = false;
        // });
        
        // this.carousel.on("select", function(index) {
        //   // console.log("Slide selected " + index);
        //   _this3.carousel_is_animating = true;
        // });
        
        // // detect mousewheel event within carousel element
        // this.$carousel.onwheel = function(e) {
        //   _this3._flickity_handle_wheel_event(e, _this3.carousel, _this3.carousel_is_animating);
        // }

        

        this.carousel.on("settle", this._carouselOnSettle.bind(this));        
        this.carousel.on("select", this._carouselOnSelect.bind(this));        
        // detect mousewheel event within carousel element
        // this.$carousel.onwheel = this._carouselOnWheel.bind(this);
        this.$carousel.addEventListener('wheel',this._carouselOnWheel.bind(this));

      }
    }, {
      key: "_reloadSlider",
      value: function _reloadSlider(currentBreakpoint) {
        var _this3 = this;


        // this.carousel.destroy();
        if (this.carousel) {

          // can't do this because the handler was added with bind
          // this.carousel.off("settle", this.carouselOnSettle);        
          // this.carousel.off("select", this.carouselOnSelect);        
          // this.$carousel.addEventListener('wheel',this.carouselOnWheel);

          this.carousel.destroy();
        }

        // console.log('DEBUG: carousel after destroy', this.carousel);
        if (currentBreakpoint === 'phone' || currentBreakpoint === 'tablet') {
          console.log('DEBUG: breakpoint - mobile 💲');
          // this.flickityOptions.prevNextButtons = false;
          this.flickityOptions.cellSelector = '.FeaturedSlider__CarouselCell--product';
          // move content outside slider
          this.contentWrapper.appendChild(this.content);
        } else {
          console.log('DEBUG: breakpoint - desktop 💲');
          // this.flickityOptions.prevNextButtons = true;
          this.flickityOptions.cellSelector = '.FeaturedSlider__CarouselCell';
          // move content inside slider
          this.carouselCellContent.appendChild(this.content);
        }
        this._setupSlider();
      }
    },{
      key: "_breakpointChanged",
      value: function _breakpointChanged(event) {
        console.log('DEBUG: breakpoint changed', event);

        var _this4 = this;

        var currentBreakpoint = event ? event.detail.currentBreakpoint : Responsive.getCurrentBreakpoint(),
            previousBreakpoint = event ? event.detail.previousBreakpoint : null;

        if (currentBreakpoint === previousBreakpoint) {
          return; // Nothing has changed, no specific setup to do
        }
        

        this._reloadSlider(currentBreakpoint);

      }
    }, {
      key: "_setHeight",
      value: function _setHeight(el, val) {
        // TODO: consider move this to general utility if also used in other components
        if (typeof val === "function") val = val();
        if (typeof val === "string") el.style.height = val;
        else el.style.height = val + "px";
      }
    }, {
      key: "_equalizeHeight",
      value: function _equalizeHeight(container) {
        // TODO: consider move this to general utility if also used in other components
        var currentTallest = 0,
            currentRowStart = 0,
            rowDivs = new Array(),
            $el,
            topPosition = 0;

        Array.from(document.querySelectorAll(container)).forEach((el,i) => {
          el.style.height = "auto";
          var topPostion = el.offsetTop;
          var currentDiv;
          if(currentRowStart != topPostion){
            for (currentDiv = 0 ; currentDiv < rowDivs.length ; currentDiv++) {
              this._setHeight(rowDivs[currentDiv], currentTallest)
            }
            rowDivs.length = 0;
            currentRowStart = topPostion;
            currentTallest = parseFloat(getComputedStyle(el, null).height.replace("px", ""))
            rowDivs.push(el);
          } else {
            rowDivs.push(el);
            currentTallest = (currentTallest < parseFloat(getComputedStyle(el, null).height.replace("px", ""))) ? (parseFloat(getComputedStyle(el, null).height.replace("px", ""))) : (currentTallest);
          }
          for (currentDiv = 0 ; currentDiv < rowDivs.length ; currentDiv++) {
            this._setHeight(rowDivs[currentDiv], currentTallest)
          }
        });
      }
    }]);

    return FeaturedSliderSection;
  }();

  var FeaturedResultsSliderSection = /*#__PURE__*/function () {
    function FeaturedResultsSliderSection(container) {
      var _this = this;
  
      _classCallCheck(this, FeaturedResultsSliderSection);
  
      this.element = container;
      this.delegateElement = new domDelegate.Delegate(this.element);
      this.options = JSON.parse(this.element.getAttribute('data-settings'));
      this.carousels = [];
  
      this.flickityOptions = {
        // options
        "freeScroll": true, 
        "cellAlign": "left", 
        "contain": true,
        // prevNextButtons: false,
        pageDots: false
      };
  
      this.contentWrapper = this.element.querySelector('.FeaturedResultsSlider__ContentWrapper');
      this.content = this.element.querySelector('.FeaturedResultsSlider__Content');
      this.carouselCellContent = this.element.querySelector('.FeaturedResultsSlider__CarouselCell--content');
  
  
      Dom.nodeListToArray(this.element.querySelectorAll('[data-flickity-config]')).forEach(function (item) {
        _this.carousels.push(new Carousel(item));
      });
  
      this._attachListeners();
  
      var currentBreakpoint = Responsive.getCurrentBreakpoint();
      if (this.contentWrapper && this.content && this.carouselCellContent) {
        console.log('DEBUG: this.currentBreakpoint 💲', currentBreakpoint);
        this._reloadSlider(currentBreakpoint);  
      }
  
      // equal height
      this._equalizeHeight('.FeaturedResultsSlider__CarouselCell--result .FeaturedResultsSlider__ResultItemInfo');
      window.addEventListener("resize", function(){
        setTimeout(function(){
          _this._equalizeHeight('.FeaturedResultsSlider__CarouselCell--result .FeaturedResultsSlider__ResultItemInfo');
        })
      })      
    }
  
    _createClass(FeaturedResultsSliderSection, [{
      key: "onUnload",
      value: function onUnload() {
        this.carousels.forEach(function (item) {
          return item.destroy();
        });
        this.intersectionObserver.disconnect();
        this.timeline.kill();
        document.removeEventListener('breakpoint:changed', this._onBreakpointChangedListener);
  
        if (this.carousel) {
          this.carousel.destroy();
        }
      }
    }, {
      key: "onBlockSelect",
      value: function onBlockSelect(event) {
        // We simply trigger a click on the element that controls this tab
        this.element.querySelector("[aria-controls=\"".concat(event.target.id, "\"]")).click();
      }
    }, {
      key: "_attachListeners",
      value: function _attachListeners() {
        this._onBreakpointChangedListener = this._breakpointChanged.bind(this);
        document.addEventListener('breakpoint:changed', this._onBreakpointChangedListener);
      }
    }, {
      key: "_flickity_handle_wheel_event",
      value: function _flickity_handle_wheel_event(e, flickity_instance, flickity_is_animating) {
  
          // do not trigger a slide change if another is being animated
          if (!flickity_is_animating) {    
            // pick the larger of the two delta magnitudes (x or y) to determine nav direction
            // var direction = e.deltaX; //(Math.abs(e.deltaX) > Math.abs(e.deltaY)) ? e.deltaX : e.deltaY;
            
            // console.log("wheel scroll ", e.deltaX, e.deltaY, direction);
            
            if (/*direction*/ e.deltaX && e.deltaX > 10) {
              // next slide
              flickity_instance.next();
            } else if (e.deltaX && e.deltaX < -10) {
              // prev slide
              flickity_instance.previous();
            }
          }
      }
    }, {
      key: "_carouselOnSettle",
      value: function _carouselOnSettle(index) {
        this.carousel_is_animating = false;
      }
    }, {
      key: "_carouselOnSelect",
      value: function _carouselOnSelect(index) {
        this.carousel_is_animating = true;
      }
    }, {
      key: "_carouselOnWheel",
      value: function _carouselOnWheel(e) {
        this._flickity_handle_wheel_event(e, this.carousel, this.carousel_is_animating);
      }
    }, {
      key: "_setupSlider",
      value: function _setupSlider() {
        var _this3 = this;
  
        this.carousel = new Flickity(this.element.querySelector('.FeaturedResultsSlider__Carousel') , this.flickityOptions);
  
        this.$carousel = this.element.querySelector('.FeaturedResultsSlider__Carousel');
        this.carousel_is_animating = false;
        
  
        
  
        this.carousel.on("settle", this._carouselOnSettle.bind(this));        
        this.carousel.on("select", this._carouselOnSelect.bind(this));        
        // detect mousewheel event within carousel element
        // this.$carousel.onwheel = this._carouselOnWheel.bind(this);
        this.$carousel.addEventListener('wheel',this._carouselOnWheel.bind(this));
  
      }
    }, {
      key: "_reloadSlider",
      value: function _reloadSlider(currentBreakpoint) {
        var _this3 = this;
  
  
        // this.carousel.destroy();
        if (this.carousel) {
  
          // can't do this because the handler was added with bind
          // this.carousel.off("settle", this.carouselOnSettle);        
          // this.carousel.off("select", this.carouselOnSelect);        
          // this.$carousel.addEventListener('wheel',this.carouselOnWheel);
  
          this.carousel.destroy();
        }
  
        // console.log('DEBUG: carousel after destroy', this.carousel);
        if (currentBreakpoint === 'phone' || currentBreakpoint === 'tablet') {
          console.log('DEBUG: breakpoint - mobile 💲');
          // this.flickityOptions.prevNextButtons = false;
          this.flickityOptions.cellSelector = '.FeaturedResultsSlider__CarouselCell--result';
          // move content outside slider
          this.contentWrapper.appendChild(this.content);
        } else {
          console.log('DEBUG: breakpoint - desktop 💲');
          // this.flickityOptions.prevNextButtons = true;
          this.flickityOptions.cellSelector = '.FeaturedResultsSlider__CarouselCell';
          // move content inside slider
          this.carouselCellContent.appendChild(this.content);
        }
        this._setupSlider();
      }
    },{
      key: "_breakpointChanged",
      value: function _breakpointChanged(event) {
        console.log('DEBUG: breakpoint changed', event);
  
        var _this4 = this;
  
        var currentBreakpoint = event ? event.detail.currentBreakpoint : Responsive.getCurrentBreakpoint(),
            previousBreakpoint = event ? event.detail.previousBreakpoint : null;
  
        if (currentBreakpoint === previousBreakpoint) {
          return; // Nothing has changed, no specific setup to do
        }
        
  
        this._reloadSlider(currentBreakpoint);
  
      }
    }, {
      key: "_setHeight",
      value: function _setHeight(el, val) {
        // TODO: consider move this to general utility if also used in other components
        if (typeof val === "function") val = val();
        if (typeof val === "string") el.style.height = val;
        else el.style.height = val + "px";
      }
    }, {
      key: "_equalizeHeight",
      value: function _equalizeHeight(container) {
        // TODO: consider move this to general utility if also used in other components
        var currentTallest = 0,
            currentRowStart = 0,
            rowDivs = new Array(),
            $el,
            topPosition = 0;
  
        Array.from(document.querySelectorAll(container)).forEach((el,i) => {
          el.style.height = "auto";
          var topPostion = el.offsetTop;
          var currentDiv;
          if(currentRowStart != topPostion){
            for (currentDiv = 0 ; currentDiv < rowDivs.length ; currentDiv++) {
              this._setHeight(rowDivs[currentDiv], currentTallest)
            }
            rowDivs.length = 0;
            currentRowStart = topPostion;
            currentTallest = parseFloat(getComputedStyle(el, null).height.replace("px", ""))
            rowDivs.push(el);
          } else {
            rowDivs.push(el);
            currentTallest = (currentTallest < parseFloat(getComputedStyle(el, null).height.replace("px", ""))) ? (parseFloat(getComputedStyle(el, null).height.replace("px", ""))) : (currentTallest);
          }
          for (currentDiv = 0 ; currentDiv < rowDivs.length ; currentDiv++) {
            this._setHeight(rowDivs[currentDiv], currentTallest)
          }
        });
      }
    }]);
  
    return FeaturedResultsSliderSection;
  }();
    

  var SkinQuizSection = /*#__PURE__*/function () {
    function SkinQuizSection(container) {
      _classCallCheck(this, SkinQuizSection);

      this.element = container;
      this.delegateElement = new domDelegate.Delegate(this.element);
      this.sectionId = this.element.getAttribute('id');

      this._run();
    }

    _createClass(SkinQuizSection, [{
      key: "_run",
      value: function _run() {
        // form script using defer, run quiz form once it loaded
        var formScript = document.getElementById('cd-form-script');
        formScript.addEventListener('load', function () {
          window.cdApp.quizForm();
        });    
      }
    }]);

    return SkinQuizSection;
  }();

  var PartnerSkinQuizSection = /*#__PURE__*/function () {
    function PartnerSkinQuizSection(container) {
      _classCallCheck(this, PartnerSkinQuizSection);

      this.element = container;
      this.delegateElement = new domDelegate.Delegate(this.element);
      this.sectionId = this.element.getAttribute('id');

      this._run();
    }

    _createClass(PartnerSkinQuizSection, [{
      key: "_run",
      value: function _run() {
        // form script using defer, run quiz form once it loaded
        var formScript = document.getElementById('cd-form-script');
        formScript.addEventListener('load', function () {
          window.cdApp.partnerQuizForm();
        });    
      }
    }]);

    return PartnerSkinQuizSection;
  }();
  
  // ClueEdit
  var CTAListSection = /*#__PURE__*/function () {
    function CTAListSection(container) {
      _classCallCheck(this, CTAListSection);

      this.element = container;
      
      this.delegateElement = new domDelegate.Delegate(this.element);
      this.options = JSON.parse(this.element.getAttribute('data-settings'));

      this.flickityOptions = {
        // options
        "freeScroll": false, 
        "cellAlign": "center", 
        // "cellAlign": "left",
        "contain": true,
        "groupCells": true,
        // prevNextButtons: false,
        pageDots: false
        // "resize": false
      };

      // this._attachListeners();
      // console.log('DEBUG: CTA List slider section');

      this._setupSlider();
    }

    _createClass(CTAListSection, [{
      key: "onUnload",
      value: function onUnload() {
        // this.carousel.destroy();
        this.intersectionObserver.disconnect();
        this.timeline.kill();

        if (this.carousel) {
          this.carousel.destroy();
        }

      }
    }, {
      key: "_setupSlider",
      value: function _setupSlider() {
        var _this3 = this;

        this.carousel = new Flickity(this.element.querySelector('.CTAList__Blocks') , this.flickityOptions);
        this.$carousel = this.element.querySelector('.CTAList__Blocks');
      }
    }]);

    return CTAListSection;
  }();

  var CTAListSliderSection = /*#__PURE__*/function () {
    function CTAListSliderSection(container) {
      var _this = this;

      _classCallCheck(this, CTAListSliderSection);

      this.element = container;
      this.delegateElement = new domDelegate.Delegate(this.element);
      this.options = JSON.parse(this.element.getAttribute('data-settings'));
      this.carousels = [];

      this.flickityOptions = {
        // options
        "freeScroll": true, 
        "cellAlign": "left", 
        "contain": true,
        // prevNextButtons: false,
        pageDots: false
      };

      this.contentWrapper = this.element.querySelector('.CTAListSlider__ContentWrapper');
      this.content = this.element.querySelector('.CTAListSlider__Content');
      this.carouselCellContent = this.element.querySelector('.CTAListSlider__CarouselCell--content');


      Dom.nodeListToArray(this.element.querySelectorAll('[data-flickity-config]')).forEach(function (item) {
        _this.carousels.push(new Carousel(item));
      });

      // this._setupAnimation();

      this._attachListeners();
      console.log('DEBUG: featured slider section');

      // this._setupSlider();

      var currentBreakpoint = Responsive.getCurrentBreakpoint();
      if (this.contentWrapper && this.content && this.carouselCellContent) {
        console.log('DEBUG: this.currentBreakpoint 💲', currentBreakpoint);
        this._reloadSlider(currentBreakpoint);  
      }

      // equal height
      setTimeout(function(){
        // _this._equalizeHeight('.CTAListSlider__CarouselCell--product .CTAListSlider__BlockProductTitle');
        // trigger window resize
        window.dispatchEvent(new Event('resize'));
      },300);

      window.addEventListener("resize", function(){
        setTimeout(function(){
          _this._equalizeHeight('.CTAListSlider__CarouselCell--product .CTAListSlider__BlockProductTitle');
        })
      })      
    }

    _createClass(CTAListSliderSection, [{
      key: "onUnload",
      value: function onUnload() {
        this.carousels.forEach(function (item) {
          return item.destroy();
        });
        this.intersectionObserver.disconnect();
        this.timeline.kill();
        document.removeEventListener('breakpoint:changed', this._onBreakpointChangedListener);

        if (this.carousel) {
          this.carousel.destroy();
        }
      }
    }, {
      key: "onBlockSelect",
      value: function onBlockSelect(event) {
        // We simply trigger a click on the element that controls this tab
        this.element.querySelector("[aria-controls=\"".concat(event.target.id, "\"]")).click();
      }
    },{
      key: "_attachListeners",
      value: function _attachListeners() {

        this._onBreakpointChangedListener = this._breakpointChanged.bind(this);
        document.addEventListener('breakpoint:changed', this._onBreakpointChangedListener);
      }
    }, {
      key: "_flickity_handle_wheel_event",
      value: function _flickity_handle_wheel_event(e, flickity_instance, flickity_is_animating) {

          // do not trigger a slide change if another is being animated
          if (!flickity_is_animating) {    
            // pick the larger of the two delta magnitudes (x or y) to determine nav direction
            // var direction = e.deltaX; //(Math.abs(e.deltaX) > Math.abs(e.deltaY)) ? e.deltaX : e.deltaY;
            
            // console.log("wheel scroll ", e.deltaX, e.deltaY, direction);
            
            if (/*direction*/ e.deltaX && e.deltaX > 10) {
              // next slide
              flickity_instance.next();
            } else if (e.deltaX && e.deltaX < -10) {
              // prev slide
              flickity_instance.previous();
            }
          }
      }
    }, {
      key: "_carouselOnSettle",
      value: function _carouselOnSettle(index) {
        this.carousel_is_animating = false;
      }
    }, {
      key: "_carouselOnSelect",
      value: function _carouselOnSelect(index) {
        this.carousel_is_animating = true;
      }
    }, {
      key: "_carouselOnWheel",
      value: function _carouselOnWheel(e) {
        this._flickity_handle_wheel_event(e, this.carousel, this.carousel_is_animating);
      }
    }, {
      key: "_setupSlider",
      value: function _setupSlider() {
        var _this3 = this;

        this.carousel = new Flickity(this.element.querySelector('.CTAListSlider__Carousel') , this.flickityOptions);

        this.$carousel = this.element.querySelector('.CTAListSlider__Carousel');
        this.carousel_is_animating = false;

        this.carousel.on("settle", this._carouselOnSettle.bind(this));        
        this.carousel.on("select", this._carouselOnSelect.bind(this));        
        // detect mousewheel event within carousel element
        // this.$carousel.onwheel = this._carouselOnWheel.bind(this);
        this.$carousel.addEventListener('wheel',this._carouselOnWheel.bind(this));

      }
    }, {
      key: "_reloadSlider",
      value: function _reloadSlider(currentBreakpoint) {
        var _this3 = this;


        // this.carousel.destroy();
        if (this.carousel) {

          // can't do this because the handler was added with bind
          // this.carousel.off("settle", this.carouselOnSettle);        
          // this.carousel.off("select", this.carouselOnSelect);        
          // this.$carousel.addEventListener('wheel',this.carouselOnWheel);

          this.carousel.destroy();
        }

        // console.log('DEBUG: carousel after destroy', this.carousel);
        if (currentBreakpoint === 'phone' || currentBreakpoint === 'tablet') {
          console.log('DEBUG: breakpoint - mobile 💲');
          // this.flickityOptions.prevNextButtons = false;
          this.flickityOptions.cellSelector = '.CTAListSlider__CarouselCell--product';
          // move content outside slider
          this.contentWrapper.appendChild(this.content);
        } else {
          console.log('DEBUG: breakpoint - desktop 💲');
          // this.flickityOptions.prevNextButtons = true;
          this.flickityOptions.cellSelector = '.CTAListSlider__CarouselCell';
          // move content inside slider
          this.carouselCellContent.appendChild(this.content);
        }
        this._setupSlider();
      }
    },{
      key: "_breakpointChanged",
      value: function _breakpointChanged(event) {
        console.log('DEBUG: breakpoint changed', event);

        var _this4 = this;

        var currentBreakpoint = event ? event.detail.currentBreakpoint : Responsive.getCurrentBreakpoint(),
            previousBreakpoint = event ? event.detail.previousBreakpoint : null;

        if (currentBreakpoint === previousBreakpoint) {
          return; // Nothing has changed, no specific setup to do
        }
        

        this._reloadSlider(currentBreakpoint);

      }
    }, {
      key: "_setHeight",
      value: function _setHeight(el, val) {
        // TODO: consider move this to general utility if also used in other components
        if (typeof val === "function") val = val();
        if (typeof val === "string") el.style.height = val;
        else el.style.height = val + "px";
      }
    }, {
      key: "_equalizeHeight",
      value: function _equalizeHeight(container) {
        // TODO: consider move this to general utility if also used in other components
        var currentTallest = 0,
            currentRowStart = 0,
            rowDivs = new Array(),
            $el,
            topPosition = 0;

        Array.from(document.querySelectorAll(container)).forEach((el,i) => {
          el.style.height = "auto";
          var topPostion = el.offsetTop;
          var currentDiv;
          if(currentRowStart != topPostion){
            for (currentDiv = 0 ; currentDiv < rowDivs.length ; currentDiv++) {
              this._setHeight(rowDivs[currentDiv], currentTallest)
            }
            rowDivs.length = 0;
            currentRowStart = topPostion;
            currentTallest = parseFloat(getComputedStyle(el, null).height.replace("px", ""))
            rowDivs.push(el);
          } else {
            rowDivs.push(el);
            currentTallest = (currentTallest < parseFloat(getComputedStyle(el, null).height.replace("px", ""))) ? (parseFloat(getComputedStyle(el, null).height.replace("px", ""))) : (currentTallest);
          }
          for (currentDiv = 0 ; currentDiv < rowDivs.length ; currentDiv++) {
            this._setHeight(rowDivs[currentDiv], currentTallest)
          }
        });
      }
    }]);

    return CTAListSliderSection;
  }();


  // ClueEdit Legal Changes
  var CustomersOrderSection = /*#__PURE__*/function () {
    function CustomersOrderSection(container) {
      _classCallCheck(this, CustomersOrderSection);

      this.element = container;
      
      this.delegateElement = new domDelegate.Delegate(this.element);

      console.log('DEBUG: customers order section');
      this.delegateElement.on('click', '.Button--reorder', this._reorder.bind(this));

    }

    _createClass(CustomersOrderSection, [{
      key: "onUnload",
      value: function onUnload() {

      }
    }, {
      key: "_reorder",
      value: function _reorder(ev) {
        var _this3 = this;
        let customersOrderData = window.cdApp.customersOrderData;

        if (!customersOrderData) {
          alert('Unable to add items in cart');
          return;
        }

        console.log('DEBUG: reorder');

        let orders = [];

        // properties need convert. ajax cart/add.js expect properties as object, while orderLineItem is array
        // like this
        /*
            "properties": [
            [
              "Day Elixir",
              "Day Brightening Elixir"
            ],
            [
              "Treatment",
              "Cellular Repair Night Eye Cream"
            ],
            [
              "Base Range",
              "Face Oil,Face Serum,Solar Serum SPF50,The Base Cream"
            ],
            [
              "Cleanser",
              "Oil Cleanser"
            ]
          ],


          need convert to
          "properties": {
              "Day Elixir" : "Day Brightening Elixir",
              "Treatment" : "Cellular Repair Night Eye Cream",
              "Base Range" : "Face Oil,Face Serum,Solar Serum SPF50,The Base Cream",
              "Cleanser" : "Oil Cleanser"
          }
    
        */

        function transformPropertiesArrayToObject(array) {
            return array.reduce(function(obj, item) {
                obj[item[0]] = item[1];
                return obj;
            }, {});
        }        
                  

        
        customersOrderData.forEach(function (orderLineItem) {
          orders.push({
            //id: orderLineItem.id,
            id: orderLineItem.variant_id,
            quantity: orderLineItem.quantity,
            properties: transformPropertiesArrayToObject(orderLineItem.properties),
            handle: orderLineItem.product.handle
          });
        });

        console.log('DEBUG: orders', orders);

        document.dispatchEvent(new CustomEvent('theme:loading:start'));

        // clear the cart
        fetch('/cart/clear.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
          }
        }).then(function(response) {
          return fetch('/cart/add.js', {
            body: JSON.stringify({
              items: orders
            }),
            credentials: 'same-origin',
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
    
            }     
          });       
        }).then(function (response) {
          document.dispatchEvent(new CustomEvent('theme:loading:end'));

          if (response.ok) {
            console.log('DEBUG: cart added');
            // location.reload();         
            window.location.href = '/cart'; 
              
          } else {
            alert('Unable to reorder. One or more products in this order might no longer be available.');
            // response.json().then(function (content) {
            //   var reorderButton = document.querySelector('.Button--reorder');
            //   var errorMessageElement = document.createElement('span');
            //   errorMessageElement.className = 'ProductForm__Error Alert Alert--error';
            //   errorMessageElement.innerHTML = 'Unable to reorder: '+content['description'];
            //   // target.removeAttribute('disabled');
            //   reorderButton.insertAdjacentElement('afterend', errorMessageElement);
            //   setTimeout(function () {
            //     errorMessageElement.remove();
            //   }, 2500);

            //   // alert(content['description']);
            // });            
          }
          
        }).catch(function(error) {
          // Handle errors here
          document.dispatchEvent(new CustomEvent('theme:loading:end'));
          alert('Unable to reorder');
        });        
    
      
        ev.preventDefault();
      }
    }]);

    return CustomersOrderSection;
  }();

  var CountdownBarSection = /*#__PURE__*/function () {
    function CountdownBarSection(container) {
      _classCallCheck(this, CountdownBarSection);

      this.element = container;
      this.enable = this.element.getAttribute('data-active');
      this.enable = this.enable === 'true';
      this.disableCountdown = this.element.getAttribute('data-disable-countdown');
      this.disableCountdown = this.disableCountdown === 'true';

      this.date = this.element.getAttribute('data-date');
      this.parentElement = this.element.parentElement;

      let countdownDate = new Date(this.date).getTime();
      let todayDate = new Date().getTime();
      let distance = countdownDate - todayDate;
      this.expired = false;
      if (distance < 0) {
        this.expired = true;
      }
      
      this.delegateElement = new domDelegate.Delegate(this.element);

      console.log('DEBUG: countdown bar section', this.element);

      if (this.enable && !this.expired && !this.disableCountdown) {
        this._run();
      }
    }

    _createClass(CountdownBarSection, [{
      key: "onUnload",
      value: function onUnload() {

      }
    }, {
      key: "_run",
      value: function _run(ev) {
        var _this3 = this;

        let countdownBarCounter = _this3.element.querySelector('.CountdownBarCounter');
        let countdownBarDescription = _this3.element.querySelector('.CountdownBarDescription');

        // console.log('DEBUG: ', _this3.enable, _this3.date);

        document.body.classList.add('with-countdown-bar');

        let day = countdownBarCounter.querySelector('.days');
        let hour = countdownBarCounter.querySelector('.hours');
        let minute = countdownBarCounter.querySelector('.minutes');
        let second = countdownBarCounter.querySelector('.seconds');
      
        function setCountdownBar() {

          // Set countdown date
          let countdownDate = new Date(_this3.date).getTime();

          // Update countdown every second
          let updateCount = setInterval(function(){

              // Get today's date and time
              let todayDate = new Date().getTime();

              // Get distance between now and countdown date
              let distance = countdownDate - todayDate;

              let days = Math.floor(distance / (1000 * 60 * 60 *24));

              let hours = Math.floor(distance % (1000 * 60 * 60 *24) / (1000 * 60 *60));

              let minutes = Math.floor(distance % (1000 * 60 * 60 ) / (1000 * 60));

              let seconds = Math.floor(distance % (1000 * 60) / 1000);


              // if countdown expires
              if(distance < 0){
                  clearInterval(updateCount);
                  // _this3.element.style.setProperty('display', 'none', 'important');
                  // _this3.parentElement.style.display = 'none';
                } else {
                // Display values in html elements
                day.textContent = days;
                hour.textContent = hours;
                minute.textContent = minutes;
                second.textContent = seconds;

                // _this3.element.style.setProperty('display', 'block', 'important');
                // _this3.parentElement.style.display = 'block';
            }


          }, 1000)
        }

        setCountdownBar();        

      }
    }]);

    return CountdownBarSection;
  }();


  // box builder page
  var boxBuilderPage = function () {
    var $el = document.getElementById('bxp-bldr-main');
    if (!$el) {
      return false;
    }

    console.log('DEBUG: this is box builder page');

    // listen to even recommendations
    document.addEventListener('theme:form:recommendations', function(event) {
      var status = event.detail.status; 
      var products = event.detail.products; 

      console.log('DEBUG:🎉🎉🎉  recommendations received', status, products);

      // box builder uses jquery, so jquery is available here
      var $ = jQuery;

      var $items = $('.bxp-bldr-item');
      // console.log('DEBUG: $items', $items);

      // get all products json
      // UPDATE 20220921, we fetch all product including hidden. because we need to get 30g products as well as recommendations (which are hidden). for boxbuilder purpose, its fine to refer to all products because we only use the list to match it with products that displayed in boxbuilder (regardless its visible or hidden).
      $.ajax({
        // url: '/collections/all-products-json/?view=allproductsjson'
        url: '/collections/all/?view=allproductsjson'
      }).done(function(data){
        var parsed;
        var $data;
        var recommendedVariants = [];  // array of variant id that recommended
        if(data) {

          // in OS 2.0, section always wrapped by tag, so its not pure json code, we have to unwrap first
          $data = $(data);
          // console.log('DEBUG: $data', $data);

          data = $data.text();

          // console.log('DEBUG: data', data);

          try {
              parsed = JSON.parse(data);
              // filterMatchData(bottomMatchData, size);
              // console.log('DEBUG: parsed', parsed);

              // filter only recommended variants
              parsed.products.forEach(function(product) {
                // 30g products
                var handleCheck = product.handle;
                if (product.handle.substring(product.handle.length-4) === '-30g') {
                  handleCheck = product.handle.substring(0, product.handle.length - 4);
                }

                if (products.indexOf(handleCheck) > -1) {
                  // push all variants id to recommendedVariants
                  // console.log('DEBUG: product', product.id, 'recommended');

                  if (product.variants && product.variants.length) {
                    product.variants.forEach(function(variant) {

                      // console.log('DEBUG: variant', variant, 'recommended');
                        recommendedVariants.push(variant.id);
                    });
                  }
                }
              });

              console.log('DEBUG: recommended variants', recommendedVariants);


          } catch(e) {
              console.log('ERROR: Invalid data');
          }

          if (recommendedVariants.length) {
              // add recommendations badge
              $items.each(function(i, item) {
                var $item = $(item);
                var id = $item.find('> input[product-id]').attr('product-id');
                // console.log('DEBUG: item', $item, ', id =', id);

                if (recommendedVariants.indexOf(parseInt(id)) > -1) {
                  // console.log('DEBUG: $item recommended', $item);
                  // $item.css('border','solid 5px fuchsia');
                  $item.parent().addClass('bxp-bldr-col-recommended');
                }

              });

          }
        }          
      
      });

    });

  };

  var kingOptions = function() {
    var $el = document.querySelector('body.template-product');
    if (!$el) {
      return false;
    }

    // console.log('DEBUG: king options');
    // setTimeout(function() {
    //   var $ymq = document.getElementById('ymq-box');
    //   if ($ymq) {
    //     console.log('DEBUG: ymq', $ymq);
    //     // reorder ymq to be placed before .ProductForm__BuyButtons
    //     let $buyButtons = document.querySelector('.ProductForm__BuyButtons');
        
    //     if ($ymq && $buyButtons) {
    //       $buyButtons.parentNode.insertBefore($ymq, $buyButtons);
    //     }        

    //   } else {
    //     return false;
    //   }
    // }, 300);

    console.log('DEBUG: king options');
    var $ymqParent = document.querySelector('.ProductForm');
    var observerYmq = new MutationObserver(function(mutations) {
      var $ymq = document.getElementById('ymq-box');
      if ($ymq) {
        console.log('DEBUG: ymq', $ymq);
        // reorder ymq to be placed before .ProductForm__BuyButtons
        let $buyButtons = document.querySelector('.ProductForm__BuyButtons');
        
        if ($ymq && $buyButtons) {
          $buyButtons.parentNode.insertBefore($ymq, $buyButtons);
        }
    
        // Once we've found the element, we don't need to keep observing the DOM
        observerYmq.disconnect();
      }
    });
    
    // Start observing the document with the configured parameters
    observerYmq.observe($ymqParent, { childList: true, subtree: true });

    // listen to even recommendations
    document.addEventListener('theme:form:recommendations', function(event) {
      var status = event.detail.status; 
      var products = event.detail.products; 

      console.log('DEBUG:🎉🎉🎉 king options recommendations received', status, products);

      fetch('/collections/all/?view=allproductsjson')
      .then(response => response.text())
      .then(data => {
        let parsed;
        // let recommendedVariants = [];  // array of variant id that recommended
        let recommendedTitles = [];
        if(data) {
          // in OS 2.0, section always wrapped by tag, so its not pure json code, we have to unwrap first
          let parser = new DOMParser();
          let doc = parser.parseFromString(data, 'text/html');
          data = doc.body.textContent;
    
          try {
            parsed = JSON.parse(data);
    
            // filter only recommended variants
            parsed.products.forEach(function(product) {
              // 30g products
              let handleCheck = product.handle;
              if (product.handle.substring(product.handle.length-4) === '-30g') {
                handleCheck = product.handle.substring(0, product.handle.length - 4);
              }
    
              if (products.indexOf(handleCheck) > -1) {
                // // push all variants id to recommendedVariants
                // console.log('DEBUG: product', product);
                // if (product.variants && product.variants.length) {
                //   product.variants.forEach(function(variant) {
                //     recommendedVariants.push(variant.id);
                //   });
                // }
                // push title to recommended titles
                if (product.title) {
                  recommendedTitles.push(product.title);
                }
              }
            });
    
            // console.log('DEBUG: recommended variants', recommendedVariants);
            console.log('DEBUG: recommended titles', recommendedTitles);
    
          } catch(e) {
            console.log('ERROR: Invalid data');
          }
    
          if (recommendedTitles.length) {

            var $ymq = document.getElementById('ymq-box');
            let $lis = $ymq.querySelectorAll('.ymq-options-box .ymq-multiple-li');

            if ($ymq) {
            } else {
              return false;
            }
      
  
            // console.log('$lis', $lis);
        
            if ($lis.length) {
              for (let i = 0; i < $lis.length; i++) {
                  let $li = $lis[i];
                  let text = $li.textContent;
                  // console.log(text);
        
                  // if (text === 'Cellular Repair Night Eye Cream' || text === 'Solar Serum SPF50') {
                  //   $li.classList.add('recommended');
                  // }

                  if (recommendedTitles.indexOf(text) > -1) {
                    $li.classList.add('recommended');
                  }
              }
              
            }
      
            
          }
        }
      });      
      
    });


  };


  (function () {
    // First, we register all plugins that are used for all pages
    new Collapsible();
    new Modal();
    new Responsive();
    // new Tabs();

    if (window.theme.pageType !== 'password' && window.theme.pageType !== 'gift_card') {
      new LoadingBar();
    }

    var sections = new SectionContainer();
    sections.register('header', HeaderSection);
    sections.register('footer', FooterSection);
    sections.register('sidebar-menu', SidebarMenuSection);
    sections.register('cart', CartSection);
    sections.register('newsletter-popup', NewsletterPopupSection); // Sections used on index

    sections.register('slideshow', SlideshowSection);
    sections.register('collection-list', CollectionListSection);
    sections.register('article-list', ArticleList);
    sections.register('featured-product', FeaturedProductSection);
    sections.register('image-with-text-block', ImageWithTextBlockSection);
    sections.register('timeline', TimelineSection);
    sections.register('map', MapSection);
    sections.register('featured-slider', FeaturedSliderSection);
    sections.register('featured-results-slider', FeaturedResultsSliderSection);
    sections.register('featured-collections', FeaturedCollectionsSection);
    sections.register('shop-the-look', ShopTheLookSection);
    sections.register('testimonials', TestimonialsSection);
    sections.register('background-video', BackgroundVideoSection); // Sections used on product page

    sections.register('product', ProductSection);
    sections.register('product-recommendations', ProductRecommendationsSection); // Sections used on product page

    sections.register('product-real-results', ProductRealResultsSection); // Sections used on product page
    sections.register('concern-real-results', ConcernRealResultsSection);

    sections.register('collection', CollectionSection); // Sections used on blog page

    sections.register('article-list', ArticleList); // Sections used on article page

    sections.register('article', ArticleSection); // Sections used on content pages

    sections.register('faq', FaqSection); // Sections used on login page

    sections.register('login', LoginSection); // Sections used on addresses page

    sections.register('addresses', AddressesSection); // Sections used on gift card page

    sections.register('gift-card', GiftCardSection); // Sections used on search page

    sections.register('search', SearchSection); // Sections used on different pages

    sections.register('recently-viewed-products', RecentlyViewedProductsSection);
    sections.register('shop-now', ShopNowSection);

    // ClueEdit
    sections.register('info-popup', InfoPopupSection);
    sections.register('showcase', ShowcaseSection);
    sections.register('skin-quiz', SkinQuizSection); 
    sections.register('real-results', RealResults);
    sections.register('partner-skin-quiz', PartnerSkinQuizSection); 
    sections.register('cta-list', CTAListSection);
    sections.register('cta-list-slider', CTAListSliderSection);
    sections.register('customers-order', CustomersOrderSection);

    sections.register('product-pfm-formulations', PrescribeForMeFormulationSection); // Sections used on product page
    
    sections.register('countdown-bar', CountdownBarSection);

    // box builder
    boxBuilderPage();

    // king options
    kingOptions();


    // upsell
    var upsellActive = document.body.classList.contains('features--upsell-active');
    if (upsellActive) {
      (function(){
        console.log('DEBUG: upsell active 💲💲💲');
        // in main cart, when content replaced
        // we need to register info-popup section
        document.addEventListener('cart:main-cart-content-replace', function(){
          console.log('DEBUG: event cart:main-cart-content-replace run');
          sections.register('info-popup-upsell', InfoPopupSection);
          let upsellPopup = document.querySelector('.InfoPopup--Upsell');
          if (upsellPopup) {
            upsellPopup.classList.add('InfoPopup--show');
          }

        });

        window.cdApp = window.cdApp || {};

        cdApp.popupUpsellAdd = function(el) {
    
          var productVariant = el.getAttribute('data-variant-id');

          if (!productVariant) {
            return false;
          }

          document.dispatchEvent(new CustomEvent('theme:loading:start'));
    
          fetch('/cart/add.js', {
            body: JSON.stringify({
              items: [{
                id: productVariant,
                quantity: 1
              }]
            }),
            credentials: 'same-origin',
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
    
            }
          }).then(function (cart) {
            console.log('DEBUG: upsell added');
            // location.reload();
            document.dispatchEvent(new CustomEvent('theme:loading:end'));
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
              bubbles: true
            }));
           
          });
        }    

      }());
    }


    // FAQ tabs
    if (document.getElementById('faq-tabs')) {
      var faqTabs = new Tabs({
        elem: "faq-tabs",
        open: 0
      });          
    }    

    // free cheapest promotion
    var freeCheapestActive = document.body.classList.contains('features--freecheapest-active');
    let freeCheapestPopup = document.querySelector('.InfoPopup--FreeCheapest');
    if (freeCheapestActive && freeCheapestPopup) {
      (function(){
        console.log('DEBUG: freeCheapest active 💲💲💲');
        sections.register('info-popup-freecheapest', InfoPopupSection);

        // // console.log('DEBUG: freeCheapest test', freeCheapestPopup);
        // if (freeCheapestPopup) {
        //   setTimeout(function(){
        //     // console.log('DEBUG: freeCheapest show!!!');
        //     freeCheapestPopup.classList.add('InfoPopup--show');
        //   },6000);
        // }

        let productListString = freeCheapestPopup.getAttribute('data-product-list');
        let productList = JSON.parse(productListString.replace(/'/g, "\""));
                
        console.log('DEBUG: freecheapest product list', productList);

        document.addEventListener('product:added', function(event) {
          var variant = event.detail.variant; // Get the variant that was added
          var quantity = event.detail.quantity; // Get the quantity that was added

          var eligibleQuantity = 0;
          console.log('DEBUG: freecheapest, product added');
          fetch('/cart.js')
          .then(response => response.json())
          .then(cart => {
            console.log('DEBUG: freecheapest',cart);
            // we can't get tag from cart product items, so the easiest way we need to match the product with freecheapest collection
            // filter product in cart that handles match with productList
            let cartItemsPromo = cart.items.filter(function(item) {
              if (productList.indexOf(item.handle) > -1) {
                eligibleQuantity += item.quantity;
                return true;
              } else {
                return false;
              }
              // return productList.indexOf(item.handle) > -1;
            });

            console.log('DEBUG: freecheapest length', cartItemsPromo.length);
            console.log('DEBUG: freecheapest eligible quantity', eligibleQuantity);

            if (cartItemsPromo.length && eligibleQuantity == 3) {
              setTimeout(function() {
                freeCheapestPopup.classList.add('InfoPopup--show');
              },600);
            }

            console.log('DEBUG: freecheapest cartItemsPromo', cartItemsPromo);

            // get the cheapest price from cartItemsPromo
            let cheapestPrice = 0;
            cartItemsPromo.forEach(function(item) {
              if (cheapestPrice === 0 || item.price < cheapestPrice) {
                cheapestPrice = item.price;
              }
            });

            console.log('DEBUG: freecheapest cheapestPrice', cheapestPrice);

            // loop all div with class InfoPopup__FreeCheapestProduct, and check its price in attribute data-product-price
            // if the price is equal to cheapestPrice, add class InfoPopup__FreeCheapestProduct--free
            let popupProducts = document.querySelectorAll('.InfoPopup__FreeCheapestProduct');
            popupProducts.forEach(function(item) {
              let productPrice = item.getAttribute('data-product-price');
              // item.style.backgroundColor = '#ffffff';

              // ClueEdit: client wants all products displayed
              // item.classList.remove('InfoPopup__FreeCheapestProduct--hidden');
              if (parseInt(productPrice) > cheapestPrice) {
                // item.classList.add('InfoPopup__FreeCheapestProduct--hidden');
                // add css fuchsia background
                // item.style.backgroundColor = 'fuchsia';
              }
            });

          })
          .catch(error => console.error('Error:', error));          
        });

        // unused
        document.addEventListener('cart:item-quantity-updated', function() {

        });


        window.cdApp = window.cdApp || {};

        cdApp.popupFreeCheapestAdd = function(el) {
    
          var productVariant = el.getAttribute('data-variant-id');

          if (!productVariant) {
            return false;
          }

          document.dispatchEvent(new CustomEvent('theme:loading:start'));
    
          fetch('/cart/add.js', {
            body: JSON.stringify({
              items: [{
                id: productVariant,
                quantity: 1
              }]
            }),
            credentials: 'same-origin',
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
    
            }
          }).then(function (cart) {
            console.log('DEBUG: free cheapest added');
            // location.reload();
            document.dispatchEvent(new CustomEvent('theme:loading:end'));
            freeCheapestPopup.classList.remove('InfoPopup--show');

            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
              bubbles: true
            }));

          });
        }
      }());
    }

    // infopopup newsletter, show
    (function(){
      let infoPopupNewsletter = document.querySelector('.InfoPopup--newsletter');
      let showOnlyOnce = true;

      if (infoPopupNewsletter) {
        let show = false;

        if (!showOnlyOnce ||
          (showOnlyOnce && localStorage.getItem('infoPopupNewsletter') === null)
        ) {
          show = true;
        }

        if (window.location.search.indexOf('resetinfopopupnewsletter=true') > -1) {
          localStorage.removeItem('infoPopupNewsletter');
        }
        if (window.location.search.indexOf('showinfopopupnewsletter=true') > -1) {
          show = true;
        }

        if (show) {
          infoPopupNewsletter.classList.add('InfoPopup--show');
          localStorage.setItem('infoPopupNewsletter', 'true');  
        }

      }  
    }());

    /**
     * ----------------------------------------------------------------------------
     * FLICKITY
     *
     * Starting from iOS 11, Safari on iOS is experiencing a bug that prevents
     * event.preventDefault to be called on dynamically added listeners, which is
     * what Flickity is using.
     *
     * The bug is coming from iOS but it impacts indirectly Flickity. A temporary
     * fix has been suggested here: https://github.com/metafizzy/flickity/issues/740
     * and that we are using here as a temporary workaround, that should be removed
     * once the bug is fixed on iOS
     * ----------------------------------------------------------------------------
     */

    Flickity.defaults.dragThreshold = 7;

    (function () {
      var touchingCarousel = false,
          touchStartCoords;
      document.body.addEventListener('touchstart', function (e) {
        if (e.target.closest('.flickity-slider')) {
          touchingCarousel = true;
        } else {
          touchingCarousel = false;
          return;
        }

        touchStartCoords = {
          x: e.touches[0].pageX,
          y: e.touches[0].pageY
        };
      });
      document.body.addEventListener('touchmove', function (e) {
        if (!(touchingCarousel && e.cancelable)) {
          return;
        }

        var moveVector = {
          x: e.touches[0].pageX - touchStartCoords.x,
          y: e.touches[0].pageY - touchStartCoords.y
        };
        if (Math.abs(moveVector.x) > Flickity.defaults.dragThreshold) e.preventDefault();
      }, {
        passive: false
      });
    })();
    /**
     * ----------------------------------------------------------------------------
     * RTE
     * ----------------------------------------------------------------------------
     */


    (function () {
      // We wrap each RTE table by a specific class to allow wrapping
      Dom.nodeListToArray(document.querySelectorAll('.Rte table')).forEach(function (table) {
        table.outerHTML = '<div class="TableWrapper">' + table.outerHTML + '</div>';
      });
      Dom.nodeListToArray(document.querySelectorAll('.Rte iframe')).forEach(function (iframe) {
        // We scope the wrapping only for YouTube and Vimeo
        if (iframe.src.indexOf('youtube') !== -1 || iframe.src.indexOf('youtu.be') !== -1 || iframe.src.indexOf('vimeo') !== -1) {
          iframe.outerHTML = '<div class="VideoWrapper">' + iframe.outerHTML + '</div>'; // Re-set the src attribute on each iframe after page load for Chrome's "incorrect iFrame content on 'back'" bug.
          // https://code.google.com/p/chromium/issues/detail?id=395791. Need to specifically target video and admin bar

          iframe.src = iframe.src;
        }
      });
    })();
    /**
     * ----------------------------------------------------------------------------
     * UTILS
     * ----------------------------------------------------------------------------
     */


    (function () {
      var documentDelegate = new domDelegate.Delegate(document.body),
          announcementBar = document.querySelector('.AnnouncementBar');
      documentDelegate.on('click', '[href^="#"], [data-href]', function (event, target) {

        // prevent scrolling for link with noscroll class
        if (target && target.classList.contains('noscroll')) {
          return false;
        }


        var selector = target.hasAttribute('href') ? target.getAttribute('href') : target.getAttribute('data-href');

        if (selector === '#' || selector === '#main') {
          return;
        }

        var element = document.querySelector(selector),
            offset = parseInt(target.getAttribute('data-offset') || 0);

        if (announcementBar) {
          offset -= announcementBar.clientHeight;
        }

        if (target.hasAttribute('data-focus-on-click')) {
          var prevScrollY = window.pageYOffset;
          element.focus({
            preventScroll: true
          }); // hack to fix scroll jump after focus

          if (window.pageYOffset !== prevScrollY) {
            window.scrollTo(window.pageXOffset, prevScrollY);
          }

          element.focus();
        }

        window.scrollTo({
          behavior: 'smooth',
          top: element.offsetTop - offset
        });
        event.preventDefault();
      });
    })();

    (function () {
      var windowWidth = window.innerWidth,
          headerSection = document.getElementById('shopify-section-header');
      window.addEventListener('resize', function () {
        var newWidth = -1;
        fastdom.measure(function () {
          newWidth = window.innerWidth;
        });
        fastdom.mutate(function () {
          if (newWidth === windowWidth) {
            return;
          }

          windowWidth = newWidth;
          document.documentElement.style.setProperty('--window-height', window.innerHeight + 'px');

          if (headerSection) {
            document.documentElement.style.setProperty('--header-height', headerSection.clientHeight + 'px');
          }
        });
      });
    })();

    (function () {
      function handleFirstTab(event) {
        if (event.keyCode === 9) {
          document.body.classList.add('is-tabbing');
          window.removeEventListener('keydown', handleFirstTab);
        }
      }

      window.addEventListener('keydown', handleFirstTab);
    })();
    /**
     * ----------------------------------------------------------------------------
     * ANIMATION
     *
     * Important: this has to be at the very end of the file
     * ----------------------------------------------------------------------------
     */


    if (window.theme.showPageTransition) {
      PageTransition.getInstance();
    }


  


  })();

})));

/*
// test bloop
(function bloopTest() {
    if (window.location.href.search("[?&]bloopdemo=") != -1) {
        console.log('Bloop Demo');

        var css = '#bloop-referral-popup-container { display: block !important; }',
        head = document.head || document.getElementsByTagName('head')[0],
        style = document.createElement('style');

        head.appendChild(style);
        style.type = 'text/css';
        if (style.styleSheet){
          // This is required for IE8 and below.
          style.styleSheet.cssText = css;
        } else {
          style.appendChild(document.createTextNode(css));
        }        
    }
}());
*/